// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  color: #18201b;
  background: #f7f4ee;
  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  font-size: 16px;
}

* {
  box-sizing: border-box;
}

body {
  margin: 0;
}

.download-app-page { background: #fffaf8; color: #2d2022; min-height: 100vh; }
.download-app-nav { align-items: center; display: flex; justify-content: space-between; margin: 0 auto; max-width: 1180px; padding: 18px 24px; }
.download-app-nav a { align-items: center; color: #5f3840; display: flex; gap: 10px; text-decoration: none; }
.download-app-nav > a:last-child { font-weight: 700; }
.download-app-nav img, .download-app-footer img { height: 48px; object-fit: contain; width: 48px; }
.download-app-nav span, .download-app-nav small { display: block; }
.download-app-nav small { color: #8b6d72; font-size: 12px; }
.download-app-hero { align-items: center; display: grid; gap: 72px; grid-template-columns: minmax(0, 1fr) 350px; margin: 0 auto; max-width: 1080px; min-height: 620px; padding: 52px 24px 76px; }
.download-app-kicker { align-items: center; color: #9e3f55; display: flex; font-weight: 800; gap: 8px; }
.download-app-copy h1 { font-family: Georgia, "Times New Roman", serif; font-size: 64px; letter-spacing: 0; line-height: 1.04; margin: 18px 0 22px; }
.download-app-copy p { color: #70575c; font-size: 20px; line-height: 1.65; margin: 0 0 28px; max-width: 650px; }
.download-app-button { align-items: center; background: #a93d56; border-radius: 8px; box-shadow: 0 14px 32px rgba(143, 48, 71, .2); color: #fff; display: inline-flex; font-size: 18px; font-weight: 800; gap: 10px; justify-content: center; min-height: 58px; padding: 0 26px; text-decoration: none; transition: transform 180ms ease, box-shadow 180ms ease; }
.download-app-button:hover { box-shadow: 0 18px 38px rgba(143, 48, 71, .28); transform: translateY(-2px); }
.download-app-version { color: #8b6d72; display: block; font-size: 13px; margin-top: 14px; }
.download-phone-preview { background: linear-gradient(155deg, #fff 0%, #fff6f3 100%); border: 8px solid #34282a; border-radius: 38px; box-shadow: 0 30px 70px rgba(67, 37, 43, .2); min-height: 560px; padding: 42px 22px 24px; position: relative; }
.download-phone-top { align-items: center; display: flex; gap: 6px; left: 50%; position: absolute; top: 14px; transform: translateX(-50%); }
.download-phone-top span:first-child { background: #453638; border-radius: 999px; height: 6px; width: 54px; }
.download-phone-top span:last-child { background: #453638; border-radius: 50%; height: 7px; width: 7px; }
.download-phone-preview > img { display: block; height: 112px; margin: 22px auto 24px; object-fit: contain; width: 112px; }
.download-phone-preview > small, .download-phone-preview > strong { display: block; text-align: center; }
.download-phone-preview > small { color: #9e3f55; font-weight: 800; }
.download-phone-preview > strong { font-family: Georgia, "Times New Roman", serif; font-size: 27px; margin-top: 7px; }
.download-phone-actions { display: grid; gap: 9px; grid-template-columns: 1fr 1fr; margin-top: 34px; }
.download-phone-actions span { background: #f7e9e8; border: 1px solid #efd5d3; border-radius: 8px; color: #713c48; font-size: 13px; font-weight: 800; padding: 14px 8px; text-align: center; }
.download-phone-note { background: #a93d56; border-radius: 8px; color: #fff; font-size: 14px; line-height: 1.5; margin-top: 22px; padding: 18px; text-align: center; }
.download-install-band { background: #f7e9e8; padding: 64px 24px; }
.download-install-heading, .download-step-grid, .download-trust-row, .download-app-footer { margin-left: auto; margin-right: auto; max-width: 1080px; }
.download-install-heading span { color: #9e3f55; font-weight: 800; }
.download-install-heading h2 { font-family: Georgia, "Times New Roman", serif; font-size: 38px; margin: 8px 0 30px; }
.download-step-grid { display: grid; gap: 16px; grid-template-columns: repeat(3, minmax(0, 1fr)); list-style: none; padding: 0; }
.download-step-grid li { align-items: flex-start; background: #fffaf8; border: 1px solid #ead3d2; border-radius: 8px; display: flex; gap: 14px; min-height: 130px; padding: 22px; }
.download-step-grid b { align-items: center; background: #a93d56; border-radius: 50%; color: #fff; display: flex; flex: 0 0 34px; height: 34px; justify-content: center; }
.download-step-grid strong, .download-step-grid span { display: block; }
.download-step-grid span { color: #765d61; line-height: 1.45; margin-top: 7px; }
.download-trust-row { display: grid; gap: 16px; grid-template-columns: repeat(3, minmax(0, 1fr)); padding: 36px 24px; }
.download-trust-row span { align-items: center; color: #69464e; display: flex; font-weight: 700; gap: 9px; justify-content: center; }
.download-help-band { align-items: start; background: #fff; border-bottom: 1px solid #eadedb; border-top: 1px solid #eadedb; display: grid; gap: 54px; grid-template-columns: minmax(0, .8fr) minmax(0, 1.2fr); margin: 0 auto; max-width: 1080px; padding: 48px 24px; }
.download-help-copy > span { align-items: center; color: #9e3f55; display: flex; font-weight: 800; gap: 8px; }
.download-help-copy h2 { font-family: Georgia, "Times New Roman", serif; font-size: 34px; line-height: 1.15; margin: 12px 0 16px; }
.download-help-copy p { color: #70575c; line-height: 1.6; margin: 0 0 12px; }
.download-help-hindi { color: #5f3840 !important; font-size: 17px; }
.download-help-steps { display: grid; gap: 12px; }
.download-help-steps article { align-items: flex-start; background: #fff8f6; border: 1px solid #ead3d2; border-radius: 8px; display: flex; gap: 13px; padding: 17px; }
.download-help-steps article > svg { color: #a93d56; flex: 0 0 auto; margin-top: 2px; }
.download-help-steps strong, .download-help-steps span { display: block; }
.download-help-steps span { color: #765d61; line-height: 1.5; margin-top: 5px; }
.download-help-button { justify-self: start; min-height: 50px; }
.download-app-footer { align-items: center; border-top: 1px solid #eadedb; display: flex; gap: 18px; padding: 24px; }
.download-app-footer p { color: #745a5f; flex: 1; margin: 0; }
.download-app-footer a { color: #764553; text-decoration: none; }

@media (max-width: 760px) {
  .download-app-nav { padding: 14px 18px; }
  .download-app-nav > a:last-child { font-size: 13px; }
  .download-app-hero { gap: 44px; grid-template-columns: 1fr; padding: 42px 20px 58px; }
  .download-app-copy { text-align: center; }
  .download-app-kicker { justify-content: center; }
  .download-app-copy h1 { font-size: 44px; }
  .download-app-copy p { font-size: 17px; }
  .download-app-button { width: 100%; }
  .download-phone-preview { justify-self: center; max-width: 340px; width: 100%; }
  .download-step-grid, .download-trust-row { grid-template-columns: 1fr; }
  .download-help-band { gap: 28px; grid-template-columns: 1fr; padding: 38px 20px; }
  .download-help-copy h2 { font-size: 29px; }
  .download-help-button { justify-self: stretch; }
  .download-install-heading h2 { font-size: 32px; }
  .download-trust-row span { justify-content: flex-start; }
  .download-app-footer { align-items: flex-start; flex-wrap: wrap; }
}

img {
  max-width: 100%;
}

button,
input {
  font: inherit;
}

select {
  font: inherit;
}

.app-shell {
  display: grid;
  grid-template-columns: 260px minmax(0, 1fr);
  min-height: 100vh;
}

.mobile-menu-button,
.sidebar-backdrop,
.mobile-bottom-nav,
.mobile-quick-start {
  display: none;
}

.sidebar {
  background: #17211c;
  color: #f8f4eb;
  padding: 24px 18px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 34px;
}

.brand small,
.page-header span,
.metric-card span {
  color: #68756e;
  display: block;
}

.sidebar .brand small {
  color: #c5cdbf;
}

.brand-mark {
  align-items: center;
  background: #d7a84f;
  border-radius: 8px;
  color: #17211c;
  display: inline-flex;
  font-weight: 800;
  height: 40px;
  justify-content: center;
  width: 40px;
}

.nav-list {
  display: grid;
  gap: 18px;
}

.nav-section {
  display: grid;
  gap: 6px;
}

.nav-section-title {
  color: #9aa89f;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 0;
  padding: 0 12px 4px;
  text-transform: uppercase;
}

.nav-link {
  align-items: center;
  border-radius: 8px;
  color: #edf0e8;
  display: flex;
  gap: 10px;
  padding: 10px 12px;
  text-decoration: none;
}

.nav-link small {
  background: rgba(215, 168, 79, 0.14);
  border-radius: 999px;
  color: #d7a84f;
  font-size: 11px;
  margin-left: auto;
  padding: 3px 7px;
}

.nav-link.active,
.nav-link:hover {
  background: #26332b;
}

.nav-link-planned {
  color: #c5cdbf;
  cursor: default;
  opacity: 0.82;
}

.nav-link-planned:hover {
  background: transparent;
}

.api-status {
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  margin-top: 28px;
  padding: 10px;
}

.session-panel {
  border: 1px solid rgba(255, 255, 255, 0.16);
  border-radius: 8px;
  margin-top: 28px;
  padding: 10px;
}

.session-panel span,
.session-panel strong,
.session-panel small,
.session-panel a,
.session-panel button {
  display: flex;
}

.session-panel span {
  color: #f8f4eb;
}

.session-panel strong {
  color: #d7a84f;
  margin-top: 4px;
  text-transform: capitalize;
}

.session-panel small {
  color: #c5cdbf;
  margin-top: 4px;
}

.session-panel a,
.session-panel button {
  align-items: center;
  background: transparent;
  border: 0;
  color: #edf0e8;
  cursor: pointer;
  gap: 6px;
  margin-top: 10px;
  padding: 0;
  text-decoration: none;
}

.session-actions {
  display: grid;
  gap: 2px;
  margin-top: 10px;
}

.session-actions a,
.session-actions button {
  margin-top: 0;
}

.session-error {
  color: #ffb4a8 !important;
}

.api-status span,
.api-status small {
  display: block;
}

.api-status small {
  color: #c5cdbf;
  margin-top: 4px;
  overflow-wrap: anywhere;
}

.api-status.connected span {
  color: #9ee0ac;
}

.api-status.offline span {
  color: #ffb4a8;
}

.main-panel {
  padding: 36px;
}

.page-header {
  margin-bottom: 28px;
  max-width: 760px;
}

.page-header h1 {
  font-size: 40px;
  line-height: 1.1;
  margin: 8px 0;
}

.page-header p {
  color: #4e5b53;
  font-size: 18px;
  line-height: 1.55;
  margin: 0;
}

.metric-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-bottom: 24px;
}

.dashboard-grid {
  display: grid;
  gap: 18px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-bottom: 18px;
}

.age-band {
  margin-bottom: 18px;
}

.age-group-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin-top: 14px;
}

.age-group-card {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  padding: 12px;
}

.age-group-card span,
.age-group-card small {
  color: #4e5b53;
  display: block;
}

.age-group-card strong {
  display: block;
  font-size: 28px;
  margin: 8px 0 4px;
}

.rally-band {
  margin-bottom: 18px;
}

.rally-band .tree-register-header > span {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}

.rally-track-list {
  display: grid;
  gap: 16px;
  margin-top: 18px;
}

.rally-lane {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  padding: 14px;
}

.rally-lane-header {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
}

.rally-lane-header span {
  color: #4e5b53;
}

.rally-track {
  background: linear-gradient(90deg, #e7e1d5 0 49%, #d6cbb9 49% 51%, #e7e1d5 51% 100%);
  border-radius: 999px;
  height: 28px;
  margin-top: 12px;
  position: relative;
}

.rally-car {
  align-items: center;
  background: #d7a84f;
  border: 2px solid #ffffff;
  border-radius: 999px;
  box-shadow: 0 8px 18px rgba(35, 32, 26, 0.16);
  color: #17211c;
  display: inline-flex;
  font-size: 12px;
  font-weight: 900;
  height: 34px;
  justify-content: center;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 42px;
}

.rally-flag {
  color: #34513f;
  position: absolute;
  right: 8px;
  top: 5px;
}

.rally-task-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 16px;
}

.rally-task-grid span {
  background: #ebe5d9;
  border-radius: 999px;
  color: #34513f;
  padding: 7px 10px;
}

.stack-list {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.compact-row {
  align-items: flex-start;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: grid;
  gap: 4px;
  padding: 12px;
}

.compact-row span,
.empty-copy {
  color: #4e5b53;
}

.snapshot-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 14px;
}

.snapshot-grid div,
.feature-card {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  padding: 12px;
}

.snapshot-grid span,
.feature-card p,
.location-list span,
.home-location-strip span {
  color: #4e5b53;
}

.snapshot-grid strong {
  display: block;
  font-size: 22px;
  margin-top: 6px;
}

.location-list,
.home-location-strip {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 12px;
}

.location-list span,
.home-location-strip span {
  background: #ebe5d9;
  border-radius: 999px;
  padding: 7px 10px;
}

.compact-form {
  border-top: 1px solid #e2ded3;
  margin-top: 16px;
  padding-top: 16px;
}

.history-timeline {
  display: grid;
  gap: 12px;
  margin-top: 18px;
}

.history-event {
  display: grid;
  gap: 14px;
  grid-template-columns: 120px minmax(0, 1fr);
}

.history-event time {
  color: #805f1d;
  font-weight: 800;
}

.history-event div {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  padding: 12px;
}

.history-event span,
.history-event small,
.history-event p {
  color: #4e5b53;
  display: block;
  margin: 6px 0 0;
}

.calendar-month-list {
  display: grid;
  gap: 22px;
  margin-top: 18px;
}

.calendar-month h3 {
  margin-bottom: 10px;
}

.calendar-event-row p {
  color: #4e5b53;
  margin: 0;
}

.calendar-event-date {
  align-items: center;
  color: #805f1d;
  display: inline-flex;
  font-weight: 800;
  gap: 8px;
}

.metric-card,
.content-band,
.login-panel {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);
}

.metric-card {
  padding: 18px;
}

.metric-card strong {
  display: block;
  font-size: 24px;
  margin-top: 10px;
}
.private-route-loading {
  min-height: 100vh;
  display: grid;
  place-content: center;
  justify-items: center;
  gap: 14px;
  background: #f7f4ed;
  color: #14271f;
}

.contribution-steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin-bottom: 16px;
}

.contribution-steps > div {
  display: grid;
  grid-template-columns: 36px minmax(0, 1fr);
  gap: 2px 10px;
  align-items: center;
  padding: 14px;
  border: 1px solid #ded8ca;
  background: #fff;
}

.contribution-steps span {
  grid-row: 1 / span 2;
  display: grid;
  place-items: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  background: #dba83f;
  color: #12231c;
  font-weight: 800;
}

.contribution-steps small { color: #526159; }

.simple-kosh-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  padding: 16px 0;
  border-top: 1px solid #ded8ca;
}

.simple-kosh-footer p { margin: 0; }

.optional-contribution-details,
.declaration-history-collapsed {
  border: 1px solid #ded8ca;
  background: #f8f6f0;
  padding: 12px;
}

.optional-contribution-details summary,
.declaration-history-collapsed summary {
  cursor: pointer;
  color: #274c3a;
  font-weight: 700;
}

.optional-contribution-details[open] summary,
.declaration-history-collapsed[open] summary { margin-bottom: 12px; }

.contribution-review-overlay {
  position: fixed;
  inset: 0;
  z-index: 1200;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(7, 23, 16, 0.76);
  backdrop-filter: blur(5px);
}

.contribution-review-dialog {
  width: min(520px, 100%);
  padding: 28px;
  border: 2px solid #d4a53a;
  background: #fff;
  box-shadow: 0 26px 70px rgba(0, 0, 0, 0.32);
}

.contribution-review-dialog h2 { margin: 8px 0 18px; }

.contribution-review-amount {
  display: block;
  color: #103f2c;
  font-size: clamp(42px, 9vw, 68px);
  line-height: 1;
}

.contribution-review-words {
  margin: 12px 0 24px;
  color: #7a5411;
  font-size: 20px;
  font-weight: 700;
}

.contribution-review-dialog dl { margin: 0; }

.contribution-review-dialog dl div {
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-top: 1px solid #e3ded2;
}

.contribution-review-dialog dt { color: #5a675f; }
.contribution-review-dialog dd { margin: 0; font-weight: 700; text-align: right; }

.contribution-review-warning {
  margin: 18px 0;
  padding: 12px;
  background: #f8f1df;
  color: #5b471c;
}

.contribution-review-actions {
  display: grid;
  grid-template-columns: 1fr 1.35fr;
  gap: 10px;
}

@media (max-width: 560px) {
  .contribution-review-dialog { padding: 22px 18px; }
  .contribution-review-actions { grid-template-columns: 1fr; }
}

@media (max-width: 720px) {
  .contribution-steps { grid-template-columns: 1fr; }
  .simple-kosh-footer { align-items: stretch; flex-direction: column; }
}

/* Verified bank contributions */
.bank-contribution-panel {
  border-top: 3px solid #d7a93c;
}

.section-kicker {
  color: #8a651d;
  display: block;
  font-size: 12px;
  font-weight: 700;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.verification-badge,
.confidence-meter {
  background: #e7f4eb;
  border: 1px solid #afd1b9;
  color: #185b31;
  font-size: 12px;
  font-style: normal;
  font-weight: 700;
  padding: 7px 10px;
}

.bank-security-note {
  background: #fff4d6;
  border-left: 3px solid #d7a93c;
  padding: 12px;
}

.bank-start-form,
.bank-review-fields {
  display: grid;
  gap: 12px;
  grid-template-columns: minmax(220px, 1fr) minmax(180px, auto);
  margin-top: 18px;
}

.bank-start-form label,
.bank-proof-form label,
.bank-review-fields label {
  display: grid;
  gap: 6px;
}

.bank-claim-workflow {
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(260px, 0.8fr) minmax(320px, 1.2fr);
  margin-top: 20px;
}

.bank-payment-card {
  background: #13251d;
  color: #fff;
  padding: 22px;
}

.bank-payment-card > span {
  color: #cbd8d1;
}

.bank-payment-card > strong {
  display: block;
  font-size: 30px;
  margin: 5px 0 18px;
}

.bank-payment-card dl {
  display: grid;
  gap: 10px;
  margin: 0;
}

.bank-payment-card dl div {
  border-top: 1px solid #355046;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding-top: 9px;
}

.bank-payment-card dt {
  color: #afc4ba;
}

.bank-payment-card dd {
  font-weight: 700;
  margin: 0;
  overflow-wrap: anywhere;
  text-align: right;
}

.bank-proof-form {
  display: grid;
  gap: 12px;
}

.bank-proof-form h3 {
  margin: 0;
}

.bank-proof-form textarea {
  min-height: 92px;
}

.bank-claim-history {
  border-top: 1px solid #ded8ca;
  margin-top: 22px;
  padding-top: 16px;
}

.bank-claim-summary {
  align-items: center;
  background: #f8f6f0;
  border: 1px solid #ded8ca;
  color: #17231d;
  display: grid;
  grid-template-columns: 1fr auto auto;
  margin-top: 8px;
  text-align: left;
  width: 100%;
}

.bank-claim-summary em {
  font-size: 12px;
  font-style: normal;
  text-transform: capitalize;
}

.bank-claim-summary > small {
  grid-column: 1 / -1;
  margin-top: 4px;
}

.bank-claim-summary.approved {
  border-left: 4px solid #2d7a4b;
}

.bank-claim-summary.rejected {
  border-left: 4px solid #a33c33;
}

.bank-review-card {
  border: 1px solid #ded8ca;
  margin-top: 16px;
  padding: 18px;
}

.bank-review-card header {
  align-items: center;
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr auto auto;
}

.bank-review-card header h3 {
  margin: 3px 0 0;
}

.evidence-list {
  display: grid;
  gap: 10px;
  margin-top: 14px;
}

.evidence-item {
  background: #f8f6f0;
  display: grid;
  gap: 5px;
  padding: 12px;
}

.evidence-item small {
  color: #805018;
}

.evidence-item .secondary-button {
  justify-self: start;
  margin-top: 5px;
}

.bank-review-fields {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.bank-sms-check {
  align-items: end;
  display: grid;
  gap: 12px;
  grid-template-columns: 1fr auto;
  margin-top: 12px;
}

.bank-sms-check label {
  display: grid;
  gap: 6px;
}

.bank-sms-check textarea {
  min-height: 72px;
}

.danger-button {
  background: #fff;
  border: 1px solid #a33c33;
  color: #8f2f28;
}

.unmatched-sms-list {
  border-top: 1px solid #ded8ca;
  margin-top: 22px;
  padding-top: 16px;
}

.unmatched-sms-list article {
  background: #fff5df;
  display: grid;
  gap: 6px;
  grid-template-columns: auto auto 1fr;
  margin-top: 10px;
  padding: 12px;
}

.unmatched-sms-list article small {
  text-align: right;
}

.unmatched-sms-list blockquote,
.evidence-item blockquote {
  background: #fff;
  border-left: 3px solid #d7a93c;
  grid-column: 1 / -1;
  margin: 4px 0 0;
  overflow-wrap: anywhere;
  padding: 9px;
}

@media (max-width: 760px) {
  .bank-claim-workflow,
  .bank-review-fields,
  .bank-sms-check,
  .bank-start-form {
    grid-template-columns: 1fr;
  }

  .bank-review-card header {
    align-items: start;
    grid-template-columns: 1fr auto;
  }

  .confidence-meter {
    grid-column: 1 / -1;
    justify-self: start;
  }

  .bank-claim-summary {
    grid-template-columns: 1fr auto;
  }

  .bank-claim-summary em {
    grid-column: 1 / -1;
  }

  .bank-payment-card dl div {
    display: grid;
  }

  .unmatched-sms-list article {
    grid-template-columns: 1fr;
  }

  .unmatched-sms-list article small {
    text-align: left;
  }

  .bank-payment-card dd {
    text-align: left;
  }
}
.hosted-contribution-list {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}

.hosted-contribution-row {
  align-items: end;
  background: #faf8f2;
  border: 1px solid #ded8ca;
  border-radius: 8px;
  display: grid;
  gap: 14px;
  grid-template-columns: minmax(220px, 1fr) auto minmax(220px, 1fr) auto;
  padding: 14px;
}

.hosted-contribution-row > div {
  display: grid;
  gap: 3px;
}

.hosted-contribution-row label {
  display: grid;
  gap: 6px;
}

.hosted-contribution-row select {
  min-height: 42px;
}

.hosted-contribution-status {
  color: #8b651f;
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
}

.hosted-contribution-amount {
  font-size: 20px;
  white-space: nowrap;
}

@media (max-width: 760px) {
  .hosted-contribution-row {
    align-items: stretch;
    grid-template-columns: 1fr;
  }

  .hosted-contribution-row button {
    width: 100%;
  }
}

.wallet-spotlight {
  align-items: center;
  background: linear-gradient(135deg, #17211c, #2e3d33);
  border: 1px solid rgba(215, 168, 79, 0.36);
  border-radius: 8px;
  color: #fff8e8;
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(0, 1.3fr) minmax(220px, 0.7fr);
  margin-bottom: 18px;
  padding: 22px;
}

.wallet-spotlight span {
  color: #d7a84f;
  display: block;
  font-weight: 850;
}

.wallet-spotlight strong {
  color: #ffffff;
  display: block;
  font-size: clamp(36px, 6vw, 58px);
  line-height: 1;
  margin: 10px 0;
}

.wallet-spotlight p {
  color: #dce3d5;
  line-height: 1.5;
  margin: 0;
}

.wallet-spotlight-metrics {
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 8px;
  display: grid;
  gap: 10px;
  padding: 14px;
}

.wallet-spotlight-metrics span {
  color: #ffffff;
  font-size: 16px;
}

.content-band {
  padding: 24px;
}

.content-band h2 {
  font-size: 22px;
  margin: 0 0 8px;
}

.content-band p {
  color: #4e5b53;
  margin: 0;
}

.vision-chart-band {
  align-items: stretch;
  background:
    linear-gradient(135deg, rgba(23, 33, 28, 0.96), rgba(54, 71, 58, 0.94)),
    #17211c;
  color: #f8f4eb;
  display: grid;
  gap: 22px;
  grid-template-columns: minmax(220px, 0.7fr) minmax(0, 1.3fr);
  margin-bottom: 24px;
  overflow: hidden;
  position: relative;
}

.vision-chart-band::after {
  border: 1px solid rgba(215, 168, 79, 0.28);
  border-radius: 8px;
  content: "";
  inset: 12px;
  pointer-events: none;
  position: absolute;
}

.vision-chart-copy {
  align-content: center;
  display: grid;
  gap: 10px;
  position: relative;
  z-index: 1;
}

.vision-chart-copy span {
  color: #d7a84f;
  font-size: 13px;
  font-weight: 900;
  text-transform: uppercase;
}

.vision-chart-copy h2 {
  color: #ffffff;
  font-size: 30px;
  line-height: 1.12;
  margin: 0;
}

.vision-chart-copy p {
  color: #dce3d5;
  line-height: 1.55;
}

.vision-cloud {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 10px 12px;
  justify-content: center;
  min-height: 210px;
  position: relative;
  z-index: 1;
}

.vision-chip {
  background: rgba(248, 244, 235, 0.1);
  border: 1px solid rgba(215, 168, 79, 0.28);
  border-radius: 999px;
  color: #fff8e8;
  display: inline-flex;
  font-weight: 850;
  line-height: 1.2;
  padding: 10px 14px;
}

.vision-chip-1 {
  font-size: 22px;
  transform: translateY(-8px);
}

.vision-chip-2 {
  background: #d7a84f;
  color: #17211c;
  font-size: 16px;
  transform: translateY(12px);
}

.vision-chip-3 {
  font-size: 18px;
  transform: translateY(4px);
}

.vision-chip-4 {
  border-color: rgba(255, 255, 255, 0.38);
  font-size: 14px;
  transform: translateY(-14px);
}

.vision-chip-5 {
  font-size: 20px;
  transform: translateY(16px);
}

.project-summary {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.project-summary span {
  background: #f0eadc;
  border-radius: 999px;
  color: #2f3e35;
  font-size: 15px;
  font-weight: 750;
  line-height: 1.25;
  padding: 9px 13px;
}

.mission-financials {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  margin-top: 18px;
}

.mission-financials div {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  padding: 12px;
}

.mission-financials span {
  color: #68756e;
  display: block;
  margin-bottom: 6px;
}

.mission-financials strong {
  display: block;
  font-size: 18px;
}

.kosh-filter-row {
  align-items: end;
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
  margin-top: 18px;
}

.kosh-filter-row label {
  display: grid;
  gap: 8px;
}

.kosh-filter-row input,
.kosh-filter-row select {
  border: 1px solid #cfc8bc;
  border-radius: 8px;
  min-width: 0;
  padding: 12px;
}

.kosh-filter-row button {
  background: #17211c;
  border: 0;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  min-height: 45px;
  padding: 12px 16px;
}

.kosh-analytics-grid {
  margin-top: 14px;
}

.featured-sankalp-band {
  margin-bottom: 18px;
}

.featured-sankalp-list {
  display: grid;
  gap: 12px;
  margin-top: 16px;
}

.featured-sankalp-card {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: grid;
  gap: 14px;
  grid-template-columns: auto minmax(0, 1fr);
  padding: 14px;
}

.sankalp-number {
  align-items: center;
  background: #d7a84f;
  border-radius: 999px;
  color: #17211c;
  display: inline-flex;
  font-weight: 900;
  height: 34px;
  justify-content: center;
  width: 34px;
}

.compact-header {
  align-items: center;
  margin-bottom: 8px;
}

.compact-header h3 {
  font-size: 18px;
}

.featured-sankalp-card p {
  line-height: 1.5;
}

.featured-sankalp-card .project-summary {
  margin-top: 12px;
}

.project-list {
  display: grid;
  gap: 16px;
  margin-top: 18px;
}

.project-card {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  padding: 18px;
}

.lifecycle-strip {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin: 18px 0 12px;
}

.lifecycle-strip div {
  align-items: center;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: flex;
  gap: 10px;
  min-height: 54px;
  padding: 10px;
}

.lifecycle-strip strong {
  align-items: center;
  background: #dba945;
  border-radius: 999px;
  color: #17211c;
  display: inline-flex;
  flex: 0 0 auto;
  height: 28px;
  justify-content: center;
  width: 28px;
}

.lifecycle-strip span,
.sankalp-team-row span {
  color: #4e5b53;
}

.section-heading-row {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.sadasya-sankalp-note {
  align-items: flex-start;
  display: grid;
  gap: 14px;
  margin-top: 16px;
}

.sankalp-board {
  display: grid;
  gap: 14px;
}

.sankalp-card {
  display: grid;
  gap: 14px;
}

.sankalp-card .project-card-header h3 {
  font-size: clamp(21px, 2.2vw, 28px);
  line-height: 1.2;
}

.sankalp-card .project-card-header p {
  font-size: 17px;
  line-height: 1.55;
  max-width: 980px;
}

.sankalp-card .button-row button {
  min-height: 44px;
}

.sankalp-team-row {
  display: grid;
  gap: 8px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.sankalp-workspace h3 {
  margin: 24px 0 10px;
}

.sankalp-workspace {
  scroll-margin-top: 18px;
}

.sankalp-workspace.workspace-opened {
  animation: workspacePulse 1.8s ease;
  border-color: #d7a84f;
}

@keyframes workspacePulse {
  0% {
    box-shadow: 0 0 0 0 rgba(215, 168, 79, 0.42);
  }

  45% {
    box-shadow: 0 0 0 8px rgba(215, 168, 79, 0.16);
  }

  100% {
    box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);
  }
}

.sankalp-detail-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 18px;
}

.compact-row {
  align-items: center;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 12px;
}

.compact-row span {
  color: #4e5b53;
  text-align: right;
}

.management-row {
  align-items: flex-start;
}

.management-row div {
  display: grid;
  gap: 4px;
}

.management-row small {
  color: #637066;
  line-height: 1.35;
}

.status-pill {
  background: #17211c;
  border-radius: 999px;
  color: #fff;
  flex: 0 0 auto;
  padding: 8px 12px;
}

.draft-pill,
.status-pill.draft-pill,
.project-card-header > span.draft-pill {
  background: #fff4d7;
  border: 1px solid #d9a642;
  color: #7a5410;
}

.next-step-card {
  background: #fff8e8;
  border: 1px solid #e3c986;
  border-radius: 8px;
  display: grid;
  gap: 8px;
  margin: 16px 0;
  padding: 14px;
}

.next-step-card strong {
  color: #17211c;
  font-size: 1rem;
}

.next-step-card span {
  color: #3f4d45;
}

.next-step-card ol {
  color: #526158;
  margin: 4px 0 0;
  padding-left: 20px;
}

.next-step-card li {
  margin: 4px 0;
}

.project-card-header {
  align-items: flex-start;
  display: flex;
  gap: 16px;
  justify-content: space-between;
}

.project-card-header h3 {
  margin: 0 0 6px;
}

.project-card-header p {
  color: #4e5b53;
  margin: 0;
}

.project-card-header > span {
  background: #17211c;
  border-radius: 999px;
  color: #fff;
  flex: 0 0 auto;
  padding: 7px 11px;
  text-transform: capitalize;
}

.progress-track {
  background: #e7e1d5;
  border-radius: 999px;
  height: 10px;
  margin: 16px 0;
  overflow: hidden;
}

.progress-track div {
  background: #d7a84f;
  height: 100%;
}

.feedback-overlay {
  align-items: center;
  background: rgba(23, 33, 28, 0.42);
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  padding: 18px;
  position: fixed;
  right: 0;
  top: 0;
  z-index: 80;
  animation: feedbackBackdropIn 180ms ease-out both;
}

.feedback-dialog {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  box-shadow: 0 24px 72px rgba(23, 33, 28, 0.28);
  display: grid;
  gap: 12px;
  max-width: 480px;
  max-height: calc(100vh - 36px);
  overflow-y: auto;
  padding: 24px;
  width: min(100%, 480px);
  animation: feedbackDialogIn 420ms cubic-bezier(0.2, 0.85, 0.25, 1.15) both;
}

.feedback-eyebrow {
  color: #805f1d;
  display: block;
  font-size: 13px;
  font-weight: 900;
  letter-spacing: 0;
  text-transform: uppercase;
}

.feedback-dialog h2 {
  color: #17211c;
  font-size: 28px;
  line-height: 1.18;
  margin: 0;
}

.feedback-dialog p {
  color: #4e5b53;
  font-size: 17px;
  line-height: 1.5;
  margin: 0;
}

.feedback-dialog button {
  background: #17211c;
  border: 0;
  border-radius: 8px;
  color: #ffffff;
  cursor: pointer;
  min-height: 46px;
  padding: 12px 16px;
}

.feedback-actions {
  display: flex;
  gap: 10px;
  margin-top: 4px;
}

.feedback-actions button {
  flex: 1 1 0;
}

.feedback-dialog .feedback-secondary-action {
  background: #f0ede5;
  color: #243129;
}

.feedback-dialog.success {
  border-top: 5px solid #2f7d46;
}

.feedback-dialog.warning {
  border-top: 5px solid #d7a84f;
}

.feedback-dialog.error {
  border-top: 5px solid #b42318;
}

.feedback-overlay.is-celebrating {
  background: rgba(13, 27, 20, 0.72);
}

.feedback-dialog.celebration {
  background: #fffdf7;
  border: 1px solid #d8b45f;
  border-top: 6px solid #d7a84f;
  box-shadow: 0 28px 90px rgba(4, 23, 14, 0.42), 0 0 0 5px rgba(215, 168, 79, 0.12);
  gap: 10px;
  max-width: 540px;
  padding: 24px 30px 28px;
  text-align: center;
}

.feedback-celebration-stage {
  height: 126px;
  margin: -4px auto 2px;
  position: relative;
  width: 210px;
}

.celebration-halo {
  border: 1px solid rgba(215, 168, 79, 0.42);
  border-radius: 50%;
  height: 112px;
  left: 49px;
  position: absolute;
  top: 7px;
  width: 112px;
  animation: celebrationHalo 1.8s ease-out infinite;
}

.celebration-halo::after {
  border: 1px solid rgba(47, 125, 70, 0.2);
  border-radius: inherit;
  content: "";
  inset: 10px;
  position: absolute;
}

.celebration-seal {
  align-items: center;
  background: #173c29;
  border: 4px solid #e6c46f;
  border-radius: 50%;
  box-shadow: 0 10px 26px rgba(23, 60, 41, 0.28);
  color: #f7d77e;
  display: flex;
  font-family: Georgia, "Times New Roman", serif;
  font-size: 45px;
  height: 84px;
  justify-content: center;
  left: 63px;
  line-height: 1;
  position: absolute;
  top: 21px;
  width: 84px;
  z-index: 2;
  animation: celebrationSealIn 650ms cubic-bezier(0.18, 0.9, 0.25, 1.25) both;
}

.celebration-petals {
  inset: 0;
  position: absolute;
}

.celebration-petals i {
  background: #d7a84f;
  border-radius: 80% 10% 80% 10%;
  display: block;
  height: 13px;
  position: absolute;
  width: 7px;
  animation: celebrationPetalIn 700ms cubic-bezier(0.2, 0.8, 0.25, 1.2) both;
}

.celebration-petals i:nth-child(1) { left: 18px; top: 24px; transform: rotate(-52deg); }
.celebration-petals i:nth-child(2) { left: 38px; top: 4px; transform: rotate(-30deg); animation-delay: 70ms; }
.celebration-petals i:nth-child(3) { left: 75px; top: 0; transform: rotate(-12deg); animation-delay: 140ms; }
.celebration-petals i:nth-child(4) { right: 75px; top: 0; transform: rotate(12deg); animation-delay: 210ms; }
.celebration-petals i:nth-child(5) { right: 38px; top: 4px; transform: rotate(30deg); animation-delay: 280ms; }
.celebration-petals i:nth-child(6) { right: 18px; top: 24px; transform: rotate(52deg); animation-delay: 350ms; }
.celebration-petals i:nth-child(7) { left: 5px; top: 62px; transform: rotate(-78deg); animation-delay: 420ms; }
.celebration-petals i:nth-child(8) { right: 5px; top: 62px; transform: rotate(78deg); animation-delay: 490ms; }
.celebration-petals i:nth-child(9) { bottom: 13px; left: 28px; transform: rotate(-115deg); animation-delay: 560ms; }
.celebration-petals i:nth-child(10) { bottom: 13px; right: 28px; transform: rotate(115deg); animation-delay: 630ms; }
.celebration-petals i:nth-child(11) { bottom: 0; left: 65px; transform: rotate(-155deg); animation-delay: 700ms; }
.celebration-petals i:nth-child(12) { bottom: 0; right: 65px; transform: rotate(155deg); animation-delay: 770ms; }

.feedback-dialog.celebration h2 {
  font-size: 30px;
}

.feedback-amount {
  color: #173c29;
  display: block;
  font-size: 42px;
  line-height: 1.08;
  margin: 2px 0;
  animation: celebrationAmountIn 520ms 260ms ease-out both;
}

.feedback-project {
  background: #f4efe2;
  border: 1px solid #e1d2ad;
  border-radius: 8px;
  display: grid;
  gap: 3px;
  padding: 11px 14px;
  text-align: left;
}

.feedback-project span {
  color: #7a6841;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.feedback-project strong {
  color: #243129;
  font-size: 17px;
}

.feedback-balance {
  align-items: center;
  background: #edf4ee;
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  padding: 10px 13px;
  text-align: left;
}

.feedback-balance strong {
  color: #1f6a39;
  font-size: 18px;
}

@keyframes feedbackBackdropIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

@keyframes feedbackDialogIn {
  from { opacity: 0; transform: translateY(24px) scale(0.96); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@keyframes celebrationSealIn {
  0% { opacity: 0; transform: scale(0.35) rotate(-18deg); }
  72% { opacity: 1; transform: scale(1.08) rotate(3deg); }
  100% { opacity: 1; transform: scale(1) rotate(0); }
}

@keyframes celebrationHalo {
  0% { opacity: 0.72; transform: scale(0.82); }
  75%, 100% { opacity: 0; transform: scale(1.28); }
}

@keyframes celebrationPetalIn {
  from { opacity: 0; margin-top: 12px; scale: 0.2; }
  to { opacity: 1; margin-top: 0; scale: 1; }
}

@keyframes celebrationAmountIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

@media (prefers-reduced-motion: reduce) {
  .feedback-overlay,
  .feedback-dialog,
  .celebration-halo,
  .celebration-seal,
  .celebration-petals i,
  .feedback-amount {
    animation: none;
  }
}

@media (max-width: 720px) {
  .sankalp-carousel-heading {
    align-items: center;
  }

  .sankalp-carousel-heading strong {
    font-size: 16px;
  }

  .sankalp-carousel-track {
    margin-inline: -4px;
    padding: 3px 4px 12px;
  }

  .sankalp-slide {
    flex-basis: calc(100% - 16px);
    min-height: 230px;
    padding: 16px;
  }

  .sankalp-slide h3 {
    font-size: 20px;
  }

  .sankalp-slide-metrics {
    align-items: flex-start;
    flex-direction: column;
    gap: 7px;
  }

  .allocation-wallet-pill {
    align-self: flex-start;
  }
}

.login-page {
  align-items: center;
  background: #17211c;
  display: flex;
  justify-content: center;
  min-height: 100vh;
  padding: 24px;
}

.login-panel {
  max-width: 440px;
  padding: 32px;
  width: 100%;
}

.login-panel h1 {
  margin: 18px 0 8px;
}

.login-panel p {
  color: #4e5b53;
  line-height: 1.5;
}

.password-input-wrap {
  position: relative;
  display: block;
}

.password-input-wrap input {
  width: 100%;
  padding-right: 52px;
}

.password-visibility-button {
  position: absolute;
  top: 50%;
  right: 8px;
  width: 40px;
  height: 40px;
  padding: 0;
  display: grid;
  place-items: center;
  transform: translateY(-50%);
  border: 0;
  background: transparent;
  color: #4e5b53;
}

.login-progress-note {
  margin: 0;
  padding: 10px 12px;
  border-left: 3px solid #d6a63e;
  background: #f7f4ed;
  font-size: 0.9rem;
}

.form-stack {
  display: grid;
  gap: 14px;
  margin-top: 24px;
}

.form-stack label {
  display: grid;
  gap: 8px;
}

.form-stack input {
  border: 1px solid #cfc8bc;
  border-radius: 8px;
  padding: 12px;
}

.form-stack button {
  background: #17211c;
  border: 0;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  padding: 12px;
}

.form-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 18px;
}

.form-grid label {
  display: grid;
  gap: 8px;
}

.form-grid input,
.form-grid select,
.form-grid textarea {
  border: 1px solid #cfc8bc;
  border-radius: 8px;
  min-width: 0;
  padding: 12px;
  width: 100%;
}

.form-grid textarea {
  resize: vertical;
}

.wide-field {
  grid-column: span 2;
}

.form-grid button,
.secondary-button {
  background: #17211c;
  border: 0;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  padding: 12px;
}

.secondary-button {
  background: #eef1ea;
  color: #17211c;
}

button:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.form-error {
  color: #b42318;
  margin: 0;
}

.form-message {
  background: #eef5ed;
  border: 1px solid #c7ddc0;
  border-radius: 8px;
  color: #34513f;
  margin-top: 16px;
  padding: 12px;
}

.section-note {
  color: #4e5b53;
  margin: 8px 0 0;
}

.contribute-hero-band {
  display: grid;
  gap: 22px;
}

.contribution-panel {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: grid;
  gap: 14px;
  padding: 16px;
}

.contribution-panel label {
  display: grid;
  gap: 8px;
}

.contribution-panel input {
  border: 1px solid #cfc8bc;
  border-radius: 8px;
  font-size: 18px;
  min-width: 0;
  padding: 12px;
  width: 100%;
}

.contribution-panel button[type="submit"] {
  background: #17211c;
  border: 0;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  min-height: 48px;
  padding: 12px;
}

.amount-preset-row {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(5, minmax(0, 1fr));
}

.amount-preset-row button {
  background: #fff;
  border: 1px solid #d8cdb8;
  border-radius: 8px;
  color: #17211c;
  cursor: pointer;
  min-height: 42px;
  padding: 10px;
}

.amount-preset-row button.active {
  background: #d7a84f;
  border-color: #b98324;
  font-weight: 800;
}

.contribute-project-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 18px;
}

.contribute-project-card {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  color: #17211c;
  cursor: pointer;
  display: grid;
  gap: 6px;
  min-height: 116px;
  padding: 14px;
  text-align: left;
}

.contribute-project-card.active {
  border-color: #d7a84f;
  box-shadow: 0 0 0 2px rgba(215, 168, 79, 0.16);
}

.contribute-project-card span {
  color: #4e5b53;
}

.contribute-project-card small {
  color: #805f1d;
  font-weight: 800;
}

.sankalp-carousel {
  display: grid;
  gap: 12px;
  margin: 20px 0;
  min-width: 0;
}

.sankalp-carousel-heading {
  align-items: flex-end;
  display: flex;
  justify-content: space-between;
}

.sankalp-carousel-heading > div:first-child {
  display: grid;
  gap: 3px;
}

.recommendation-kicker {
  color: #8a641b;
  font-size: 12px;
  font-weight: 800;
  text-transform: uppercase;
}

.sankalp-carousel-heading strong {
  font-size: 18px;
}

.sankalp-carousel-controls {
  display: flex;
  gap: 8px;
}

.sankalp-carousel-controls button {
  align-items: center;
  background: #ffffff;
  border: 1px solid #d8cdb8;
  border-radius: 50%;
  color: #17211c;
  cursor: pointer;
  display: inline-flex;
  height: 42px;
  justify-content: center;
  padding: 0;
  width: 42px;
}

.sankalp-carousel-track {
  display: flex;
  gap: 12px;
  min-width: 0;
  overflow-x: auto;
  overscroll-behavior-inline: contain;
  padding: 3px;
  scrollbar-width: none;
  scroll-snap-type: x mandatory;
}

.sankalp-carousel-track::-webkit-scrollbar {
  display: none;
}

.sankalp-slide {
  background: #fbfaf6;
  border: 1px solid #ddd6c8;
  border-radius: 8px;
  color: #17211c;
  cursor: pointer;
  display: grid;
  flex: 0 0 min(520px, calc(100% - 24px));
  gap: 12px;
  min-height: 214px;
  padding: 20px;
  scroll-snap-align: center;
  text-align: left;
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.sankalp-slide.active {
  border-color: #d7a84f;
  box-shadow: 0 12px 32px rgba(34, 55, 42, 0.12), 0 0 0 2px rgba(215, 168, 79, 0.16);
  transform: translateY(-1px);
}

.sankalp-slide-topline,
.sankalp-slide-metrics {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.sankalp-slide-topline span {
  background: #efe4c9;
  border-radius: 999px;
  color: #755617;
  font-size: 12px;
  font-weight: 800;
  padding: 5px 9px;
}

.sankalp-slide-topline strong {
  color: #245f39;
  font-size: 14px;
}

.sankalp-slide h3 {
  font-size: 22px;
  margin: 0;
}

.sankalp-progress {
  background: #e8e2d6;
  border-radius: 999px;
  height: 9px;
  overflow: hidden;
}

.sankalp-progress i {
  background: #2f7d46;
  border-radius: inherit;
  display: block;
  height: 100%;
  min-width: 4px;
  transition: width 480ms cubic-bezier(0.2, 0.75, 0.25, 1);
}

.sankalp-slide-metrics {
  color: #536158;
  gap: 14px;
}

.sankalp-slide-metrics span {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}

.sankalp-slide small {
  color: #755617;
  font-weight: 700;
}

.sankalp-carousel-dots {
  display: flex;
  gap: 7px;
  justify-content: center;
}

.sankalp-carousel-dots button {
  background: #cfc7b7;
  border: 0;
  border-radius: 999px;
  cursor: pointer;
  height: 7px;
  padding: 0;
  transition: background 180ms ease, width 180ms ease;
  width: 7px;
}

.sankalp-carousel-dots button.active {
  background: #2f7d46;
  width: 24px;
}

.allocation-wallet-pill {
  background: #edf4ee;
  border: 1px solid #c9ddcd;
  border-radius: 999px;
  color: #245f39;
  padding: 9px 13px;
  white-space: nowrap;
}

.sankalp-allocation-form {
  border-top: 1px solid #e2ded3;
  padding-top: 18px;
}

.sabha-intro-band {
  display: grid;
  gap: 18px;
}

.sabha-rule-grid {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.sabha-rule-grid span {
  background: #f0eadc;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  font-weight: 800;
  padding: 12px;
}

.proposal-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  margin-top: 18px;
}

.proposal-card {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: grid;
  gap: 12px;
  padding: 16px;
}

.proposal-card h3 {
  margin: 0;
}

.proposal-card p,
.proposal-card small {
  color: #4e5b53;
  line-height: 1.5;
}

.compact-proposal-card {
  min-height: 160px;
}

.vote-meter {
  background: #e7dfd0;
  border-radius: 999px;
  height: 10px;
  overflow: hidden;
}

.vote-meter span {
  background: #d7a84f;
  display: block;
  height: 100%;
}

.vote-actions {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(2, minmax(0, 1fr));
}

.vote-actions button {
  background: #17211c;
  border: 0;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  min-height: 44px;
  padding: 10px;
}

.button-row {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 14px;
}

.copy-box {
  align-items: center;
  background: #f4f1e9;
  border: 1px solid #ded8ca;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-top: 16px;
  overflow-wrap: anywhere;
  padding: 14px;
}

.copy-box span {
  min-width: 0;
}

.copy-box button {
  background: #17211c;
  border: 0;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  flex: 0 0 auto;
  padding: 10px 14px;
}

.list-stack {
  display: grid;
  gap: 10px;
  margin-top: 18px;
}

.list-row {
  align-items: center;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  color: #18201b;
  display: flex;
  justify-content: space-between;
  padding: 12px 14px;
  text-align: left;
  width: 100%;
}

.invite-row {
  align-items: center;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 12px 14px;
}

.member-row {
  align-items: center;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 12px 14px;
}

.ledger-row {
  align-items: center;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: flex;
  gap: 16px;
  justify-content: space-between;
  padding: 12px 14px;
}

.ledger-row span,
.ledger-row small,
.ledger-member span {
  color: #4e5b53;
  display: block;
  margin-top: 4px;
  text-transform: capitalize;
}

.ledger-member {
  text-align: right;
}

.document-list {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 10px;
}

.document-list button {
  background: #eef1ea;
  border: 0;
  border-radius: 8px;
  color: #17211c;
  cursor: pointer;
  padding: 8px 10px;
}

.member-row span {
  color: #4e5b53;
  display: block;
  margin-top: 4px;
  text-transform: capitalize;
}

.member-summary {
  align-items: center;
  display: flex;
  gap: 12px;
}

.member-avatar {
  align-items: center;
  background: #ebe5d9;
  border-radius: 999px;
  color: #17211c;
  display: inline-flex;
  flex: 0 0 auto;
  height: 42px;
  justify-content: center;
  overflow: hidden;
  width: 42px;
}

.member-avatar.deceased {
  background: #ece7dc;
  border: 2px solid #b8ad9b;
  color: #615849;
}

.member-avatar.female {
  background: #f2dfdd;
  color: #6f2b38;
}

.member-avatar.male {
  background: #dfe8ef;
  color: #24435b;
}

.member-avatar.male.deceased,
.member-avatar.female.deceased,
.member-avatar.unknown.deceased {
  background: #ece7dc;
  color: #615849;
}

.member-avatar.has-photo {
  background: #ffffff;
}

.member-avatar.has-photo.deceased {
  background: #ece7dc;
}

.member-avatar img {
  display: block;
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.member-avatar.deceased img {
  filter: grayscale(1) sepia(0.15);
  opacity: 0.82;
}

.avatar-letter {
  font-size: 14px;
  font-weight: 800;
  line-height: 1;
}

.invite-row span {
  color: #4e5b53;
  display: block;
  margin-top: 4px;
  text-transform: capitalize;
}

.row-actions {
  display: flex;
  flex: 0 0 auto;
  gap: 8px;
}

.row-actions select {
  border: 1px solid #cfc8bc;
  border-radius: 8px;
  padding: 10px 12px;
}

.reject-reason {
  display: grid;
  gap: 8px;
  margin-top: 16px;
}

.reject-reason input {
  border: 1px solid #cfc8bc;
  border-radius: 8px;
  padding: 12px;
}

.spaced-band {
  margin-top: 20px;
}

.text-link {
  color: #17211c;
  display: inline-block;
  margin-top: 18px;
}

.empty-state {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: grid;
  gap: 10px;
  margin: 16px 0;
  padding: 18px;
}

.empty-state h3,
.empty-state p {
  margin: 0;
}

.empty-state p {
  color: #4e5b53;
  line-height: 1.5;
}

.empty-state .secondary-button {
  display: inline-flex;
  justify-self: start;
  text-decoration: none;
}

.home-page {
  background: #f7f4ee;
  color: #18201b;
  min-height: 100vh;
}

.launch-stage {
  align-items: center;
  background: #132019;
  color: #f8f4eb;
  display: flex;
  inset: 0;
  justify-content: center;
  min-height: 100vh;
  min-height: 100dvh;
  overflow: hidden;
  padding: 24px 24px 96px;
  position: fixed;
  z-index: 100;
}

.launch-stage::before,
.launch-stage::after {
  border: 1px solid rgba(215, 168, 79, 0.4);
  content: "";
  inset: 28px;
  pointer-events: none;
  position: absolute;
}

.launch-stage::after {
  inset: 42px;
  opacity: 0.35;
}

.launch-om-burst {
  color: rgba(255, 214, 126, 0.34);
  font-size: clamp(52px, 9vw, 142px);
  font-weight: 900;
  left: 50%;
  letter-spacing: 0;
  line-height: 1;
  max-width: min(88vw, 980px);
  opacity: 0;
  pointer-events: none;
  position: absolute;
  text-align: center;
  text-shadow: 0 0 30px rgba(255, 206, 93, 0.48);
  top: 28%;
  transform: translate(-50%, -50%) scale(0.18);
  white-space: normal;
  z-index: 2;
}

.launch-stage-active .launch-om-burst {
  animation: launchOmBurst 3.4s ease-out forwards;
}

.launch-blessing-2 {
  color: rgba(255, 244, 198, 0.36);
  top: 53%;
}

.launch-blessing-3 {
  color: rgba(215, 168, 79, 0.38);
  top: 75%;
}

.launch-stage-inner {
  align-items: center;
  display: grid;
  gap: 12px;
  justify-items: center;
  max-height: calc(100dvh - 122px);
  max-width: 920px;
  position: relative;
  text-align: center;
  z-index: 3;
}

.launch-logo-ring {
  align-items: center;
  animation: launchLogoFloat 3.6s ease-in-out infinite;
  background: #f8f4eb;
  border: 2px solid #d7a84f;
  border-radius: 999px;
  box-shadow: 0 0 0 12px rgba(215, 168, 79, 0.08);
  display: inline-flex;
  height: 108px;
  justify-content: center;
  overflow: hidden;
  width: 108px;
}

.launch-logo-ring img {
  height: 90px;
  object-fit: cover;
  width: 90px;
}

.launch-kicker {
  color: #d7a84f;
  font-weight: 800;
  margin: 0;
  text-transform: uppercase;
}

.launch-stage h1 {
  color: #fff;
  font-size: clamp(54px, 10vw, 124px);
  line-height: 0.9;
  margin: 0;
}

.launch-subtitle {
  color: #e7dfd0;
  font-size: clamp(18px, 2.4vw, 28px);
  margin: 0;
}

.launch-bell-button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 8px;
  color: #f8f4eb;
  cursor: pointer;
  display: grid;
  font-weight: 900;
  gap: 8px;
  justify-content: center;
  justify-items: center;
  min-height: 152px;
  min-width: 170px;
  padding: 0;
  position: relative;
}

.launch-bell-button:hover,
.launch-bell-button:focus-visible {
  filter: drop-shadow(0 0 24px rgba(255, 190, 75, 0.38));
}

.launch-bell-button:disabled {
  cursor: default;
  opacity: 0.78;
}

.temple-bell-wrap {
  align-items: center;
  display: inline-flex;
  height: 122px;
  justify-content: center;
  position: relative;
  width: 130px;
}

.temple-bell-wrap::before {
  background: radial-gradient(circle, rgba(255, 190, 75, 0.2), transparent 68%);
  content: "";
  inset: -32px;
  opacity: 0.78;
  position: absolute;
}

.temple-bell-rope {
  background:
    repeating-linear-gradient(90deg, #b72e22 0 4px, #f6c451 4px 8px),
    #b72e22;
  border-radius: 0 0 999px 999px;
  box-shadow: 0 0 0 2px rgba(255, 214, 126, 0.22);
  height: 44px;
  left: 50%;
  position: absolute;
  top: -12px;
  transform: translateX(-50%);
  width: 9px;
}

.temple-bell-rope::after {
  background: #b72e22;
  border: 2px solid #f6c451;
  border-radius: 999px;
  content: "";
  height: 18px;
  left: 50%;
  position: absolute;
  top: 34px;
  transform: translateX(-50%);
  width: 18px;
}

.temple-bell {
  bottom: 0;
  height: 98px;
  position: absolute;
  transform-origin: 50% 0;
  width: 112px;
}

.temple-bell-cap {
  background:
    radial-gradient(circle at 38% 28%, #fff4c4, transparent 26%),
    linear-gradient(135deg, #ffe184, #c98219 50%, #6b3c08);
  border: 2px solid rgba(255, 222, 135, 0.86);
  border-radius: 999px 999px 14px 14px;
  box-shadow: inset -10px -8px 16px rgba(74, 43, 9, 0.28);
  height: 26px;
  left: 50%;
  position: absolute;
  top: 2px;
  transform: translateX(-50%);
  width: 52px;
}

.temple-bell-body {
  background:
    radial-gradient(circle at 32% 22%, rgba(255, 246, 199, 0.96), transparent 16%),
    radial-gradient(ellipse at 50% 100%, rgba(50, 27, 5, 0.72), transparent 31%),
    linear-gradient(100deg, #6b3c08 0%, #c98219 14%, #ffd76f 34%, #bb7217 58%, #74430b 100%);
  border: 2px solid rgba(255, 222, 135, 0.84);
  border-radius: 60px 60px 18px 18px;
  box-shadow:
    inset 13px 0 20px rgba(255, 244, 196, 0.35),
    inset -18px -10px 24px rgba(63, 36, 6, 0.48),
    0 20px 40px rgba(0, 0, 0, 0.26);
  clip-path: polygon(29% 0, 71% 0, 93% 83%, 100% 93%, 0 93%, 7% 83%);
  height: 76px;
  left: 50%;
  position: absolute;
  top: 24px;
  transform: translateX(-50%);
  width: 100px;
}

.temple-bell-body::before {
  background:
    linear-gradient(90deg, transparent, rgba(255, 241, 181, 0.7), transparent),
    linear-gradient(90deg, #7a470b, #f0b743, #7a470b);
  border-radius: 999px;
  content: "";
  height: 8px;
  left: 50%;
  position: absolute;
  top: 54px;
  transform: translateX(-50%);
  width: 94px;
}

.temple-bell-lip {
  background:
    radial-gradient(ellipse at center, rgba(32, 18, 5, 0.92) 0 48%, transparent 52%),
    linear-gradient(90deg, #5f3306, #f7c659 28%, #b66b13 55%, #4c2a06);
  border: 2px solid rgba(255, 221, 132, 0.82);
  border-radius: 999px;
  bottom: 2px;
  height: 20px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 110px;
}

.temple-bell-clapper {
  background: radial-gradient(circle at 35% 30%, #fff0ba, #c27a19 58%, #5f3306);
  border: 1px solid rgba(255, 226, 150, 0.82);
  border-radius: 999px;
  bottom: -8px;
  height: 24px;
  left: 50%;
  position: absolute;
  transform: translateX(-50%);
  width: 24px;
}

.launch-bell-ringing .temple-bell {
  animation: launchBellRing 1.6s ease-in-out 2;
}

.launch-bell-ringing .temple-bell-clapper {
  animation: launchClapperRing 1.6s ease-in-out 2;
}

.launch-bell-ringing .launch-bell-button {
  filter: drop-shadow(0 0 42px rgba(255, 190, 75, 0.52));
}

.launch-sequence-line {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  justify-content: center;
  margin-top: 10px;
}

.launch-sequence-line span {
  background: rgba(248, 244, 235, 0.08);
  border: 1px solid rgba(215, 168, 79, 0.36);
  border-radius: 999px;
  color: #f8f4eb;
  opacity: 0.38;
  padding: 10px 14px;
}

.launch-stage-active .launch-sequence-line span {
  animation: launchStepReveal 0.75s ease forwards;
}

.launch-reveal-card {
  background: #f8f4eb;
  border: 1px solid #d7a84f;
  border-radius: 8px;
  color: #17211c;
  display: grid;
  gap: 6px;
  margin-top: 10px;
  max-width: 620px;
  opacity: 0;
  padding: 18px;
  transform: translateY(14px);
}

.launch-stage-active .launch-reveal-card {
  animation: launchCardReveal 0.9s ease 4.8s forwards;
}

.launch-reveal-card strong {
  font-size: 24px;
}

.launch-reveal-card span {
  color: #4e5b53;
  line-height: 1.5;
}

.launch-controls {
  bottom: 28px;
  left: 50%;
  min-height: 52px;
  position: fixed;
  transform: translateX(-50%);
  z-index: 6;
}

.launch-controls button,
.launch-skip-button {
  align-items: center;
  background: #d7a84f;
  border: 0;
  border-radius: 8px;
  color: #17211c;
  cursor: pointer;
  display: inline-flex;
  font-weight: 900;
  gap: 8px;
  justify-content: center;
  min-height: 48px;
  padding: 12px 18px;
}

.launch-skip-button {
  background: rgba(248, 244, 235, 0.1);
  color: #f8f4eb;
  position: absolute;
  right: 24px;
  top: 24px;
  z-index: 2;
}

@keyframes launchLogoFloat {
  0%,
  100% {
    transform: translateY(0) scale(1);
  }

  50% {
    transform: translateY(-8px) scale(1.02);
  }
}

@keyframes launchOmBurst {
  0% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.12);
  }

  24% {
    opacity: 1;
    text-shadow: 0 0 28px rgba(255, 206, 93, 0.58);
    transform: translate(-50%, -50%) scale(1);
  }

  56% {
    opacity: 0.46;
    transform: translate(-50%, -50%) scale(2.2);
  }

  100% {
    opacity: 0;
    transform: translate(-50%, -50%) scale(4.2);
  }
}

@keyframes launchBellRing {
  0%,
  100% {
    transform: rotate(0deg);
  }

  10% {
    transform: rotate(18deg);
  }

  22% {
    transform: rotate(-16deg);
  }

  35% {
    transform: rotate(11deg);
  }

  48% {
    transform: rotate(-9deg);
  }

  62% {
    transform: rotate(5deg);
  }

  78% {
    transform: rotate(-3deg);
  }
}

@keyframes launchClapperRing {
  0%,
  100% {
    transform: translateX(-50%);
  }

  10% {
    transform: translateX(-112%);
  }

  22% {
    transform: translateX(12%);
  }

  35% {
    transform: translateX(-92%);
  }

  48% {
    transform: translateX(-8%);
  }

  62% {
    transform: translateX(-66%);
  }

  78% {
    transform: translateX(-36%);
  }
}

@keyframes launchStepReveal {
  0% {
    opacity: 0.38;
    transform: translateY(8px);
  }

  100% {
    background: #d7a84f;
    color: #17211c;
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes launchCardReveal {
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.home-nav {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  max-width: 1180px;
  padding: 24px;
}

.home-brand,
.home-nav-actions,
.home-actions,
.home-kicker {
  align-items: center;
  display: flex;
}

.home-brand {
  gap: 12px;
}

.home-brand-logo {
  border-radius: 8px;
  height: 44px;
  object-fit: cover;
  width: 44px;
}

.home-brand small {
  color: #68756e;
  display: block;
}

.home-nav-actions {
  flex-wrap: wrap;
  gap: 12px;
  justify-content: flex-end;
}

.home-nav-actions a,
.home-secondary {
  color: #17211c;
  text-decoration: none;
}

.home-primary-link,
.home-cta {
  background: #17211c;
  border-radius: 8px;
  color: #fff !important;
  padding: 10px 14px;
  text-decoration: none;
}

.home-hero {
  align-items: center;
  display: grid;
  gap: 42px;
  grid-template-columns: minmax(0, 0.9fr) minmax(420px, 1fr);
  margin: 0 auto;
  max-width: 1180px;
  min-height: calc(100vh - 96px);
  padding: 24px 24px 72px;
}

.home-hero-logo {
  border-radius: 8px;
  display: block;
  height: 112px;
  margin-bottom: 24px;
  object-fit: cover;
  width: 112px;
}

.home-hero-copy h1 {
  font-size: 56px;
  line-height: 1;
  margin: 18px 0;
  max-width: 820px;
}

.home-hero-copy p {
  color: #4e5b53;
  font-size: 20px;
  line-height: 1.55;
  max-width: 720px;
}

.home-hero-copy .home-blessing-line {
  color: #34513f;
  font-size: 18px;
  margin-top: 14px;
}

.home-kicker {
  color: #34513f;
  gap: 8px;
}

.home-actions {
  gap: 14px;
  margin-top: 28px;
}

.village-pill-row {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-top: 18px;
}

.village-pill-row span {
  background: #f0eadc;
  border: 1px solid #e2ded3;
  border-radius: 999px;
  color: #34513f;
  padding: 8px 12px;
}

.home-cta {
  align-items: center;
  display: inline-flex;
  gap: 8px;
  padding: 14px 18px;
}

.family-hero-card {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  box-shadow: 0 24px 60px rgba(35, 32, 26, 0.12);
  overflow: hidden;
}

.family-hero-card > img {
  aspect-ratio: 16 / 10;
  display: block;
  object-fit: cover;
  width: 100%;
}

.family-hero-overlay {
  align-items: center;
  background: #ffffff;
  border-bottom: 1px solid #e2ded3;
  display: flex;
  justify-content: space-between;
  padding: 14px 18px;
}

.family-hero-overlay strong {
  background: #d7a84f;
  border-radius: 999px;
  padding: 7px 10px;
}

.portal-preview {
  padding: 18px;
}

.preview-header,
.preview-row {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.preview-header strong {
  background: #d7a84f;
  border-radius: 999px;
  padding: 7px 10px;
}

.preview-metrics {
  display: grid;
  gap: 10px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 18px;
}

.preview-metrics div,
.preview-mission,
.walkthrough-card,
.home-band div,
.launch-grid article {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  padding: 16px;
}

.preview-metrics span,
.preview-mission span {
  color: #68756e;
  display: block;
  margin-bottom: 6px;
}

.preview-metrics strong {
  font-size: 24px;
}

.preview-mission {
  margin-top: 12px;
}

.preview-progress {
  background: #e7e1d5;
  border-radius: 999px;
  height: 10px;
  margin-top: 14px;
  overflow: hidden;
}

.preview-progress span {
  background: #d7a84f;
  display: block;
  height: 100%;
}

.preview-row {
  color: #34513f;
  gap: 10px;
  justify-content: flex-start;
  margin-top: 14px;
}

.home-section,
.home-band {
  margin: 0 auto;
  max-width: 1180px;
  padding: 56px 24px;
}

.home-section-heading {
  max-width: 680px;
}

.home-section-heading span,
.interactive-section > div > span {
  color: #68756e;
}

.home-section h2 {
  font-size: 36px;
  line-height: 1.1;
  margin: 8px 0 22px;
}

.today-start-section {
  padding-top: 24px;
}

.today-start-section .home-section-heading p {
  color: #4e5b53;
  font-size: 18px;
  line-height: 1.55;
  margin: 0;
}

.today-step-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 24px;
}

.today-step-grid article,
.today-action-panel {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);
}

.today-step-grid article {
  padding: 18px;
}

.today-step-grid svg {
  color: #34513f;
}

.today-step-grid h3 {
  margin: 12px 0 8px;
}

.today-step-grid p {
  color: #4e5b53;
  line-height: 1.5;
  margin: 0;
}

.today-action-panel {
  align-items: center;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  margin-top: 16px;
  padding: 20px;
}

.today-action-panel strong,
.today-action-panel span {
  display: block;
}

.today-action-panel span {
  color: #4e5b53;
  line-height: 1.5;
  margin-top: 6px;
  max-width: 780px;
}

.launch-message-section {
  align-items: stretch;
  display: grid;
  gap: 18px;
  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.65fr);
  padding-top: 24px;
}

.launch-note-card,
.launch-message-list {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);
  padding: 24px;
}

.launch-note-card p {
  color: #4e5b53;
  font-size: 18px;
  line-height: 1.65;
  margin: 0;
}

.launch-note-card blockquote {
  border-left: 4px solid #d7a84f;
  color: #17211c;
  font-size: 22px;
  font-weight: 700;
  line-height: 1.45;
  margin: 24px 0 0;
  padding-left: 18px;
}

.launch-message-list {
  align-content: center;
  display: grid;
  gap: 12px;
}

.launch-message-list div {
  align-items: flex-start;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  color: #34513f;
  display: flex;
  gap: 10px;
  line-height: 1.5;
  padding: 14px;
}

.launch-message-list svg {
  flex: 0 0 auto;
  margin-top: 2px;
}

.village-section {
  align-items: center;
  display: grid;
  gap: 28px;
  grid-template-columns: minmax(0, 0.9fr) minmax(320px, 0.7fr);
}

.village-story > span {
  align-items: center;
  color: #34513f;
  display: inline-flex;
  gap: 8px;
}

.village-story h2 {
  max-width: 760px;
}

.village-story p {
  color: #4e5b53;
  font-size: 18px;
  line-height: 1.55;
  margin: 0;
  max-width: 780px;
}

.village-focus-grid {
  display: grid;
  gap: 12px;
}

.village-focus-grid div {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);
  padding: 16px;
}

.village-focus-grid strong,
.village-focus-grid span {
  display: block;
}

.village-focus-grid span {
  color: #4e5b53;
  line-height: 1.5;
  margin-top: 6px;
}

.market-section {
  padding-top: 24px;
}

.market-section .home-section-heading p {
  color: #4e5b53;
  font-size: 18px;
  line-height: 1.55;
  margin: 0;
}

.customer-segment-grid,
.pricing-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  margin-top: 24px;
}

.customer-segment-grid article,
.pricing-grid article,
.market-position-card,
.pricing-note {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);
}

.customer-segment-grid article,
.pricing-grid article {
  padding: 18px;
}

.customer-segment-grid svg {
  color: #34513f;
}

.customer-segment-grid h3,
.pricing-grid p,
.customer-segment-grid p {
  margin: 10px 0 0;
}

.customer-segment-grid p,
.pricing-grid p {
  color: #4e5b53;
  line-height: 1.5;
}

.market-position-card {
  align-items: center;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  margin-top: 16px;
  padding: 22px;
}

.market-position-card span,
.pricing-grid article > span {
  color: #68756e;
  display: block;
}

.market-position-card strong {
  display: block;
  font-size: 24px;
  margin-top: 6px;
}

.market-position-card p {
  color: #4e5b53;
  line-height: 1.55;
  margin: 8px 0 0;
  max-width: 760px;
}

.pricing-section {
  padding-top: 24px;
}

.pricing-grid {
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.pricing-grid article {
  display: grid;
  gap: 12px;
}

.pricing-grid strong {
  color: #17211c;
  font-size: 30px;
}

.pricing-grid ul {
  display: grid;
  gap: 10px;
  list-style: none;
  margin: 4px 0 0;
  padding: 0;
}

.pricing-grid li {
  align-items: center;
  color: #34513f;
  display: flex;
  gap: 8px;
}

.pricing-note {
  display: grid;
  gap: 6px;
  margin-top: 16px;
  padding: 18px;
}

.pricing-note span {
  color: #4e5b53;
  line-height: 1.5;
}

.home-snapshot-section {
  padding-top: 24px;
}

.home-snapshot-grid {
  display: grid;
  gap: 14px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
}

.home-snapshot-grid div {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);
  padding: 18px;
}

.home-snapshot-grid span {
  color: #68756e;
}

.home-snapshot-grid strong {
  color: #17211c;
  display: block;
  font-size: 30px;
  margin-top: 8px;
}

.family-gallery-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);
}

.family-gallery-grid figure {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);
  margin: 0;
  overflow: hidden;
}

.family-gallery-grid img {
  aspect-ratio: 16 / 9;
  display: block;
  object-fit: cover;
  width: 100%;
}

.family-gallery-grid figcaption {
  display: grid;
  gap: 4px;
  padding: 16px;
}

.family-gallery-grid figcaption span {
  color: #4e5b53;
}

.launch-grid,
.home-band,
.future-grid {
  display: grid;
  gap: 16px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
}

.launch-grid article svg,
.home-band svg,
.future-grid svg {
  color: #34513f;
}

.launch-grid h3,
.home-band strong,
.future-grid h3 {
  display: block;
  margin: 12px 0 8px;
}

.launch-grid p,
.home-band p,
.interactive-section p,
.future-grid p {
  color: #4e5b53;
  line-height: 1.5;
  margin: 0;
}

.future-grid article {
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  padding: 18px;
}

.future-grid article > span {
  background: #f0eadc;
  border-radius: 999px;
  color: #34513f;
  display: inline-flex;
  font-size: 13px;
  margin-top: 16px;
  padding: 6px 10px;
}

.interactive-section {
  align-items: center;
  display: grid;
  gap: 28px;
  grid-template-columns: minmax(0, 0.8fr) minmax(320px, 0.6fr);
}

.segmented-control {
  background: #ebe5d9;
  border-radius: 8px;
  display: inline-flex;
  gap: 4px;
  margin-top: 22px;
  padding: 4px;
}

.segmented-control button {
  background: transparent;
  border: 0;
  border-radius: 6px;
  cursor: pointer;
  padding: 10px 12px;
}

.segmented-control button.active {
  background: #ffffff;
}

.walkthrough-card ul {
  display: grid;
  gap: 12px;
  list-style: none;
  margin: 16px 0 0;
  padding: 0;
}

.walkthrough-card li {
  align-items: center;
  display: flex;
  gap: 10px;
}

.profile-form {
  align-items: end;
}

.account-security-section {
  background: #f4f8f4;
  border: 1px solid #bfd2c4;
  border-left: 4px solid #2f6947;
  border-radius: 6px;
  margin: 18px 0 24px;
  padding: 18px;
}

.account-security-section h3 {
  margin: 0 0 6px;
}

.security-form {
  align-items: end;
  margin-top: 14px;
}

.transaction-security-callout {
  align-items: center;
  background: #fff8e7;
  border: 1px solid #dfbf72;
  border-left: 5px solid #b98624;
  display: flex;
  gap: 18px;
  justify-content: space-between;
  margin-bottom: 18px;
  padding: 16px 18px;
}

.transaction-security-callout div {
  display: grid;
  gap: 4px;
}

.transaction-security-callout span {
  color: #4e5e55;
}

.transaction-security-callout .secondary-button {
  background: #173c29;
  border-color: #173c29;
  color: #ffffff;
  flex: 0 0 auto;
  font-weight: 700;
  text-decoration: none;
}

.home-app-note {
  color: #68756e;
  display: block;
  line-height: 1.5;
  margin-top: 10px;
}

.transaction-security-callout .secondary-button:hover,
.transaction-security-callout .secondary-button:focus-visible {
  background: #245c3f;
  border-color: #245c3f;
  color: #ffffff;
}

.payment-test-banner {
  align-items: center;
  background: #fff7dd;
  border: 1px solid #d7a84f;
  border-left: 4px solid #a26e11;
  border-radius: 6px;
  color: #57461f;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: 14px 0;
  padding: 11px 13px;
}

.payment-test-banner strong {
  color: #17211c;
}

.home-legal-footer {
  align-items: center;
  background: #111d17;
  color: #edf2ee;
  display: grid;
  gap: 24px;
  grid-template-columns: minmax(220px, 0.7fr) minmax(280px, 1.4fr) auto;
  margin-top: 34px;
  padding: 34px max(5vw, 28px);
}

.home-legal-footer > div:first-child {
  align-items: center;
  display: flex;
  gap: 12px;
}

.home-legal-footer img {
  background: #fff;
  border-radius: 6px;
  height: 52px;
  object-fit: contain;
  width: 52px;
}

.home-legal-footer strong,
.home-legal-footer span {
  display: block;
}

.home-legal-footer p {
  color: #c8d2cc;
  line-height: 1.65;
  margin: 0;
}

.home-legal-links {
  display: grid;
  gap: 9px;
  justify-items: end;
}

.home-legal-links a {
  color: #fff;
}

.legal-page {
  background: #f7f4ee;
  color: #17211c;
  min-height: 100vh;
}

.legal-header,
.legal-content,
.legal-page-footer {
  margin: 0 auto;
  max-width: 1120px;
  padding-left: 28px;
  padding-right: 28px;
}

.legal-header {
  padding-bottom: 48px;
  padding-top: 30px;
}

.legal-header img {
  display: block;
  height: 74px;
  margin: 54px 0 28px;
  object-fit: contain;
  width: 74px;
}

.legal-header > span,
.legal-identity-band span,
.legal-contact-band span {
  color: #6c5b32;
  display: block;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
}

.legal-header h1 {
  font-size: clamp(36px, 5vw, 64px);
  line-height: 1.02;
  margin: 10px 0 16px;
}

.legal-header p {
  color: #526158;
  font-size: 20px;
  margin: 0;
}

.legal-back-link {
  align-items: center;
  color: #17211c;
  display: inline-flex;
  gap: 8px;
}

.legal-identity-band {
  background: #17211c;
  color: #fff;
  display: grid;
  gap: 1px;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  padding: 0 max(calc((100vw - 1120px) / 2 + 28px), 28px);
}

.legal-identity-band div {
  border-left: 1px solid #38483f;
  min-width: 0;
  padding: 25px 20px;
}

.legal-identity-band div:last-child {
  border-right: 1px solid #38483f;
}

.legal-identity-band span {
  color: #d7b86e;
  margin-bottom: 7px;
}

.legal-identity-band strong {
  overflow-wrap: anywhere;
}

.legal-content {
  display: grid;
  gap: 0;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  padding-bottom: 58px;
  padding-top: 58px;
}

.legal-content article {
  border-bottom: 1px solid #dcd6ca;
  padding: 30px 34px 30px 0;
}

.legal-content article:nth-child(even) {
  border-left: 1px solid #dcd6ca;
  padding-left: 34px;
}

.legal-content article svg {
  color: #a26e11;
}

.legal-content h2 {
  font-size: 24px;
  margin: 14px 0 12px;
}

.legal-content p {
  color: #4f5e55;
  line-height: 1.68;
}

.legal-contact-band {
  align-items: center;
  background: #ead7a6;
  display: grid;
  gap: 26px;
  grid-template-columns: 0.7fr 1.5fr auto;
  padding: 30px max(calc((100vw - 1120px) / 2 + 28px), 28px);
}

.legal-contact-band p {
  line-height: 1.55;
  margin: 0;
}

.legal-contact-band a {
  background: #17211c;
  border-radius: 6px;
  color: #fff;
  padding: 12px 16px;
  white-space: nowrap;
}

.legal-page-footer {
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding-bottom: 32px;
  padding-top: 32px;
}

.legal-page-footer a {
  color: #17211c;
}

.legal-page-footer nav {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}

.policy-page {
  background: #f7f4ee;
  color: #17211c;
  min-height: 100vh;
}

.policy-page > header,
.policy-body,
.policy-page > footer {
  margin: 0 auto;
  max-width: 940px;
  padding-left: 28px;
  padding-right: 28px;
}

.policy-page > header {
  padding-bottom: 42px;
  padding-top: 30px;
}

.policy-page > header > a {
  align-items: center;
  color: #17211c;
  display: inline-flex;
  gap: 8px;
}

.policy-page > header img {
  display: block;
  height: 68px;
  margin: 50px 0 24px;
  object-fit: contain;
  width: 68px;
}

.policy-page > header span {
  color: #765a21;
  display: block;
  font-size: 13px;
  font-weight: 800;
  text-transform: uppercase;
}

.policy-page > header h1 {
  font-size: clamp(36px, 5vw, 58px);
  line-height: 1.05;
  margin: 10px 0 14px;
}

.policy-page > header p {
  color: #5b685f;
  margin: 0;
}

.policy-body {
  background: #fff;
  border-bottom: 1px solid #ded8cc;
  border-top: 1px solid #ded8cc;
  padding-bottom: 42px;
  padding-top: 42px;
}

.policy-body section + section {
  border-top: 1px solid #e5e0d6;
  margin-top: 28px;
  padding-top: 28px;
}

.policy-body h2 {
  font-size: 22px;
  margin: 0 0 10px;
}

.policy-body p {
  color: #4f5e55;
  line-height: 1.72;
  margin: 8px 0;
}

.policy-page > footer {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding-bottom: 34px;
  padding-top: 34px;
}

.policy-page > footer a {
  color: #17211c;
}

.account-deletion-form {
  display: grid;
  gap: 16px;
  max-width: 680px;
}

.account-deletion-form label {
  display: grid;
  gap: 7px;
  font-weight: 700;
}

.account-deletion-form textarea,
.account-deletion-form input {
  width: 100%;
}

.account-deletion-form button {
  width: fit-content;
}

@media (max-width: 760px) {
  .home-legal-footer,
  .legal-contact-band {
    grid-template-columns: 1fr;
  }

  .home-legal-links {
    justify-items: start;
  }

  .legal-identity-band,
  .legal-content {
    grid-template-columns: 1fr;
  }

  .legal-identity-band div,
  .legal-identity-band div:last-child {
    border-bottom: 1px solid #38483f;
    border-left: 0;
    border-right: 0;
  }

  .legal-content article,
  .legal-content article:nth-child(even) {
    border-left: 0;
    padding-left: 0;
    padding-right: 0;
  }

  .legal-page-footer {
    align-items: flex-start;
    flex-direction: column;
    gap: 10px;
  }

  .legal-page-footer nav {
    display: grid;
    gap: 10px;
  }
}

.form-section-title {
  border-top: 1px solid #e2ded3;
  color: #17211c;
  grid-column: 1 / -1;
  margin: 18px 0 0;
  padding-top: 18px;
}

.form-section-title:first-of-type {
  border-top: 0;
  margin-top: 0;
  padding-top: 0;
}

.nested-fieldset {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: grid;
  gap: 10px;
  padding: 12px;
}

.nested-fieldset strong {
  color: #17211c;
}

.nested-fieldset input {
  min-width: 0;
}

.relative-card {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: grid;
  gap: 14px;
  grid-column: 1 / -1;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  padding: 14px;
}

.relative-search {
  align-items: end;
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: grid;
  gap: 10px;
  grid-template-columns: minmax(0, 1fr) auto;
  padding: 12px;
}

.relative-search-results {
  display: grid;
  gap: 8px;
  grid-column: 1 / -1;
}

.relative-search-results button {
  align-items: center;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  color: #17211c;
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  padding: 10px;
  text-align: left;
}

.relative-search-results span {
  color: #4e5b53;
}

.relative-actions {
  align-items: center;
  background: #ffffff;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  padding: 10px;
}

.relative-actions span {
  color: #4e5b53;
  font-size: 13px;
}

.profile-help {
  background: #f8f6f1;
  border-left: 4px solid #d8a947;
  border-radius: 8px;
  margin: 0;
  padding: 12px;
}

.app-error-page {
  background: #f7f4ee;
  min-height: 100vh;
  padding: 40px;
}

.app-error-panel {
  margin: 0 auto;
  max-width: 760px;
}

.app-error-panel pre {
  background: #17211c;
  border-radius: 8px;
  color: #fff;
  overflow-x: auto;
  padding: 14px;
  white-space: pre-wrap;
}

.app-error-panel button {
  background: #17211c;
  border: 0;
  border-radius: 8px;
  color: #fff;
  cursor: pointer;
  padding: 12px 16px;
}

.tree-toolbar {
  background: #ebe5d9;
  border-radius: 8px;
  display: inline-flex;
  gap: 4px;
  padding: 4px;
}

.family-tabs {
  border-bottom: 1px solid #e2ded3;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin-bottom: 18px;
  padding-bottom: 12px;
}

.family-tabs button {
  background: transparent;
  border: 1px solid transparent;
  border-radius: 8px;
  color: #4e5b53;
  cursor: pointer;
  font-weight: 800;
  padding: 10px 14px;
}

.family-tabs button.active {
  background: #17211c;
  border-color: #17211c;
  color: #ffffff;
}

.family-history-panel {
  margin-top: 4px;
}

.tree-toolbar button {
  align-items: center;
  background: transparent;
  border: 0;
  border-radius: 6px;
  color: #17211c;
  cursor: pointer;
  display: inline-flex;
  gap: 8px;
  padding: 10px 12px;
}

.tree-toolbar button.active {
  background: #ffffff;
}

.family-tree-board {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: grid;
  gap: 0;
  margin-top: 18px;
  overflow-x: auto;
  padding: 18px;
}

.tree-level {
  display: grid;
  gap: 12px;
  min-width: 640px;
}

.tree-level-label {
  color: #4e5b53;
  font-size: 13px;
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
}

.tree-level-members {
  display: flex;
  gap: 14px;
  justify-content: center;
}

.tree-connector {
  background: #d8a947;
  height: 28px;
  justify-self: center;
  margin: 8px 0;
  width: 2px;
}

.tree-empty-node {
  background: #ffffff;
  border: 1px dashed #cfc8bc;
  border-radius: 8px;
  color: #4e5b53;
  min-width: 220px;
  padding: 18px;
  text-align: center;
}

.tree-register-header {
  align-items: center;
  display: flex;
  justify-content: space-between;
  margin-top: 24px;
}

.tree-register-header h2 {
  margin: 0;
}

.tree-register-header p {
  color: #4e5b53;
  margin: 6px 0 0;
}

.tree-register-header span {
  color: #4e5b53;
}

.whole-tree {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: flex;
  gap: 18px;
  margin-top: 14px;
  overflow-x: auto;
  padding: 18px;
}

.expanded-family-map {
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  margin-top: 14px;
  max-height: 780px;
  overflow: auto;
  padding: 18px;
}

.relationship-graph {
  min-height: 320px;
  min-width: 860px;
  position: relative;
}

.relationship-lines {
  inset: 0;
  pointer-events: none;
  position: absolute;
}

.relationship-line {
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2.5;
}

.parent-line {
  stroke: #d8a947;
}

.spouse-line {
  stroke: #805f1d;
  stroke-dasharray: 7 7;
}

.relationship-node {
  position: absolute;
  z-index: 1;
}

.relationship-node .tree-member-card.compact {
  height: 126px;
  min-width: 238px;
  width: 238px;
}

.generation-row {
  display: grid;
  gap: 14px;
  min-width: 980px;
}

.generation-label {
  align-items: baseline;
  display: flex;
  gap: 10px;
}

.generation-label strong {
  color: #17211c;
}

.generation-label span {
  color: #4e5b53;
  font-size: 13px;
}

.generation-units {
  align-items: flex-start;
  display: flex;
  gap: 18px;
}

.family-unit {
  background: #ffffff;
  border: 1px solid #ded8cc;
  border-radius: 8px;
  box-shadow: 0 10px 24px rgba(35, 32, 26, 0.06);
  min-width: 560px;
  padding: 14px;
}

.couple-row {
  align-items: stretch;
  display: flex;
  gap: 16px;
}

.couple-partner {
  align-items: center;
  display: flex;
  flex: 1;
  gap: 12px;
  min-width: 0;
}

.marriage-link {
  background: #efe6d2;
  border: 1px solid #d8a947;
  border-radius: 999px;
  color: #805f1d;
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 800;
  padding: 5px 8px;
  text-transform: uppercase;
}

.sibling-strip {
  border-top: 2px solid #d8a947;
  margin-top: 16px;
  padding-top: 14px;
  position: relative;
}

.sibling-strip::before {
  background: #d8a947;
  content: "";
  height: 14px;
  left: 50%;
  position: absolute;
  top: 0;
  transform: translate(-50%, -100%);
  width: 2px;
}

.sibling-label,
.unit-note {
  color: #4e5b53;
  display: block;
  font-size: 12px;
  font-weight: 800;
  margin-bottom: 10px;
  text-transform: uppercase;
}

.sibling-list {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
}

.child-bridge {
  align-items: center;
  background: #fbfaf7;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: flex;
  gap: 10px;
  padding: 10px;
}

.child-bridge .tree-member-card.compact {
  min-width: 210px;
  width: 230px;
}

.family-branch {
  align-items: center;
  display: inline-flex;
  flex-direction: column;
  gap: 14px;
}

.family-branch-children {
  border-top: 2px solid #d8a947;
  display: flex;
  gap: 14px;
  padding-top: 18px;
  position: relative;
}

.family-branch-children::before {
  background: #d8a947;
  content: "";
  height: 18px;
  left: 50%;
  position: absolute;
  top: 0;
  transform: translate(-50%, -100%);
  width: 2px;
}

.tree-grid {
  display: grid;
  gap: 12px;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  margin-top: 18px;
}

.tree-member-card {
  align-items: flex-start;
  background: #f8f6f1;
  border: 1px solid #e2ded3;
  border-radius: 8px;
  display: flex;
  gap: 12px;
  padding: 14px;
}

.tree-member-card.self {
  border-color: #d8a947;
  box-shadow: 0 0 0 2px rgba(216, 169, 71, 0.18);
}

.tree-member-card.muted {
  opacity: 0.72;
}

.tree-member-card.deceased {
  background: #f3f0e8;
  border-color: #c9bfae;
}

.tree-member-card.compact {
  min-width: 220px;
  width: 260px;
}

.tree-member-card h3,
.tree-member-card p {
  margin: 0;
}

.tree-member-card h3 {
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}

.memory-mark {
  background: #e9e1d1;
  border: 1px solid #c9bfae;
  border-radius: 999px;
  color: #615849;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0;
  line-height: 1;
  padding: 5px 7px;
  text-transform: uppercase;
}

.tree-member-card p,
.tree-member-card small {
  color: #4e5b53;
  display: block;
  line-height: 1.4;
  margin-top: 6px;
}

@media (max-width: 1120px) {
  .app-shell {
    grid-template-columns: 220px minmax(0, 1fr);
  }

  .main-panel {
    padding: 28px;
  }

  .metric-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .wallet-spotlight {
    grid-template-columns: 1fr;
  }

  .age-group-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .form-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .mission-financials {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lifecycle-strip,
  .sankalp-detail-grid,
  .kosh-filter-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .sankalp-team-row {
    grid-template-columns: 1fr;
  }

  .tree-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .home-hero {
    grid-template-columns: 1fr;
  }

  .customer-segment-grid,
  .pricing-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 820px) {
  .app-shell {
    grid-template-columns: 1fr;
  }

  .mobile-menu-button {
    display: none;
  }

  .sidebar-backdrop {
    background: rgba(23, 33, 28, 0.42);
    border: 0;
    bottom: 0;
    display: block;
    left: 0;
    opacity: 0;
    pointer-events: none;
    position: fixed;
    right: 0;
    top: 0;
    transition: opacity 0.18s ease;
    z-index: 20;
  }

  .sidebar {
    border-radius: 16px 16px 0 0;
    bottom: calc(64px + env(safe-area-inset-bottom));
    box-shadow: 0 -16px 40px rgba(23, 33, 28, 0.28);
    left: 0;
    max-height: min(76vh, 680px);
    max-width: none;
    overflow-y: auto;
    padding: 22px 18px calc(18px + env(safe-area-inset-bottom));
    position: fixed;
    top: auto;
    transform: translateY(110%);
    transition: transform 0.22s ease;
    width: 100%;
    z-index: 30;
  }

  .sidebar-open .sidebar {
    transform: translateY(0);
  }

  .sidebar-open .sidebar-backdrop {
    opacity: 1;
    pointer-events: auto;
  }

  .brand {
    margin-bottom: 18px;
  }

  .nav-list {
    gap: 12px;
  }

  .nav-section {
    display: grid;
  }

  .nav-section-title {
    display: block;
    padding: 0 4px 8px;
  }

  .nav-section .nav-link {
    display: flex;
    margin: 0;
    white-space: nowrap;
  }

  .nav-section .mobile-primary-duplicate {
    display: none;
  }

  .session-panel,
  .api-status {
    margin-top: 14px;
  }

  .metric-grid {
    grid-template-columns: 1fr;
  }

  .main-panel {
    min-height: 100dvh;
    padding-bottom: calc(92px + env(safe-area-inset-bottom));
  }

  .mobile-bottom-nav {
    align-items: stretch;
    background: rgba(255, 255, 255, 0.98);
    border-top: 1px solid #e2ddd2;
    bottom: 0;
    box-shadow: 0 -8px 24px rgba(23, 33, 28, 0.08);
    display: grid;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    left: 0;
    padding: 6px max(4px, env(safe-area-inset-left)) calc(6px + env(safe-area-inset-bottom)) max(4px, env(safe-area-inset-right));
    position: fixed;
    right: 0;
    z-index: 45;
  }

  .mobile-bottom-link {
    align-items: center;
    background: transparent;
    border: 0;
    border-radius: 6px;
    color: #617067;
    display: flex;
    flex-direction: column;
    font-family: inherit;
    font-size: 11px;
    font-weight: 700;
    gap: 3px;
    justify-content: center;
    letter-spacing: 0;
    min-height: 52px;
    min-width: 0;
    padding: 5px 2px;
    text-decoration: none;
  }

  .mobile-bottom-link.active {
    background: #f6efdf;
    color: #17211c;
  }

  .mobile-bottom-link svg {
    flex: 0 0 auto;
  }

  .mobile-more-button {
    cursor: pointer;
  }

  .mobile-quick-start {
    background: #17211c;
    border: 1px solid rgba(218, 164, 66, 0.38);
    border-radius: 8px;
    color: #fff;
    display: block;
    margin-bottom: 18px;
    padding: 18px;
  }

  .mobile-quick-start > div:first-child span {
    color: #e7bd66;
    display: block;
    font-size: 13px;
    font-weight: 800;
    margin-bottom: 4px;
  }

  .mobile-quick-start h2 {
    color: #fff;
    font-size: 22px;
    margin: 0 0 14px;
  }

  .mobile-quick-grid {
    display: grid;
    gap: 8px;
  }

  .mobile-quick-grid a {
    align-items: center;
    background: rgba(255, 255, 255, 0.09);
    border: 1px solid rgba(255, 255, 255, 0.12);
    border-radius: 6px;
    color: #fff;
    display: grid;
    gap: 11px;
    grid-template-columns: auto minmax(0, 1fr) auto;
    min-height: 58px;
    padding: 10px 12px;
    text-decoration: none;
  }

  .mobile-quick-grid a > span {
    min-width: 0;
  }

  .mobile-quick-grid strong,
  .mobile-quick-grid small {
    display: block;
  }

  .mobile-quick-grid strong {
    font-size: 16px;
  }

  .mobile-quick-grid small {
    color: #d5ddd8;
    font-size: 12px;
    margin-top: 2px;
  }

  .featured-sankalp-list .featured-sankalp-card:nth-child(n + 3) {
    display: none;
  }

  .dashboard-grid,
  .snapshot-grid,
  .age-group-grid,
  .vision-chart-band,
  .history-event,
  .home-snapshot-grid {
    grid-template-columns: 1fr;
  }

  .form-grid {
    grid-template-columns: 1fr;
  }

  .wide-field {
    grid-column: span 1;
  }

  .mission-financials {
    grid-template-columns: 1fr;
  }

  .lifecycle-strip,
  .sankalp-detail-grid,
  .kosh-filter-row {
    grid-template-columns: 1fr;
  }

  .section-heading-row,
  .compact-row {
    align-items: stretch;
    flex-direction: column;
  }

  .compact-row span {
    text-align: left;
  }

  .member-row,
  .invite-row,
  .ledger-row {
    align-items: stretch;
    flex-direction: column;
  }

  .ledger-member {
    text-align: left;
  }

  .row-actions {
    flex-wrap: wrap;
  }

  .relative-card {
    grid-template-columns: 1fr;
  }

  .relative-search {
    align-items: stretch;
    grid-template-columns: 1fr;
  }

  .relative-search-results button {
    align-items: flex-start;
    flex-direction: column;
  }

  .tree-grid {
    grid-template-columns: 1fr;
  }

  .tree-toolbar {
    display: flex;
  }

  .whole-tree {
    align-items: flex-start;
  }

  .member-summary {
    align-items: flex-start;
  }

  .project-card-header {
    flex-direction: column;
  }

  .main-panel {
    padding: 24px;
  }

  .home-nav,
  .home-nav-actions,
  .home-actions {
    align-items: flex-start;
    flex-direction: column;
  }

  .home-hero,
  .launch-message-section,
  .today-step-grid,
  .interactive-section,
  .village-section,
  .launch-grid,
  .home-band,
  .future-grid,
  .family-gallery-grid,
  .contribute-project-grid,
  .customer-segment-grid,
  .pricing-grid,
  .proposal-grid,
  .sabha-rule-grid {
    grid-template-columns: 1fr;
  }

  .market-position-card {
    align-items: stretch;
    flex-direction: column;
  }

  .amount-preset-row {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .home-hero {
    min-height: auto;
  }

  .launch-stage {
    padding: 18px;
  }

  .launch-stage::before {
    inset: 14px;
  }

  .launch-stage::after {
    inset: 24px;
  }

  .launch-logo-ring {
    height: 104px;
    width: 104px;
  }

  .launch-logo-ring img {
    height: 86px;
    width: 86px;
  }

  .home-hero-copy h1 {
    font-size: 42px;
  }

  .home-hero-logo {
    height: 88px;
    width: 88px;
  }

  .preview-metrics {
    grid-template-columns: 1fr;
  }

  .today-action-panel {
    align-items: stretch;
    flex-direction: column;
  }

  .vision-chart-copy h2 {
    font-size: 26px;
  }

  .vision-cloud {
    justify-content: flex-start;
    min-height: auto;
  }

  .vision-chip {
    transform: none;
  }
}

@media (max-width: 640px) {
  :root {
    font-size: 15px;
  }

  .sidebar {
    border-bottom: 0;
    max-height: calc(100dvh - 76px - env(safe-area-inset-bottom));
    overflow-y: auto;
  }

  .brand-mark {
    height: 36px;
    width: 36px;
  }

  .main-panel {
    padding: 18px 14px 82px;
  }

  .metric-grid {
    display: flex;
    gap: 10px;
    margin-left: -14px;
    margin-right: -14px;
    overflow-x: auto;
    padding: 0 14px 8px;
    scroll-snap-type: x proximity;
  }

  .metric-grid .metric-card {
    flex: 0 0 min(44vw, 180px);
    scroll-snap-align: start;
  }

  .vision-chart-band,
  .mobile-deferred-section {
    display: none;
  }

  .page-header {
    margin-bottom: 18px;
  }

  .page-header h1 {
    font-size: 32px;
  }

  .page-header p {
    font-size: 16px;
  }

  .content-band {
    padding: 16px;
  }

  .transaction-security-callout {
    align-items: stretch;
    flex-direction: column;
  }

  .wallet-spotlight {
    padding: 18px;
  }

  .wallet-spotlight strong {
    font-size: 38px;
  }

  .feedback-dialog {
    padding: 20px;
  }

  .feedback-dialog.celebration {
    padding: 18px 16px 20px;
  }

  .feedback-dialog.celebration h2 {
    font-size: 25px;
  }

  .feedback-celebration-stage {
    margin-bottom: -5px;
    margin-top: -12px;
    transform: scale(0.88);
  }

  .feedback-amount {
    font-size: 35px;
  }

  .feedback-actions {
    flex-direction: column;
  }

  .vision-chart-band {
    padding: 18px;
  }

  .vision-chart-band::after {
    inset: 8px;
  }

  .vision-chart-copy h2 {
    font-size: 24px;
  }

  .vision-chip {
    font-size: 14px;
    padding: 9px 11px;
  }

  .metric-card {
    padding: 14px;
  }

  .metric-card strong {
    font-size: 22px;
  }

  .age-group-card strong {
    font-size: 24px;
  }

  .form-grid {
    gap: 12px;
  }

  .form-grid button,
  .secondary-button,
  .button-row .secondary-button {
    justify-content: center;
    width: 100%;
  }

  .button-row {
    display: grid;
  }

  .copy-box,
  .family-hero-overlay,
  .preview-row,
  .tree-register-header {
    align-items: stretch;
    flex-direction: column;
  }

  .copy-box button {
    width: 100%;
  }

  .family-tabs,
  .tree-toolbar {
    display: flex;
    gap: 8px;
    margin-left: -16px;
    margin-right: -16px;
    overflow-x: auto;
    padding: 0 16px 8px;
  }

  .family-tabs button,
  .tree-toolbar button {
    flex: 0 0 auto;
  }

  .expanded-family-map {
    margin-left: -16px;
    margin-right: -16px;
    max-height: 68vh;
    padding: 12px;
  }

  .relationship-graph {
    transform-origin: top left;
  }

  .tree-member-card,
  .member-row,
  .ledger-row,
  .featured-sankalp-card,
  .project-card {
    padding: 12px;
  }

  .featured-sankalp-card {
    grid-template-columns: 1fr;
  }

  .tree-member-card.compact {
    min-width: 210px;
    width: 230px;
  }

  .project-summary {
    display: grid;
    grid-template-columns: 1fr;
  }

  .project-summary span {
    border-radius: 8px;
  }

  .row-actions select,
  .row-actions button,
  .kosh-filter-row button {
    width: 100%;
  }

  .home-nav {
    padding: 16px 14px;
  }

  .home-nav-actions {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .home-nav-actions a {
    align-items: center;
    background: #f0eadc;
    border-radius: 8px;
    display: flex;
    min-height: 40px;
    padding: 8px 10px;
  }

  .home-primary-link {
    justify-content: center;
  }

  .home-hero {
    gap: 24px;
    padding: 12px 14px 42px;
  }

  .home-hero-copy h1 {
    font-size: 36px;
    line-height: 1.05;
  }

  .home-hero-copy p {
    font-size: 17px;
  }

  .home-actions {
    align-items: stretch;
    width: 100%;
  }

  .home-cta,
  .home-secondary {
    justify-content: center;
    text-align: center;
  }

  .pricing-grid strong {
    font-size: 26px;
  }

  .portal-preview,
  .launch-message-copy,
  .village-story {
    padding: 14px;
  }

  .launch-sequence-line {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    width: 100%;
  }

  .launch-sequence-line span {
    padding: 9px;
  }

  .launch-reveal-card {
    padding: 14px;
  }
}
.trust-contribution-panel,
.reconciliation-panel {
  overflow: hidden;
}

.trust-badge {
  padding: 8px 12px;
  border: 1px solid #d9ae4c;
  border-radius: 999px;
  color: #6d5218;
  background: #fff9e9;
  font-weight: 700;
  white-space: nowrap;
}

.direct-payment-layout {
  display: grid;
  grid-template-columns: minmax(300px, 0.85fr) minmax(360px, 1.15fr);
  gap: 20px;
  margin-top: 20px;
}

.bank-destination-card,
.self-declaration-form {
  border: 1px solid #ded8ca;
  border-radius: 8px;
  padding: 20px;
  background: #faf8f3;
}

.bank-destination-card {
  display: grid;
  grid-template-columns: 240px 1fr;
  gap: 24px;
  align-items: start;
}

.bank-qr-image,
.bank-qr-placeholder {
  width: 240px;
  aspect-ratio: 1;
  border: 1px solid #d8d1c2;
  border-radius: 6px;
  background: #fff;
  object-fit: contain;
}

.bank-qr-placeholder {
  display: grid;
  place-content: center;
  gap: 4px;
  text-align: center;
  color: #6b706d;
}

.bank-qr-placeholder strong {
  font-size: 32px;
}

.bank-destination-card h3,
.self-declaration-form h3,
.declaration-history h3,
.reconciliation-declarations h3 {
  margin: 4px 0 14px;
  font-size: 20px;
}

.bank-destination-card dl {
  display: grid;
  gap: 8px;
  margin: 0 0 16px;
}

.bank-destination-card dl div {
  display: grid;
  grid-template-columns: 72px 1fr;
  gap: 8px;
}

.bank-destination-card dt {
  color: #67706b;
}

.bank-destination-card dd {
  margin: 0;
  font-weight: 700;
  overflow-wrap: anywhere;
}

.upi-amount-field {
  display: grid;
  gap: 7px;
  margin: 14px 0;
  font-weight: 700;
}

.upi-amount-suggestions {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
}

.upi-amount-suggestions button {
  min-height: 42px;
  padding: 8px;
  border: 1px solid #d9cfc7;
  background: #fffaf8;
  color: #542f34;
  font-weight: 700;
}

.upi-amount-suggestions button.selected {
  border-color: #a84f61;
  background: #f8e8ec;
  color: #7f2e40;
  box-shadow: 0 0 0 2px rgb(168 79 97 / 12%);
}

.upi-direct-note {
  display: block;
  margin-top: 10px;
  color: #69716d;
  line-height: 1.45;
}

.contribution-guidance-card ol {
  display: grid;
  gap: 10px;
  margin: 14px 0;
  padding-left: 22px;
  color: #50484a;
  line-height: 1.5;
}

.upi-amount-field small {
  color: #69716d;
  font-size: 13px;
  font-weight: 400;
}

.transferred-amount-summary {
  display: grid;
  grid-column: 1 / -1;
  gap: 5px;
  padding: 13px 14px;
  border: 1px solid #d8c48d;
  border-radius: 6px;
  background: #fffaf0;
}

.transferred-amount-summary span {
  color: #69716d;
  font-size: 13px;
}

.transferred-amount-summary strong {
  font-size: 20px;
}

.primary-link-button {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 42px;
  padding: 10px 16px;
  border-radius: 6px;
  background: #17251f;
  color: #fff;
  text-decoration: none;
}

.self-declaration-form,
.reconciliation-form {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}

.self-declaration-form h3,
.self-declaration-form .attestation-check,
.self-declaration-form > button,
.self-declaration-form > small {
  grid-column: 1 / -1;
}

.self-declaration-form label,
.reconciliation-form label {
  display: grid;
  gap: 7px;
}

.self-declaration-form label > span {
  color: #69716d;
  font-size: 13px;
}

.attestation-check {
  grid-template-columns: 22px 1fr !important;
  align-items: start;
  padding: 12px;
  border: 1px solid #d8c48d;
  border-radius: 6px;
  background: #fffaf0;
}

.attestation-check input {
  width: 18px;
  height: 18px;
  margin-top: 2px;
}

.declaration-history,
.reconciliation-declarations {
  margin-top: 24px;
}

.declaration-history article,
.reconciliation-declarations article {
  display: grid;
  grid-template-columns: minmax(180px, 1.4fr) minmax(160px, 1fr);
  gap: 10px 18px;
  padding: 13px 0;
  border-top: 1px solid #e5dfd3;
}

.declaration-history article > div,
.reconciliation-declarations article > div {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
}

.declaration-history em,
.reconciliation-declarations em {
  justify-self: end;
  padding: 4px 8px;
  border-radius: 999px;
  background: #eee9df;
  color: #5d625f;
  font-size: 12px;
  font-style: normal;
  text-transform: capitalize;
}

.declaration-history em.reconciled,
.reconciliation-declarations em.reconciled {
  color: #1f6b45;
  background: #e4f4e9;
}

.declaration-history em.flagged,
.reconciliation-declarations em.flagged {
  color: #8b3f31;
  background: #fae8e3;
}

.reconciliation-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
  margin: 20px 0;
}

.reconciliation-metrics > div {
  display: grid;
  gap: 6px;
  padding: 16px;
  border: 1px solid #ded8ca;
  border-radius: 7px;
  background: #faf8f3;
}

.reconciliation-metrics strong {
  font-size: 24px;
}

.reconciliation-metrics .matched {
  border-color: #8dbb9c;
  background: #edf8f0;
}

.reconciliation-metrics .mismatch {
  border-color: #d7a48e;
  background: #fff3ee;
}

.reconciliation-form {
  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;
  align-items: end;
  padding: 16px;
  border: 1px solid #ded8ca;
  border-radius: 7px;
}

.reconciliation-declarations article {
  grid-template-columns: minmax(180px, 1.2fr) 120px minmax(130px, 1fr) 110px auto;
  align-items: center;
}

.reconciliation-alert {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin: 0 0 18px;
  padding: 14px 16px;
  border: 1px solid #b7d5c0;
  border-radius: 7px;
  background: #edf8f0;
  color: #1f5e3d;
}

.reconciliation-alert.warning { border-color: #ddb276; background: #fff6e5; color: #755017; }
.reconciliation-alert.error { border-color: #ddb0a6; background: #fff0ed; color: #8b3429; }
.reconciliation-alert button { flex: 0 0 auto; padding: 7px 11px; }
.icon-text-button { display: inline-flex; align-items: center; gap: 7px; }
.declaration-review-list { display: grid; gap: 14px; }

.declaration-review-card {
  padding: 18px;
  border: 1px solid #ddd6c8;
  border-radius: 7px;
  background: #fcfbf8;
}

.declaration-review-summary {
  display: grid;
  grid-template-columns: repeat(5, minmax(120px, 1fr)) auto;
  gap: 14px;
  align-items: start;
  padding-bottom: 16px;
  border-bottom: 1px solid #e5dfd3;
}

.declaration-review-summary > div,
.correction-preview { display: grid; gap: 5px; }
.declaration-review-summary span,
.correction-preview span { color: #66706b; font-size: 13px; }
.declaration-review-summary strong { overflow-wrap: anywhere; font-size: 15px; }
.declaration-review-summary em { padding: 5px 9px; border-radius: 999px; background: #eee9df; color: #5d625f; font-size: 12px; font-style: normal; text-transform: capitalize; }
.declaration-review-summary em.reconciled { background: #e4f4e9; color: #1f6b45; }

.declaration-review-fields {
  display: grid;
  grid-template-columns: repeat(3, minmax(160px, 1fr)) minmax(140px, 0.7fr) auto;
  gap: 12px;
  align-items: end;
  padding-top: 16px;
}

.declaration-review-fields label { display: grid; gap: 7px; }
.correction-preview { min-height: 44px; padding: 10px 12px; border: 1px solid #b7d5c0; border-radius: 6px; background: #edf8f0; }
.correction-preview.debit { border-color: #ddb0a6; background: #fff0ed; color: #8b3429; }
.correction-preview.credit { color: #1f6b45; }

.member-kosh-credit-panel { margin-top: 18px; }
.member-kosh-credit-form {
  display: grid;
  grid-template-columns: minmax(220px, 1.35fr) minmax(180px, 0.75fr) minmax(210px, 1fr);
  gap: 14px;
  align-items: end;
  margin-top: 18px;
}
.member-kosh-credit-form label,
.member-credit-search { display: grid; gap: 7px; }
.member-credit-search { position: relative; }
.member-credit-search label { display: flex; align-items: center; gap: 7px; }
.member-credit-results {
  position: absolute;
  z-index: 8;
  top: calc(100% + 6px);
  right: 0;
  left: 0;
  display: grid;
  padding: 6px;
  border: 1px solid var(--nyas-line, #ded8ca);
  border-radius: 7px;
  background: #fff;
  box-shadow: 0 16px 36px rgba(52, 41, 45, 0.14);
}
.member-credit-results button {
  display: grid;
  gap: 2px;
  padding: 11px 12px;
  border: 0;
  border-radius: 6px;
  background: transparent;
  color: inherit;
  text-align: left;
}
.member-credit-results button:hover,
.member-credit-results button:focus-visible { background: var(--nyas-surface-soft, #faf8f3); }
.member-credit-results span { color: var(--nyas-muted, #66706b); font-size: 13px; }
.member-credit-note { grid-column: 1 / 3; }
.member-kosh-credit-form > button { display: inline-flex; align-items: center; justify-content: center; gap: 7px; }
.member-credit-dialog-backdrop {
  position: fixed;
  z-index: 120;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 20px;
  background: rgba(39, 29, 33, 0.52);
  backdrop-filter: blur(5px);
}
.member-credit-dialog {
  width: min(100%, 520px);
  padding: 28px;
  border: 1px solid var(--nyas-line, #ded8ca);
  border-radius: 8px;
  background: #fff;
  box-shadow: 0 30px 80px rgba(40, 28, 33, 0.25);
  text-align: center;
}
.member-credit-dialog h2 { margin: 7px 0 14px; }
.member-credit-review-amount { display: block; margin: 12px 0; color: var(--nyas-forest, #183b2d); font-size: clamp(36px, 8vw, 54px); line-height: 1.1; }
.member-credit-dialog p { color: var(--nyas-muted, #66706b); }
.member-credit-reference { display: grid; gap: 4px; margin: 18px 0; padding: 12px; border-radius: 7px; background: var(--nyas-surface-soft, #faf8f3); }
.member-credit-reference span { color: var(--nyas-muted, #66706b); font-size: 13px; }
.member-credit-dialog-actions { display: grid; grid-template-columns: 1fr 1.35fr; gap: 10px; margin-top: 22px; }

@media (max-width: 760px) {
  .direct-payment-layout,
  .reconciliation-metrics,
  .self-declaration-form,
  .reconciliation-form {
    grid-template-columns: 1fr;
  }

  .bank-destination-card {
    grid-template-columns: 1fr;
    padding: 14px;
  }

  .bank-qr-image,
  .bank-qr-placeholder {
    width: min(100%, 340px);
    justify-self: center;
  }

  .bank-destination-card dl div {
    grid-template-columns: 1fr;
    gap: 2px;
  }

  .self-declaration-form h3,
  .transferred-amount-summary,
  .self-declaration-form .attestation-check,
  .self-declaration-form > button,
  .self-declaration-form > small {
    grid-column: auto;
  }

  .reconciliation-declarations article,
  .declaration-history article {
    grid-template-columns: 1fr;
  }

  .declaration-review-summary,
  .declaration-review-fields { grid-template-columns: 1fr; }
  .member-kosh-credit-form,
  .member-credit-dialog-actions { grid-template-columns: 1fr; }
  .member-credit-note { grid-column: auto; }
  .declaration-review-card { padding: 14px; }
  .reconciliation-alert { align-items: flex-start; flex-direction: column; }

  .declaration-history em,
  .reconciliation-declarations em {
    justify-self: start;
  }

  .trust-badge {
    white-space: normal;
  }
}

/* Premium family theme */
:root {
  --nyas-ink: #34292d;
  --nyas-muted: #77676d;
  --nyas-canvas: #fff9f7;
  --nyas-surface: #ffffff;
  --nyas-surface-soft: #fcf5f6;
  --nyas-line: #eadde1;
  --nyas-sage: #fbedef;
  --nyas-sage-strong: #f4dce1;
  --nyas-leaf: #c98591;
  --nyas-forest: #8e4352;
  --nyas-gold: #c99668;
  --nyas-sun: #fff2ea;
  --nyas-sky: #f5edf1;
  --nyas-blush: #f9e5e8;
  --nyas-petal: #f4e9ed;
  --nyas-shadow: 0 12px 34px rgba(92, 54, 66, 0.075);
  --nyas-shadow-raised: 0 18px 46px rgba(92, 54, 66, 0.13);
  color: var(--nyas-ink);
  background: var(--nyas-canvas);
}

html {
  background: var(--nyas-canvas);
  scroll-behavior: smooth;
}

body {
  background:
    linear-gradient(180deg, rgba(251, 237, 239, 0.62) 0, rgba(255, 249, 247, 0) 260px),
    var(--nyas-canvas);
  color: var(--nyas-ink);
}

button,
a,
input,
select,
textarea {
  -webkit-tap-highlight-color: transparent;
}

button,
a {
  transition: background-color 180ms ease, border-color 180ms ease, color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

button:focus-visible,
a:focus-visible,
input:focus-visible,
select:focus-visible,
textarea:focus-visible {
  outline: 3px solid rgba(201, 133, 145, 0.28);
  outline-offset: 2px;
}

.sidebar {
  background: rgba(255, 255, 255, 0.96);
  border-right: 1px solid var(--nyas-line);
  box-shadow: 10px 0 34px rgba(92, 54, 66, 0.055);
  color: var(--nyas-ink);
}

.brand {
  border-bottom: 1px solid var(--nyas-line);
  padding: 0 8px 22px;
}

.brand strong {
  color: var(--nyas-forest);
  font-size: 19px;
}

.sidebar .brand small {
  color: var(--nyas-muted);
}

.brand-mark {
  background: var(--nyas-sun);
  border: 1px solid #ead5c5;
  box-shadow: 0 8px 20px rgba(201, 150, 104, 0.16);
  overflow: hidden;
}

.brand-mark img {
  height: 100%;
  object-fit: cover;
  width: 100%;
}

.nav-list {
  gap: 22px;
}

.nav-section-title {
  color: #849089;
}

.nav-link {
  color: #4f5d56;
  min-height: 44px;
}

.nav-icon {
  align-items: center;
  background: var(--nyas-surface-soft);
  border: 1px solid transparent;
  border-radius: 8px;
  display: inline-flex;
  height: 30px;
  justify-content: center;
  width: 30px;
}

.nav-link:hover {
  background: #fdf4f6;
  color: var(--nyas-forest);
  transform: translateX(2px);
}

.nav-link.active {
  background: var(--nyas-sage);
  color: var(--nyas-forest);
  font-weight: 750;
}

.nav-link.active .nav-icon {
  background: rgba(255, 255, 255, 0.82);
  border-color: #edd8dd;
  color: var(--nyas-leaf);
  box-shadow: 0 5px 14px rgba(142, 67, 82, 0.1);
}

.nav-link-planned,
.nav-link-planned:hover {
  color: #87918b;
}

.nav-link small {
  background: var(--nyas-sun);
  color: #805d1c;
}

.session-panel,
.api-status {
  background: var(--nyas-surface-soft);
  border-color: var(--nyas-line);
  color: var(--nyas-ink);
}

.session-panel span,
.session-panel a,
.session-panel button {
  color: var(--nyas-ink);
}

.session-panel strong {
  color: var(--nyas-gold);
}

.session-panel small,
.api-status small {
  color: var(--nyas-muted);
}

.api-status.connected span {
  color: #3d7b59;
}

.main-panel {
  animation: nyasPageIn 420ms cubic-bezier(.2, .8, .2, 1) both;
  background: transparent;
}

.page-header span {
  color: var(--nyas-leaf);
  font-weight: 750;
}

.page-header h1 {
  color: var(--nyas-ink);
}

.page-header p,
.content-band p,
.project-card-header p,
.metric-card span {
  color: var(--nyas-muted);
}

.metric-card,
.content-band,
.login-panel,
.project-card,
.featured-sankalp-card,
.age-group-card,
.bank-destination-card,
.self-declaration-form,
.declaration-review-card {
  background: rgba(255, 255, 255, 0.96);
  border-color: var(--nyas-line);
  box-shadow: var(--nyas-shadow);
}

.metric-card {
  overflow: hidden;
  position: relative;
  transition: transform 200ms ease, box-shadow 200ms ease;
}

.metric-card::before {
  background: var(--nyas-sage-strong);
  content: "";
  height: 4px;
  inset: 0 0 auto;
  position: absolute;
}

.metric-card:nth-child(2)::before { background: #f0dce2; }
.metric-card:nth-child(3)::before { background: #ead0d7; }
.metric-card:nth-child(4)::before { background: #eed9c8; }
.metric-card:nth-child(5)::before { background: #e7d8df; }

.metric-card:hover,
.content-band:hover {
  box-shadow: var(--nyas-shadow-raised);
  transform: translateY(-2px);
}

.metric-card strong {
  color: var(--nyas-forest);
}

.content-band {
  transition: box-shadow 220ms ease, transform 220ms ease;
}

.mobile-quick-start,
.vision-chart-band,
.wallet-spotlight {
  background: var(--nyas-sage);
  border: 1px solid #edd8dd;
  color: var(--nyas-ink);
}

.mobile-quick-start > div:first-child span,
.vision-chart-copy span,
.wallet-spotlight span {
  color: var(--nyas-gold);
}

.mobile-quick-start h2,
.vision-chart-copy h2,
.wallet-spotlight strong,
.wallet-spotlight-metrics span {
  color: var(--nyas-forest);
}

.mobile-quick-grid a,
.wallet-spotlight-metrics {
  background: rgba(255, 255, 255, 0.78);
  border-color: rgba(142, 67, 82, 0.14);
  color: var(--nyas-ink);
}

.mobile-quick-grid small,
.vision-chart-copy p,
.wallet-spotlight p {
  color: var(--nyas-muted);
}

.vision-chart-band::after {
  border-color: rgba(142, 67, 82, 0.16);
}

.vision-chip {
  background: rgba(255, 255, 255, 0.82);
  border-color: rgba(142, 67, 82, 0.18);
  color: var(--nyas-forest);
  box-shadow: 0 6px 16px rgba(92, 54, 66, 0.07);
  animation: nyasFloat 7s ease-in-out infinite;
}

.vision-chip:nth-child(3n + 2) {
  animation-delay: -2.1s;
  background: var(--nyas-sun);
}

.vision-chip:nth-child(3n) {
  animation-delay: -4.2s;
  background: var(--nyas-sky);
}

.featured-sankalp-card,
.project-card {
  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;
}

.featured-sankalp-card:hover,
.project-card:hover {
  border-color: #e1c5cc;
  box-shadow: var(--nyas-shadow-raised);
  transform: translateY(-2px);
}

.sankalp-number,
.lifecycle-strip strong {
  background: var(--nyas-sun);
  color: #73531a;
}

.project-summary span,
.compact-row,
.lifecycle-strip div,
.next-step-card {
  background: var(--nyas-surface-soft);
  border-color: var(--nyas-line);
}

.project-card-header > span,
.status-pill {
  background: var(--nyas-sage);
  border: 1px solid #ead0d6;
  color: var(--nyas-forest);
}

.progress-track {
  background: #f3e9ec;
}

.progress-track div {
  background: var(--nyas-leaf);
  border-radius: inherit;
  transition: width 700ms cubic-bezier(.2, .8, .2, 1);
}

.primary-link-button,
.kosh-filter-row button,
button[type="submit"] {
  background: var(--nyas-forest);
  color: white;
}

.primary-link-button:hover,
.kosh-filter-row button:hover,
button[type="submit"]:hover {
  background: #7b3947;
  box-shadow: 0 10px 24px rgba(142, 67, 82, 0.2);
  transform: translateY(-1px);
}

.bank-qr-image {
  border-color: #ead0d6;
  box-shadow: 0 10px 24px rgba(92, 54, 66, 0.09);
}

.trust-badge,
.attestation-check,
.next-step-card {
  background: var(--nyas-sun);
  border-color: #ead2c2;
  color: #76513d;
}

.feedback-overlay {
  background: rgba(76, 48, 57, 0.22);
  backdrop-filter: blur(8px);
}

.feedback-dialog {
  border-color: var(--nyas-line);
  box-shadow: 0 28px 80px rgba(92, 54, 66, 0.19);
}

.mobile-bottom-nav {
  background: rgba(255, 255, 255, 0.94) !important;
  border-color: var(--nyas-line) !important;
  backdrop-filter: blur(18px);
}

.mobile-bottom-link.active {
  background: var(--nyas-sage) !important;
  color: var(--nyas-forest) !important;
}

/* The ceremonial welcome stays luminous so it belongs to the light family theme. */
.launch-stage {
  background:
    radial-gradient(circle at 50% 38%, rgba(201, 150, 104, 0.24), transparent 25%),
    linear-gradient(145deg, var(--nyas-canvas), var(--nyas-sun) 50%, var(--nyas-sage));
  color: var(--nyas-ink);
}

.launch-stage::before,
.launch-stage::after {
  border-color: rgba(201, 150, 104, 0.36);
}

.launch-stage h1 {
  color: var(--nyas-forest);
  text-shadow: 0 8px 24px rgba(142, 67, 82, 0.1);
}

.launch-subtitle,
.launch-bell-button,
.launch-sequence-line span,
.launch-skip-button {
  color: var(--nyas-ink);
}

.launch-logo-ring {
  background: white;
  border-color: var(--nyas-gold);
  box-shadow: 0 0 0 12px rgba(201, 150, 104, 0.14), var(--nyas-shadow-raised);
}

.launch-om-burst,
.launch-blessing-2,
.launch-blessing-3 {
  color: rgba(142, 67, 82, 0.32);
  text-shadow: 0 0 30px rgba(201, 150, 104, 0.38);
}

.launch-sequence-line span,
.launch-skip-button {
  background: rgba(255, 255, 255, 0.66);
  border: 1px solid rgba(201, 150, 104, 0.28);
  box-shadow: 0 6px 18px rgba(92, 54, 66, 0.07);
}

.launch-reveal-card {
  background: rgba(255, 255, 255, 0.9);
  border-color: rgba(201, 150, 104, 0.36);
  box-shadow: var(--nyas-shadow-raised);
}

.launch-controls button {
  background: var(--nyas-gold);
  color: #432f35;
  box-shadow: 0 12px 30px rgba(201, 150, 104, 0.24);
}

.login-page {
  background:
    radial-gradient(circle at 18% 18%, rgba(201, 150, 104, 0.2), transparent 30%),
    radial-gradient(circle at 82% 78%, rgba(245, 237, 241, 0.82), transparent 34%),
    linear-gradient(145deg, var(--nyas-canvas), var(--nyas-sage));
}

.login-panel {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid var(--nyas-line);
  border-radius: 8px;
  box-shadow: 0 28px 80px rgba(92, 54, 66, 0.16);
  overflow: hidden;
  position: relative;
}

.login-panel::before {
  background: linear-gradient(90deg, var(--nyas-forest), var(--nyas-leaf), var(--nyas-gold));
  content: "";
  height: 4px;
  inset: 0 0 auto;
  position: absolute;
}

.login-panel .brand-mark {
  background: var(--nyas-sun);
  border: 1px solid #ecd9a7;
  box-shadow: 0 8px 20px rgba(201, 150, 104, 0.14);
  color: var(--nyas-forest);
}

@keyframes nyasPageIn {
  from { opacity: 0; transform: translateY(8px); }
  to { opacity: 1; transform: translateY(0); }
}

@keyframes nyasFloat {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-4px); }
}

@media (max-width: 900px) {
  .sidebar {
    box-shadow: 16px 0 42px rgba(92, 54, 66, 0.13);
  }

  .mobile-menu-button {
    background: rgba(255, 255, 255, 0.96);
    border: 1px solid var(--nyas-line);
    box-shadow: 0 8px 22px rgba(92, 54, 66, 0.11);
    color: var(--nyas-forest);
  }
}

@media (max-width: 640px) {
  body {
    background: var(--nyas-canvas);
  }

  .metric-card:hover,
  .content-band:hover,
  .featured-sankalp-card:hover,
  .project-card:hover {
    transform: none;
  }

  .mobile-quick-start {
    box-shadow: var(--nyas-shadow);
  }

  .mobile-quick-grid a:active,
  .mobile-bottom-link:active {
    transform: scale(0.97);
  }
}

@media (prefers-reduced-motion: reduce) {
  html { scroll-behavior: auto; }
  *, *::before, *::after {
    animation-duration: 0.01ms !important;
    animation-iteration-count: 1 !important;
    scroll-behavior: auto !important;
    transition-duration: 0.01ms !important;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,uGAAuG;EACvG,eAAe;AACjB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,SAAS;AACX;;AAEA,qBAAqB,mBAAmB,EAAE,cAAc,EAAE,iBAAiB,EAAE;AAC7E,oBAAoB,mBAAmB,EAAE,aAAa,EAAE,8BAA8B,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC/I,sBAAsB,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE,SAAS,EAAE,qBAAqB,EAAE;AAC5G,mCAAmC,gBAAgB,EAAE;AACrD,kDAAkD,YAAY,EAAE,mBAAmB,EAAE,WAAW,EAAE;AAClG,kDAAkD,cAAc,EAAE;AAClE,0BAA0B,cAAc,EAAE,eAAe,EAAE;AAC3D,qBAAqB,mBAAmB,EAAE,aAAa,EAAE,SAAS,EAAE,2CAA2C,EAAE,cAAc,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,uBAAuB,EAAE;AAChM,uBAAuB,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,QAAQ,EAAE;AACvG,wBAAwB,8CAA8C,EAAE,eAAe,EAAE,iBAAiB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AACpJ,uBAAuB,cAAc,EAAE,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC/G,uBAAuB,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,6CAA6C,EAAE,WAAW,EAAE,oBAAoB,EAAE,eAAe,EAAE,gBAAgB,EAAE,SAAS,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,eAAe,EAAE,qBAAqB,EAAE,uDAAuD,EAAE;AACjW,6BAA6B,8CAA8C,EAAE,2BAA2B,EAAE;AAC1G,wBAAwB,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC3F,0BAA0B,0DAA0D,EAAE,yBAAyB,EAAE,mBAAmB,EAAE,4CAA4C,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,kBAAkB,EAAE;AACpP,sBAAsB,mBAAmB,EAAE,aAAa,EAAE,QAAQ,EAAE,SAAS,EAAE,kBAAkB,EAAE,SAAS,EAAE,2BAA2B,EAAE;AAC3I,uCAAuC,mBAAmB,EAAE,oBAAoB,EAAE,WAAW,EAAE,WAAW,EAAE;AAC5G,sCAAsC,mBAAmB,EAAE,kBAAkB,EAAE,WAAW,EAAE,UAAU,EAAE;AACxG,gCAAgC,cAAc,EAAE,aAAa,EAAE,sBAAsB,EAAE,mBAAmB,EAAE,YAAY,EAAE;AAC1H,oEAAoE,cAAc,EAAE,kBAAkB,EAAE;AACxG,kCAAkC,cAAc,EAAE,gBAAgB,EAAE;AACpE,mCAAmC,8CAA8C,EAAE,eAAe,EAAE,eAAe,EAAE;AACrH,0BAA0B,aAAa,EAAE,QAAQ,EAAE,8BAA8B,EAAE,gBAAgB,EAAE;AACrG,+BAA+B,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,cAAc,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AAC7L,uBAAuB,mBAAmB,EAAE,kBAAkB,EAAE,WAAW,EAAE,eAAe,EAAE,gBAAgB,EAAE,gBAAgB,EAAE,aAAa,EAAE,kBAAkB,EAAE;AACrK,yBAAyB,mBAAmB,EAAE,kBAAkB,EAAE;AAClE,4FAA4F,iBAAiB,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AACtJ,iCAAiC,cAAc,EAAE,gBAAgB,EAAE;AACnE,+BAA+B,8CAA8C,EAAE,eAAe,EAAE,kBAAkB,EAAE;AACpH,sBAAsB,aAAa,EAAE,SAAS,EAAE,gDAAgD,EAAE,gBAAgB,EAAE,UAAU,EAAE;AAChI,yBAAyB,uBAAuB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,SAAS,EAAE,iBAAiB,EAAE,aAAa,EAAE;AAClL,wBAAwB,mBAAmB,EAAE,mBAAmB,EAAE,kBAAkB,EAAE,WAAW,EAAE,aAAa,EAAE,cAAc,EAAE,YAAY,EAAE,uBAAuB,EAAE;AACzK,uDAAuD,cAAc,EAAE;AACvE,2BAA2B,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE;AAC/E,sBAAsB,aAAa,EAAE,SAAS,EAAE,gDAAgD,EAAE,kBAAkB,EAAE;AACtH,2BAA2B,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,QAAQ,EAAE,uBAAuB,EAAE;AACpI,sBAAsB,kBAAkB,EAAE,gBAAgB,EAAE,gCAAgC,EAAE,6BAA6B,EAAE,aAAa,EAAE,SAAS,EAAE,uDAAuD,EAAE,cAAc,EAAE,iBAAiB,EAAE,kBAAkB,EAAE;AACvQ,6BAA6B,mBAAmB,EAAE,cAAc,EAAE,aAAa,EAAE,gBAAgB,EAAE,QAAQ,EAAE;AAC7G,yBAAyB,8CAA8C,EAAE,eAAe,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAClI,wBAAwB,cAAc,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAC5E,uBAAuB,yBAAyB,EAAE,eAAe,EAAE;AACnE,uBAAuB,aAAa,EAAE,SAAS,EAAE;AACjD,+BAA+B,uBAAuB,EAAE,mBAAmB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,aAAa,EAAE,SAAS,EAAE,aAAa,EAAE;AACrK,qCAAqC,cAAc,EAAE,cAAc,EAAE,eAAe,EAAE;AACtF,yDAAyD,cAAc,EAAE;AACzE,4BAA4B,cAAc,EAAE,gBAAgB,EAAE,eAAe,EAAE;AAC/E,wBAAwB,mBAAmB,EAAE,gBAAgB,EAAE;AAC/D,uBAAuB,mBAAmB,EAAE,6BAA6B,EAAE,aAAa,EAAE,SAAS,EAAE,aAAa,EAAE;AACpH,yBAAyB,cAAc,EAAE,OAAO,EAAE,SAAS,EAAE;AAC7D,yBAAyB,cAAc,EAAE,qBAAqB,EAAE;;AAEhE;EACE,oBAAoB,kBAAkB,EAAE;EACxC,mCAAmC,eAAe,EAAE;EACpD,qBAAqB,SAAS,EAAE,0BAA0B,EAAE,uBAAuB,EAAE;EACrF,qBAAqB,kBAAkB,EAAE;EACzC,uBAAuB,uBAAuB,EAAE;EAChD,wBAAwB,eAAe,EAAE;EACzC,uBAAuB,eAAe,EAAE;EACxC,uBAAuB,WAAW,EAAE;EACpC,0BAA0B,oBAAoB,EAAE,gBAAgB,EAAE,WAAW,EAAE;EAC/E,2CAA2C,0BAA0B,EAAE;EACvE,sBAAsB,SAAS,EAAE,0BAA0B,EAAE,kBAAkB,EAAE;EACjF,yBAAyB,eAAe,EAAE;EAC1C,wBAAwB,qBAAqB,EAAE;EAC/C,+BAA+B,eAAe,EAAE;EAChD,2BAA2B,2BAA2B,EAAE;EACxD,uBAAuB,uBAAuB,EAAE,eAAe,EAAE;AACnE;;AAEA;EACE,eAAe;AACjB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,iBAAiB;AACnB;;AAEA;;;;EAIE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;AACrB;;AAEA;;;EAGE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,oCAAoC;EACpC,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,aAAa;AACf;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;;;;;EAKE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,cAAc;EACd,eAAe;EACf,QAAQ;EACR,gBAAgB;EAChB,UAAU;EACV,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,oFAAoF;EACpF,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,6CAA6C;EAC7C,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,gCAAgC;EAChC,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;;EAIE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,2CAA2C;AAC7C;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;;EAGE,cAAc;EACd,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,QAAQ;AACV;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,qBAAqB;EACrB,qBAAqB;EACrB,SAAS;EACT,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA,4BAA4B,cAAc,EAAE;;AAE5C;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,6BAA6B;AAC/B;;AAEA,wBAAwB,SAAS,EAAE;;AAEnC;;EAEE,yBAAyB;EACzB,mBAAmB;EACnB,aAAa;AACf;;AAEA;;EAEE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;+CAC+C,mBAAmB,EAAE;;AAEpE;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA,iCAAiC,kBAAkB,EAAE;;AAErD;EACE,cAAc;EACd,cAAc;EACd,iCAAiC;EACjC,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA,iCAAiC,SAAS,EAAE;;AAE5C;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,6BAA6B;AAC/B;;AAEA,iCAAiC,cAAc,EAAE;AACjD,iCAAiC,SAAS,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;;AAEjF;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iCAAiC;EACjC,SAAS;AACX;;AAEA;EACE,8BAA8B,kBAAkB,EAAE;EAClD,+BAA+B,0BAA0B,EAAE;AAC7D;;AAEA;EACE,sBAAsB,0BAA0B,EAAE;EAClD,sBAAsB,oBAAoB,EAAE,sBAAsB,EAAE;AACtE;;AAEA,gCAAgC;AAChC;EACE,6BAA6B;AAC/B;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,6DAA6D;EAC7D,gBAAgB;AAClB;;AAEA;;;EAGE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gEAAgE;EAChE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,aAAa;EACb,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,QAAQ;EACR,oCAAoC;EACpC,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,iBAAiB;AACnB;;AAEA;;EAEE,gBAAgB;EAChB,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;EAClB;AACF;AACA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,sEAAsE;EACtE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,WAAW;EACb;AACF;;AAEA;EACE,mBAAmB;EACnB,qDAAqD;EACrD,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,SAAS;EACT,4DAA4D;EAC5D,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,iCAAiC;EACjC,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,qCAAqC;EACrC,2CAA2C;EAC3C,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB;;WAES;EACT,cAAc;EACd,aAAa;EACb,SAAS;EACT,4DAA4D;EAC5D,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,SAAS;EACT,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,0CAA0C;EAC1C,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,uCAAuC;EACvC,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;EACT,qDAAqD;EACrD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,mCAAmC;EACnC,qBAAqB;AACvB;;AAEA;EACE;IACE,4CAA4C;EAC9C;;EAEA;IACE,8CAA8C;EAChD;;EAEA;IACE,8CAA8C;EAChD;AACF;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,cAAc;EACd,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kCAAkC;EAClC,SAAS;EACT,aAAa;EACb,uBAAuB;EACvB,OAAO;EACP,aAAa;EACb,eAAe;EACf,QAAQ;EACR,MAAM;EACN,WAAW;EACX,iDAAiD;AACnD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,0EAA0E;AAC5E;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6BAA6B;EAC7B,iFAAiF;EACjF,SAAS;EACT,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,YAAY;EACZ,iDAAiD;AACnD;;AAEA;EACE,wCAAwC;EACxC,sBAAsB;EACtB,WAAW;EACX,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,cAAc;EACd,aAAa;EACb,8CAA8C;EAC9C,eAAe;EACf,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,2EAA2E;AAC7E;;AAEA;EACE,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,0EAA0E;AAC5E;;AAEA,qCAAqC,UAAU,EAAE,SAAS,EAAE,yBAAyB,EAAE;AACvF,qCAAqC,UAAU,EAAE,QAAQ,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AAC7G,qCAAqC,UAAU,EAAE,MAAM,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AAC5G,qCAAqC,WAAW,EAAE,MAAM,EAAE,wBAAwB,EAAE,sBAAsB,EAAE;AAC5G,qCAAqC,WAAW,EAAE,QAAQ,EAAE,wBAAwB,EAAE,sBAAsB,EAAE;AAC9G,qCAAqC,WAAW,EAAE,SAAS,EAAE,wBAAwB,EAAE,sBAAsB,EAAE;AAC/G,qCAAqC,SAAS,EAAE,SAAS,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AAC9G,qCAAqC,UAAU,EAAE,SAAS,EAAE,wBAAwB,EAAE,sBAAsB,EAAE;AAC9G,qCAAqC,YAAY,EAAE,UAAU,EAAE,0BAA0B,EAAE,sBAAsB,EAAE;AACnH,sCAAsC,YAAY,EAAE,WAAW,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;AACpH,sCAAsC,SAAS,EAAE,UAAU,EAAE,0BAA0B,EAAE,sBAAsB,EAAE;AACjH,sCAAsC,SAAS,EAAE,WAAW,EAAE,yBAAyB,EAAE,sBAAsB,EAAE;;AAEjH;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,aAAa;EACb,wDAAwD;AAC1D;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;EACE,OAAO,UAAU,EAAE,uCAAuC,EAAE;EAC5D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE,KAAK,UAAU,EAAE,qCAAqC,EAAE;EACxD,MAAM,UAAU,EAAE,mCAAmC,EAAE;EACvD,OAAO,UAAU,EAAE,6BAA6B,EAAE;AACpD;;AAEA;EACE,KAAK,aAAa,EAAE,sBAAsB,EAAE;EAC5C,YAAY,UAAU,EAAE,sBAAsB,EAAE;AAClD;;AAEA;EACE,OAAO,UAAU,EAAE,gBAAgB,EAAE,UAAU,EAAE;EACjD,KAAK,UAAU,EAAE,aAAa,EAAE,QAAQ,EAAE;AAC5C;;AAEA;EACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;EAChD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE;;;;;;IAME,eAAe;EACjB;AACF;;AAEA;EACE;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,6BAA6B;IAC7B,iBAAiB;IACjB,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,QAAQ;EACV;;EAEA;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,uBAAuB;EACvB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,SAAS;EACT,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,8BAA8B;EAC9B,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;;;EAGE,yBAAyB;EACzB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,QAAQ;EACR,iBAAiB;EACjB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;EACT,YAAY;EACZ,gBAAgB;EAChB,mCAAmC;EACnC,YAAY;EACZ,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,uCAAuC;EACvC,SAAS;EACT,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,kFAAkF;EAClF,2BAA2B;AAC7B;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,sBAAsB;EACtB,cAAc;EACd,YAAY;EACZ,cAAc;EACd,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,oBAAoB;EACpB,eAAe;EACf,WAAW;EACX,UAAU;EACV,mDAAmD;EACnD,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;;;EAGE,cAAc;EACd,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,cAAc;EACd,YAAY;EACZ,uBAAuB;EACvB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;;EAGE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gCAAgC;EAChC,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,QAAQ;EACR,uBAAuB;EACvB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,yCAAyC;EACzC,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;AACf;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,gBAAgB;EAChB,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;EAClB,8CAA8C;EAC9C,QAAQ;EACR,4CAA4C;EAC5C,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,gCAAgC;EAChC,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,qBAAqB;EACrB,gCAAgC;EAChC,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,oDAAoD;EACpD,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,+CAA+C;EAC/C,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;EACT,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,cAAc;EACd,mCAAmC;EACnC,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,gBAAgB;EAChB,QAAQ;EACR,uBAAuB;EACvB,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;;EAEE,sDAAsD;AACxD;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,aAAa;EACb,uBAAuB;EACvB,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,6EAA6E;EAC7E,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE;;WAES;EACT,8BAA8B;EAC9B,+CAA+C;EAC/C,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,UAAU;EACV,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,kBAAkB;EAClB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE;;0DAEwD;EACxD,2CAA2C;EAC3C,oCAAoC;EACpC,uDAAuD;EACvD,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE;;;4FAG0F;EAC1F,2CAA2C;EAC3C,kCAAkC;EAClC;;;mCAGiC;EACjC,kEAAkE;EAClE,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE;;qDAEmD;EACnD,oBAAoB;EACpB,WAAW;EACX,WAAW;EACX,SAAS;EACT,kBAAkB;EAClB,SAAS;EACT,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE;;sEAEoE;EACpE,2CAA2C;EAC3C,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,YAAY;AACd;;AAEA;EACE,6EAA6E;EAC7E,2CAA2C;EAC3C,oBAAoB;EACpB,YAAY;EACZ,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,sDAAsD;AACxD;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,0CAA0C;EAC1C,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,+CAA+C;AACjD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE,mDAAmD;AACrD;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,2BAA2B;EAC3B,UAAU;AACZ;;AAEA;;EAEE,mBAAmB;EACnB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,QAAQ;EACR,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;AACZ;;AAEA;EACE;;IAEE,iCAAiC;EACnC;;EAEA;IACE,uCAAuC;EACzC;AACF;;AAEA;EACE;IACE,UAAU;IACV,4CAA4C;EAC9C;;EAEA;IACE,UAAU;IACV,8CAA8C;IAC9C,yCAAyC;EAC3C;;EAEA;IACE,aAAa;IACb,2CAA2C;EAC7C;;EAEA;IACE,UAAU;IACV,2CAA2C;EAC7C;AACF;;AAEA;EACE;;IAEE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;;IAEE,2BAA2B;EAC7B;;EAEA;IACE,4BAA4B;EAC9B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,2BAA2B;EAC7B;AACF;;AAEA;EACE;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;IACnB,cAAc;IACd,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;;;;EAIE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,qBAAqB;AACvB;;AAEA;;EAEE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,0DAA0D;EAC1D,cAAc;EACd,iBAAiB;EACjB,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,cAAc;EACd,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;;;;;EAKE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,SAAS;EACT,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;EACT,2DAA2D;EAC3D,iBAAiB;AACnB;;AAEA;;EAEE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;;;;EAIE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;AAChD;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,sDAAsD;AACxD;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,aAAa;EACb,SAAS;EACT,gDAAgD;AAClD;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;;;EAGE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;;;EAIE,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,SAAS;EACT,qEAAqE;EACrE,gBAAgB;EAChB,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,WAAW;AACb;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;;;EAGE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,QAAQ;EACR,gDAAgD;EAChD,uDAAuD;AACzD;;AAEA;EACE,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,MAAM;EACN,gDAAgD;EAChD,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,SAAS;EACT,uCAAuC;EACvC,0DAA0D;AAC5D;;AAEA;EACE,iBAAiB;EACjB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,iBAAiB;AACnB;;AAEA;;;EAGE,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,iCAAiC;EACjC,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,gCAAgC;EAChC,6BAA6B;EAC7B,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;EACtB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;;IAEE,gCAAgC;IAChC,cAAc;IACd,eAAe;EACjB;;EAEA;;IAEE,cAAc;IACd,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,aAAa;IACb,SAAS;EACX;AACF;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,gDAAgD;EAChD,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,0CAA0C;EAC1C,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,aAAa;EACb,8BAA8B;EAC9B,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,8BAA8B;EAC9B,aAAa;AACf;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,SAAS;EACT,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,aAAa;AACf;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB;EACpB,QAAQ;EACR,YAAY;AACd;;AAEA;EACE,gCAAgC;EAChC,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,uBAAuB;EACvB,6BAA6B;EAC7B,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,MAAM;EACN,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,oBAAoB;EACpB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;EAC1B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,QAAQ;EACR,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,OAAO;EACP,SAAS;EACT,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,iCAAiC;EACjC,UAAU;AACZ;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,6BAA6B;EAC7B,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,MAAM;EACN,iCAAiC;EACjC,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;;EAEE,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;;EAEE,cAAc;EACd,cAAc;EACd,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,2CAA2C;EAC7C;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gDAAgD;EAClD;;EAEA;;;IAGE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;IAEE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kCAAkC;IAClC,SAAS;IACT,SAAS;IACT,cAAc;IACd,OAAO;IACP,UAAU;IACV,oBAAoB;IACpB,eAAe;IACf,QAAQ;IACR,MAAM;IACN,8BAA8B;IAC9B,WAAW;EACb;;EAEA;IACE,4BAA4B;IAC5B,gDAAgD;IAChD,+CAA+C;IAC/C,OAAO;IACP,4BAA4B;IAC5B,eAAe;IACf,gBAAgB;IAChB,2DAA2D;IAC3D,eAAe;IACf,SAAS;IACT,2BAA2B;IAC3B,gCAAgC;IAChC,WAAW;IACX,WAAW;EACb;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,UAAU;IACV,oBAAoB;EACtB;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,wDAAwD;EAC1D;;EAEA;IACE,oBAAoB;IACpB,qCAAqC;IACrC,6BAA6B;IAC7B,SAAS;IACT,8CAA8C;IAC9C,aAAa;IACb,gDAAgD;IAChD,OAAO;IACP,6HAA6H;IAC7H,eAAe;IACf,QAAQ;IACR,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,cAAc;IACd,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,eAAe;IACf,gBAAgB;IAChB,QAAQ;IACR,uBAAuB;IACvB,iBAAiB;IACjB,gBAAgB;IAChB,YAAY;IACZ,gBAAgB;IAChB,qBAAqB;EACvB;;EAEA;IACE,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,0CAA0C;IAC1C,kBAAkB;IAClB,WAAW;IACX,cAAc;IACd,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,cAAc;IACd,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;IACb,QAAQ;EACV;;EAEA;IACE,mBAAmB;IACnB,qCAAqC;IACrC,2CAA2C;IAC3C,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,SAAS;IACT,+CAA+C;IAC/C,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;EACvB;;EAEA;IACE,YAAY;EACd;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,cAAc;IACd,eAAe;IACf,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;;;IAME,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;IAGE,0BAA0B;EAC5B;;EAEA;;IAEE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;;;IAGE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;;;IAGE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;;;;;;;;;;;;;;IAcE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,gDAAgD;EAClD;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,aAAa;IACb,YAAY;EACd;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,2BAA2B;IAC3B,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,gBAAgB;IAChB,6DAA6D;IAC7D,gBAAgB;EAClB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,SAAS;IACT,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,6BAA6B;EAC/B;;EAEA;IACE,0BAA0B;IAC1B,wBAAwB;EAC1B;;EAEA;;IAEE,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,sBAAsB;EACxB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,SAAS;EACX;;EAEA;;;IAGE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;;IAEE,aAAa;IACb,QAAQ;IACR,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;IAEE,cAAc;EAChB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;;;;;IAKE,aAAa;EACf;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,gBAAgB;IAChB,YAAY;EACd;;EAEA;IACE,aAAa;IACb,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;;;IAGE,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,uBAAuB;EACzB;;EAEA;IACE,SAAS;IACT,uBAAuB;EACzB;;EAEA;IACE,eAAe;IACf,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,oBAAoB;IACpB,WAAW;EACb;;EAEA;;IAEE,uBAAuB;IACvB,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;;;IAGE,aAAa;EACf;;EAEA;IACE,aAAa;IACb,gDAAgD;IAChD,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,aAAa;EACf;AACF;AACA;;EAEE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,oBAAoB;EACpB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kEAAkE;EAClE,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;;EAEE,YAAY;EACZ,eAAe;EACf,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,+BAA+B;EAC/B,QAAQ;AACV;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;;EAEE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;;;;EAIE,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0CAA0C;EAC1C,kBAAkB;EAClB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,8DAA8D;EAC9D,cAAc;EACd,eAAe;EACf,6BAA6B;AAC/B;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,eAAe;AACjB;;AAEA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,0BAA0B;AAC5B;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;EACT,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,aAAa;EACb,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;EAC/E,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,gCAAgC,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC5F,8BAA8B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AAC1F,+BAA+B,cAAc,EAAE,iBAAiB,EAAE;AAClE,oBAAoB,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AACzE,2BAA2B,aAAa,EAAE,SAAS,EAAE;;AAErD;EACE,aAAa;EACb,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;sBACsB,aAAa,EAAE,QAAQ,EAAE;AAC/C;2BAC2B,cAAc,EAAE,eAAe,EAAE;AAC5D,qCAAqC,uBAAuB,EAAE,eAAe,EAAE;AAC/E,iCAAiC,gBAAgB,EAAE,oBAAoB,EAAE,mBAAmB,EAAE,cAAc,EAAE,eAAe,EAAE,kBAAkB,EAAE,0BAA0B,EAAE;AAC/K,4CAA4C,mBAAmB,EAAE,cAAc,EAAE;;AAEjF;EACE,aAAa;EACb,8EAA8E;EAC9E,SAAS;EACT,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,mCAAmC,aAAa,EAAE,QAAQ,EAAE;AAC5D,sBAAsB,gBAAgB,EAAE,kBAAkB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,mBAAmB,EAAE;AAChI,4BAA4B,qBAAqB,EAAE,mBAAmB,EAAE,cAAc,EAAE;AACxF,6BAA6B,cAAc,EAAE;;AAE7C,4BAA4B,gBAAgB,EAAE;AAC9C;EACE,aAAa;EACb,qFAAqF;EACrF,SAAS;EACT,gBAAgB;EAChB,gBAAgB;AAClB;AACA;wBACwB,aAAa,EAAE,QAAQ,EAAE;AACjD,wBAAwB,kBAAkB,EAAE;AAC5C,8BAA8B,aAAa,EAAE,mBAAmB,EAAE,QAAQ,EAAE;AAC5E;EACE,kBAAkB;EAClB,UAAU;EACV,qBAAqB;EACrB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,YAAY;EACZ,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;AAChD;AACA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;EAClB,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;AACA;8CAC8C,6CAA6C,EAAE;AAC7F,8BAA8B,iCAAiC,EAAE,eAAe,EAAE;AAClF,sBAAsB,kBAAkB,EAAE;AAC1C,oCAAoC,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB,EAAE,QAAQ,EAAE;AAClH;EACE,eAAe;EACf,YAAY;EACZ,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,2CAA2C;EAC3C,kBAAkB;EAClB,gBAAgB;EAChB,8CAA8C;EAC9C,kBAAkB;AACpB;AACA,2BAA2B,kBAAkB,EAAE;AAC/C,+BAA+B,cAAc,EAAE,cAAc,EAAE,kCAAkC,EAAE,iCAAiC,EAAE,gBAAgB,EAAE;AACxJ,0BAA0B,iCAAiC,EAAE;AAC7D,2BAA2B,aAAa,EAAE,QAAQ,EAAE,cAAc,EAAE,aAAa,EAAE,kBAAkB,EAAE,6CAA6C,EAAE;AACtJ,gCAAgC,iCAAiC,EAAE,eAAe,EAAE;AACpF,gCAAgC,aAAa,EAAE,iCAAiC,EAAE,SAAS,EAAE,gBAAgB,EAAE;;AAE/G;EACE;;;;IAIE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;IAC1B,aAAa;EACf;;EAEA;;IAEE,uBAAuB;IACvB,oBAAoB;EACtB;;EAEA;IACE,0BAA0B;IAC1B,QAAQ;EACV;;EAEA;;;;;IAKE,iBAAiB;EACnB;;EAEA;;IAEE,0BAA0B;EAC5B;;EAEA;+BAC6B,0BAA0B,EAAE;EACzD;kCACgC,0BAA0B,EAAE;EAC5D,sBAAsB,iBAAiB,EAAE;EACzC,2BAA2B,aAAa,EAAE;EAC1C,wBAAwB,uBAAuB,EAAE,sBAAsB,EAAE;;EAEzE;;IAEE,mBAAmB;EACrB;;EAEA;IACE,mBAAmB;EACrB;AACF;;AAEA,yBAAyB;AACzB;EACE,mBAAmB;EACnB,qBAAqB;EACrB,sBAAsB;EACtB,uBAAuB;EACvB,4BAA4B;EAC5B,oBAAoB;EACpB,oBAAoB;EACpB,2BAA2B;EAC3B,oBAAoB;EACpB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;EACrB,qBAAqB;EACrB,kDAAkD;EAClD,wDAAwD;EACxD,sBAAsB;EACtB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;EAC9B,uBAAuB;AACzB;;AAEA;EACE;;sBAEoB;EACpB,sBAAsB;AACxB;;AAEA;;;;;EAKE,wCAAwC;AAC1C;;AAEA;;EAEE,+HAA+H;AACjI;;AAEA;;;;;EAKE,4CAA4C;EAC5C,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,wCAAwC;EACxC,+CAA+C;EAC/C,sBAAsB;AACxB;;AAEA;EACE,yCAAyC;EACzC,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,eAAe;AACjB;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gDAAgD;EAChD,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,oCAAoC;EACpC,6BAA6B;EAC7B,kBAAkB;EAClB,oBAAoB;EACpB,YAAY;EACZ,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,4BAA4B;EAC5B,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,qBAAqB;EACrB,uBAAuB;EACvB,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;EAEE,oCAAoC;EACpC,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,wBAAwB;AAC1B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,4DAA4D;EAC5D,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;;;;EAIE,wBAAwB;AAC1B;;AAEA;;;;;;;;;EASE,qCAAqC;EACrC,8BAA8B;EAC9B,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,uDAAuD;AACzD;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;AACzD,oCAAoC,mBAAmB,EAAE;;AAEzD;;EAEE,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uDAAuD;AACzD;;AAEA;;;EAGE,4BAA4B;EAC5B,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;;EAGE,uBAAuB;AACzB;;AAEA;;;;EAIE,yBAAyB;AAC3B;;AAEA;;EAEE,qCAAqC;EACrC,qCAAqC;EACrC,sBAAsB;AACxB;;AAEA;;;EAGE,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,qCAAqC;EACrC,yBAAyB;EACzB,6CAA6C;EAC7C,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;EAEE,gFAAgF;AAClF;;AAEA;;EAEE,qBAAqB;EACrB,qCAAqC;EACrC,2BAA2B;AAC7B;;AAEA;;EAEE,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;;;;EAIE,oCAAoC;EACpC,8BAA8B;AAChC;;AAEA;;EAEE,4BAA4B;EAC5B,yBAAyB;EACzB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,sBAAsB;EACtB,mDAAmD;AACrD;;AAEA;;;EAGE,8BAA8B;EAC9B,YAAY;AACd;;AAEA;;;EAGE,mBAAmB;EACnB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;;;EAGE,2BAA2B;EAC3B,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,8CAA8C;AAChD;;AAEA;EACE,gDAAgD;EAChD,yCAAyC;EACzC,2BAA2B;AAC7B;;AAEA;EACE,uCAAuC;EACvC,oCAAoC;AACtC;;AAEA,mFAAmF;AACnF;EACE;;sFAEoF;EACpF,sBAAsB;AACxB;;AAEA;;EAEE,uCAAuC;AACzC;;AAEA;EACE,yBAAyB;EACzB,8CAA8C;AAChD;;AAEA;;;;EAIE,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,8BAA8B;EAC9B,2EAA2E;AAC7E;;AAEA;;;EAGE,8BAA8B;EAC9B,+CAA+C;AACjD;;AAEA;;EAEE,qCAAqC;EACrC,2CAA2C;EAC3C,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,uCAAuC;EACvC,qCAAqC;AACvC;;AAEA;EACE,4BAA4B;EAC5B,cAAc;EACd,iDAAiD;AACnD;;AAEA;EACE;;;iEAG+D;AACjE;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;EAClC,kBAAkB;EAClB,8CAA8C;EAC9C,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,0FAA0F;EAC1F,WAAW;EACX,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,gDAAgD;EAChD,yBAAyB;AAC3B;;AAEA;EACE,OAAO,UAAU,EAAE,0BAA0B,EAAE;EAC/C,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA;EACE,WAAW,wBAAwB,EAAE;EACrC,MAAM,2BAA2B,EAAE;AACrC;;AAEA;EACE;IACE,8CAA8C;EAChD;;EAEA;IACE,qCAAqC;IACrC,kCAAkC;IAClC,6CAA6C;IAC7C,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,8BAA8B;EAChC;;EAEA;;;;IAIE,eAAe;EACjB;;EAEA;IACE,8BAA8B;EAChC;;EAEA;;IAEE,sBAAsB;EACxB;AACF;;AAEA;EACE,OAAO,qBAAqB,EAAE;EAC9B;IACE,qCAAqC;IACrC,uCAAuC;IACvC,gCAAgC;IAChC,sCAAsC;EACxC;AACF","sourcesContent":[":root {\n  color: #18201b;\n  background: #f7f4ee;\n  font-family: Inter, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", sans-serif;\n  font-size: 16px;\n}\n\n* {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n}\n\n.download-app-page { background: #fffaf8; color: #2d2022; min-height: 100vh; }\n.download-app-nav { align-items: center; display: flex; justify-content: space-between; margin: 0 auto; max-width: 1180px; padding: 18px 24px; }\n.download-app-nav a { align-items: center; color: #5f3840; display: flex; gap: 10px; text-decoration: none; }\n.download-app-nav > a:last-child { font-weight: 700; }\n.download-app-nav img, .download-app-footer img { height: 48px; object-fit: contain; width: 48px; }\n.download-app-nav span, .download-app-nav small { display: block; }\n.download-app-nav small { color: #8b6d72; font-size: 12px; }\n.download-app-hero { align-items: center; display: grid; gap: 72px; grid-template-columns: minmax(0, 1fr) 350px; margin: 0 auto; max-width: 1080px; min-height: 620px; padding: 52px 24px 76px; }\n.download-app-kicker { align-items: center; color: #9e3f55; display: flex; font-weight: 800; gap: 8px; }\n.download-app-copy h1 { font-family: Georgia, \"Times New Roman\", serif; font-size: 64px; letter-spacing: 0; line-height: 1.04; margin: 18px 0 22px; }\n.download-app-copy p { color: #70575c; font-size: 20px; line-height: 1.65; margin: 0 0 28px; max-width: 650px; }\n.download-app-button { align-items: center; background: #a93d56; border-radius: 8px; box-shadow: 0 14px 32px rgba(143, 48, 71, .2); color: #fff; display: inline-flex; font-size: 18px; font-weight: 800; gap: 10px; justify-content: center; min-height: 58px; padding: 0 26px; text-decoration: none; transition: transform 180ms ease, box-shadow 180ms ease; }\n.download-app-button:hover { box-shadow: 0 18px 38px rgba(143, 48, 71, .28); transform: translateY(-2px); }\n.download-app-version { color: #8b6d72; display: block; font-size: 13px; margin-top: 14px; }\n.download-phone-preview { background: linear-gradient(155deg, #fff 0%, #fff6f3 100%); border: 8px solid #34282a; border-radius: 38px; box-shadow: 0 30px 70px rgba(67, 37, 43, .2); min-height: 560px; padding: 42px 22px 24px; position: relative; }\n.download-phone-top { align-items: center; display: flex; gap: 6px; left: 50%; position: absolute; top: 14px; transform: translateX(-50%); }\n.download-phone-top span:first-child { background: #453638; border-radius: 999px; height: 6px; width: 54px; }\n.download-phone-top span:last-child { background: #453638; border-radius: 50%; height: 7px; width: 7px; }\n.download-phone-preview > img { display: block; height: 112px; margin: 22px auto 24px; object-fit: contain; width: 112px; }\n.download-phone-preview > small, .download-phone-preview > strong { display: block; text-align: center; }\n.download-phone-preview > small { color: #9e3f55; font-weight: 800; }\n.download-phone-preview > strong { font-family: Georgia, \"Times New Roman\", serif; font-size: 27px; margin-top: 7px; }\n.download-phone-actions { display: grid; gap: 9px; grid-template-columns: 1fr 1fr; margin-top: 34px; }\n.download-phone-actions span { background: #f7e9e8; border: 1px solid #efd5d3; border-radius: 8px; color: #713c48; font-size: 13px; font-weight: 800; padding: 14px 8px; text-align: center; }\n.download-phone-note { background: #a93d56; border-radius: 8px; color: #fff; font-size: 14px; line-height: 1.5; margin-top: 22px; padding: 18px; text-align: center; }\n.download-install-band { background: #f7e9e8; padding: 64px 24px; }\n.download-install-heading, .download-step-grid, .download-trust-row, .download-app-footer { margin-left: auto; margin-right: auto; max-width: 1080px; }\n.download-install-heading span { color: #9e3f55; font-weight: 800; }\n.download-install-heading h2 { font-family: Georgia, \"Times New Roman\", serif; font-size: 38px; margin: 8px 0 30px; }\n.download-step-grid { display: grid; gap: 16px; grid-template-columns: repeat(3, minmax(0, 1fr)); list-style: none; padding: 0; }\n.download-step-grid li { align-items: flex-start; background: #fffaf8; border: 1px solid #ead3d2; border-radius: 8px; display: flex; gap: 14px; min-height: 130px; padding: 22px; }\n.download-step-grid b { align-items: center; background: #a93d56; border-radius: 50%; color: #fff; display: flex; flex: 0 0 34px; height: 34px; justify-content: center; }\n.download-step-grid strong, .download-step-grid span { display: block; }\n.download-step-grid span { color: #765d61; line-height: 1.45; margin-top: 7px; }\n.download-trust-row { display: grid; gap: 16px; grid-template-columns: repeat(3, minmax(0, 1fr)); padding: 36px 24px; }\n.download-trust-row span { align-items: center; color: #69464e; display: flex; font-weight: 700; gap: 9px; justify-content: center; }\n.download-help-band { align-items: start; background: #fff; border-bottom: 1px solid #eadedb; border-top: 1px solid #eadedb; display: grid; gap: 54px; grid-template-columns: minmax(0, .8fr) minmax(0, 1.2fr); margin: 0 auto; max-width: 1080px; padding: 48px 24px; }\n.download-help-copy > span { align-items: center; color: #9e3f55; display: flex; font-weight: 800; gap: 8px; }\n.download-help-copy h2 { font-family: Georgia, \"Times New Roman\", serif; font-size: 34px; line-height: 1.15; margin: 12px 0 16px; }\n.download-help-copy p { color: #70575c; line-height: 1.6; margin: 0 0 12px; }\n.download-help-hindi { color: #5f3840 !important; font-size: 17px; }\n.download-help-steps { display: grid; gap: 12px; }\n.download-help-steps article { align-items: flex-start; background: #fff8f6; border: 1px solid #ead3d2; border-radius: 8px; display: flex; gap: 13px; padding: 17px; }\n.download-help-steps article > svg { color: #a93d56; flex: 0 0 auto; margin-top: 2px; }\n.download-help-steps strong, .download-help-steps span { display: block; }\n.download-help-steps span { color: #765d61; line-height: 1.5; margin-top: 5px; }\n.download-help-button { justify-self: start; min-height: 50px; }\n.download-app-footer { align-items: center; border-top: 1px solid #eadedb; display: flex; gap: 18px; padding: 24px; }\n.download-app-footer p { color: #745a5f; flex: 1; margin: 0; }\n.download-app-footer a { color: #764553; text-decoration: none; }\n\n@media (max-width: 760px) {\n  .download-app-nav { padding: 14px 18px; }\n  .download-app-nav > a:last-child { font-size: 13px; }\n  .download-app-hero { gap: 44px; grid-template-columns: 1fr; padding: 42px 20px 58px; }\n  .download-app-copy { text-align: center; }\n  .download-app-kicker { justify-content: center; }\n  .download-app-copy h1 { font-size: 44px; }\n  .download-app-copy p { font-size: 17px; }\n  .download-app-button { width: 100%; }\n  .download-phone-preview { justify-self: center; max-width: 340px; width: 100%; }\n  .download-step-grid, .download-trust-row { grid-template-columns: 1fr; }\n  .download-help-band { gap: 28px; grid-template-columns: 1fr; padding: 38px 20px; }\n  .download-help-copy h2 { font-size: 29px; }\n  .download-help-button { justify-self: stretch; }\n  .download-install-heading h2 { font-size: 32px; }\n  .download-trust-row span { justify-content: flex-start; }\n  .download-app-footer { align-items: flex-start; flex-wrap: wrap; }\n}\n\nimg {\n  max-width: 100%;\n}\n\nbutton,\ninput {\n  font: inherit;\n}\n\nselect {\n  font: inherit;\n}\n\n.app-shell {\n  display: grid;\n  grid-template-columns: 260px minmax(0, 1fr);\n  min-height: 100vh;\n}\n\n.mobile-menu-button,\n.sidebar-backdrop,\n.mobile-bottom-nav,\n.mobile-quick-start {\n  display: none;\n}\n\n.sidebar {\n  background: #17211c;\n  color: #f8f4eb;\n  padding: 24px 18px;\n}\n\n.brand {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  margin-bottom: 34px;\n}\n\n.brand small,\n.page-header span,\n.metric-card span {\n  color: #68756e;\n  display: block;\n}\n\n.sidebar .brand small {\n  color: #c5cdbf;\n}\n\n.brand-mark {\n  align-items: center;\n  background: #d7a84f;\n  border-radius: 8px;\n  color: #17211c;\n  display: inline-flex;\n  font-weight: 800;\n  height: 40px;\n  justify-content: center;\n  width: 40px;\n}\n\n.nav-list {\n  display: grid;\n  gap: 18px;\n}\n\n.nav-section {\n  display: grid;\n  gap: 6px;\n}\n\n.nav-section-title {\n  color: #9aa89f;\n  font-size: 12px;\n  font-weight: 700;\n  letter-spacing: 0;\n  padding: 0 12px 4px;\n  text-transform: uppercase;\n}\n\n.nav-link {\n  align-items: center;\n  border-radius: 8px;\n  color: #edf0e8;\n  display: flex;\n  gap: 10px;\n  padding: 10px 12px;\n  text-decoration: none;\n}\n\n.nav-link small {\n  background: rgba(215, 168, 79, 0.14);\n  border-radius: 999px;\n  color: #d7a84f;\n  font-size: 11px;\n  margin-left: auto;\n  padding: 3px 7px;\n}\n\n.nav-link.active,\n.nav-link:hover {\n  background: #26332b;\n}\n\n.nav-link-planned {\n  color: #c5cdbf;\n  cursor: default;\n  opacity: 0.82;\n}\n\n.nav-link-planned:hover {\n  background: transparent;\n}\n\n.api-status {\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 8px;\n  margin-top: 28px;\n  padding: 10px;\n}\n\n.session-panel {\n  border: 1px solid rgba(255, 255, 255, 0.16);\n  border-radius: 8px;\n  margin-top: 28px;\n  padding: 10px;\n}\n\n.session-panel span,\n.session-panel strong,\n.session-panel small,\n.session-panel a,\n.session-panel button {\n  display: flex;\n}\n\n.session-panel span {\n  color: #f8f4eb;\n}\n\n.session-panel strong {\n  color: #d7a84f;\n  margin-top: 4px;\n  text-transform: capitalize;\n}\n\n.session-panel small {\n  color: #c5cdbf;\n  margin-top: 4px;\n}\n\n.session-panel a,\n.session-panel button {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  color: #edf0e8;\n  cursor: pointer;\n  gap: 6px;\n  margin-top: 10px;\n  padding: 0;\n  text-decoration: none;\n}\n\n.session-actions {\n  display: grid;\n  gap: 2px;\n  margin-top: 10px;\n}\n\n.session-actions a,\n.session-actions button {\n  margin-top: 0;\n}\n\n.session-error {\n  color: #ffb4a8 !important;\n}\n\n.api-status span,\n.api-status small {\n  display: block;\n}\n\n.api-status small {\n  color: #c5cdbf;\n  margin-top: 4px;\n  overflow-wrap: anywhere;\n}\n\n.api-status.connected span {\n  color: #9ee0ac;\n}\n\n.api-status.offline span {\n  color: #ffb4a8;\n}\n\n.main-panel {\n  padding: 36px;\n}\n\n.page-header {\n  margin-bottom: 28px;\n  max-width: 760px;\n}\n\n.page-header h1 {\n  font-size: 40px;\n  line-height: 1.1;\n  margin: 8px 0;\n}\n\n.page-header p {\n  color: #4e5b53;\n  font-size: 18px;\n  line-height: 1.55;\n  margin: 0;\n}\n\n.metric-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin-bottom: 24px;\n}\n\n.dashboard-grid {\n  display: grid;\n  gap: 18px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-bottom: 18px;\n}\n\n.age-band {\n  margin-bottom: 18px;\n}\n\n.age-group-grid {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  margin-top: 14px;\n}\n\n.age-group-card {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.age-group-card span,\n.age-group-card small {\n  color: #4e5b53;\n  display: block;\n}\n\n.age-group-card strong {\n  display: block;\n  font-size: 28px;\n  margin: 8px 0 4px;\n}\n\n.rally-band {\n  margin-bottom: 18px;\n}\n\n.rally-band .tree-register-header > span {\n  align-items: center;\n  display: inline-flex;\n  gap: 6px;\n}\n\n.rally-track-list {\n  display: grid;\n  gap: 16px;\n  margin-top: 18px;\n}\n\n.rally-lane {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  padding: 14px;\n}\n\n.rally-lane-header {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n}\n\n.rally-lane-header span {\n  color: #4e5b53;\n}\n\n.rally-track {\n  background: linear-gradient(90deg, #e7e1d5 0 49%, #d6cbb9 49% 51%, #e7e1d5 51% 100%);\n  border-radius: 999px;\n  height: 28px;\n  margin-top: 12px;\n  position: relative;\n}\n\n.rally-car {\n  align-items: center;\n  background: #d7a84f;\n  border: 2px solid #ffffff;\n  border-radius: 999px;\n  box-shadow: 0 8px 18px rgba(35, 32, 26, 0.16);\n  color: #17211c;\n  display: inline-flex;\n  font-size: 12px;\n  font-weight: 900;\n  height: 34px;\n  justify-content: center;\n  position: absolute;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  width: 42px;\n}\n\n.rally-flag {\n  color: #34513f;\n  position: absolute;\n  right: 8px;\n  top: 5px;\n}\n\n.rally-task-grid {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.rally-task-grid span {\n  background: #ebe5d9;\n  border-radius: 999px;\n  color: #34513f;\n  padding: 7px 10px;\n}\n\n.stack-list {\n  display: grid;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.compact-row {\n  align-items: flex-start;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: grid;\n  gap: 4px;\n  padding: 12px;\n}\n\n.compact-row span,\n.empty-copy {\n  color: #4e5b53;\n}\n\n.snapshot-grid {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-top: 14px;\n}\n\n.snapshot-grid div,\n.feature-card {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.snapshot-grid span,\n.feature-card p,\n.location-list span,\n.home-location-strip span {\n  color: #4e5b53;\n}\n\n.snapshot-grid strong {\n  display: block;\n  font-size: 22px;\n  margin-top: 6px;\n}\n\n.location-list,\n.home-location-strip {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 12px;\n}\n\n.location-list span,\n.home-location-strip span {\n  background: #ebe5d9;\n  border-radius: 999px;\n  padding: 7px 10px;\n}\n\n.compact-form {\n  border-top: 1px solid #e2ded3;\n  margin-top: 16px;\n  padding-top: 16px;\n}\n\n.history-timeline {\n  display: grid;\n  gap: 12px;\n  margin-top: 18px;\n}\n\n.history-event {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: 120px minmax(0, 1fr);\n}\n\n.history-event time {\n  color: #805f1d;\n  font-weight: 800;\n}\n\n.history-event div {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.history-event span,\n.history-event small,\n.history-event p {\n  color: #4e5b53;\n  display: block;\n  margin: 6px 0 0;\n}\n\n.calendar-month-list {\n  display: grid;\n  gap: 22px;\n  margin-top: 18px;\n}\n\n.calendar-month h3 {\n  margin-bottom: 10px;\n}\n\n.calendar-event-row p {\n  color: #4e5b53;\n  margin: 0;\n}\n\n.calendar-event-date {\n  align-items: center;\n  color: #805f1d;\n  display: inline-flex;\n  font-weight: 800;\n  gap: 8px;\n}\n\n.metric-card,\n.content-band,\n.login-panel {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);\n}\n\n.metric-card {\n  padding: 18px;\n}\n\n.metric-card strong {\n  display: block;\n  font-size: 24px;\n  margin-top: 10px;\n}\n.private-route-loading {\n  min-height: 100vh;\n  display: grid;\n  place-content: center;\n  justify-items: center;\n  gap: 14px;\n  background: #f7f4ed;\n  color: #14271f;\n}\n\n.contribution-steps {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin-bottom: 16px;\n}\n\n.contribution-steps > div {\n  display: grid;\n  grid-template-columns: 36px minmax(0, 1fr);\n  gap: 2px 10px;\n  align-items: center;\n  padding: 14px;\n  border: 1px solid #ded8ca;\n  background: #fff;\n}\n\n.contribution-steps span {\n  grid-row: 1 / span 2;\n  display: grid;\n  place-items: center;\n  width: 34px;\n  height: 34px;\n  border-radius: 50%;\n  background: #dba83f;\n  color: #12231c;\n  font-weight: 800;\n}\n\n.contribution-steps small { color: #526159; }\n\n.simple-kosh-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 16px;\n  padding: 16px 0;\n  border-top: 1px solid #ded8ca;\n}\n\n.simple-kosh-footer p { margin: 0; }\n\n.optional-contribution-details,\n.declaration-history-collapsed {\n  border: 1px solid #ded8ca;\n  background: #f8f6f0;\n  padding: 12px;\n}\n\n.optional-contribution-details summary,\n.declaration-history-collapsed summary {\n  cursor: pointer;\n  color: #274c3a;\n  font-weight: 700;\n}\n\n.optional-contribution-details[open] summary,\n.declaration-history-collapsed[open] summary { margin-bottom: 12px; }\n\n.contribution-review-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 1200;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  background: rgba(7, 23, 16, 0.76);\n  backdrop-filter: blur(5px);\n}\n\n.contribution-review-dialog {\n  width: min(520px, 100%);\n  padding: 28px;\n  border: 2px solid #d4a53a;\n  background: #fff;\n  box-shadow: 0 26px 70px rgba(0, 0, 0, 0.32);\n}\n\n.contribution-review-dialog h2 { margin: 8px 0 18px; }\n\n.contribution-review-amount {\n  display: block;\n  color: #103f2c;\n  font-size: clamp(42px, 9vw, 68px);\n  line-height: 1;\n}\n\n.contribution-review-words {\n  margin: 12px 0 24px;\n  color: #7a5411;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.contribution-review-dialog dl { margin: 0; }\n\n.contribution-review-dialog dl div {\n  display: flex;\n  justify-content: space-between;\n  gap: 16px;\n  padding: 10px 0;\n  border-top: 1px solid #e3ded2;\n}\n\n.contribution-review-dialog dt { color: #5a675f; }\n.contribution-review-dialog dd { margin: 0; font-weight: 700; text-align: right; }\n\n.contribution-review-warning {\n  margin: 18px 0;\n  padding: 12px;\n  background: #f8f1df;\n  color: #5b471c;\n}\n\n.contribution-review-actions {\n  display: grid;\n  grid-template-columns: 1fr 1.35fr;\n  gap: 10px;\n}\n\n@media (max-width: 560px) {\n  .contribution-review-dialog { padding: 22px 18px; }\n  .contribution-review-actions { grid-template-columns: 1fr; }\n}\n\n@media (max-width: 720px) {\n  .contribution-steps { grid-template-columns: 1fr; }\n  .simple-kosh-footer { align-items: stretch; flex-direction: column; }\n}\n\n/* Verified bank contributions */\n.bank-contribution-panel {\n  border-top: 3px solid #d7a93c;\n}\n\n.section-kicker {\n  color: #8a651d;\n  display: block;\n  font-size: 12px;\n  font-weight: 700;\n  margin-bottom: 4px;\n  text-transform: uppercase;\n}\n\n.verification-badge,\n.confidence-meter {\n  background: #e7f4eb;\n  border: 1px solid #afd1b9;\n  color: #185b31;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 700;\n  padding: 7px 10px;\n}\n\n.bank-security-note {\n  background: #fff4d6;\n  border-left: 3px solid #d7a93c;\n  padding: 12px;\n}\n\n.bank-start-form,\n.bank-review-fields {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: minmax(220px, 1fr) minmax(180px, auto);\n  margin-top: 18px;\n}\n\n.bank-start-form label,\n.bank-proof-form label,\n.bank-review-fields label {\n  display: grid;\n  gap: 6px;\n}\n\n.bank-claim-workflow {\n  display: grid;\n  gap: 18px;\n  grid-template-columns: minmax(260px, 0.8fr) minmax(320px, 1.2fr);\n  margin-top: 20px;\n}\n\n.bank-payment-card {\n  background: #13251d;\n  color: #fff;\n  padding: 22px;\n}\n\n.bank-payment-card > span {\n  color: #cbd8d1;\n}\n\n.bank-payment-card > strong {\n  display: block;\n  font-size: 30px;\n  margin: 5px 0 18px;\n}\n\n.bank-payment-card dl {\n  display: grid;\n  gap: 10px;\n  margin: 0;\n}\n\n.bank-payment-card dl div {\n  border-top: 1px solid #355046;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  padding-top: 9px;\n}\n\n.bank-payment-card dt {\n  color: #afc4ba;\n}\n\n.bank-payment-card dd {\n  font-weight: 700;\n  margin: 0;\n  overflow-wrap: anywhere;\n  text-align: right;\n}\n\n.bank-proof-form {\n  display: grid;\n  gap: 12px;\n}\n\n.bank-proof-form h3 {\n  margin: 0;\n}\n\n.bank-proof-form textarea {\n  min-height: 92px;\n}\n\n.bank-claim-history {\n  border-top: 1px solid #ded8ca;\n  margin-top: 22px;\n  padding-top: 16px;\n}\n\n.bank-claim-summary {\n  align-items: center;\n  background: #f8f6f0;\n  border: 1px solid #ded8ca;\n  color: #17231d;\n  display: grid;\n  grid-template-columns: 1fr auto auto;\n  margin-top: 8px;\n  text-align: left;\n  width: 100%;\n}\n\n.bank-claim-summary em {\n  font-size: 12px;\n  font-style: normal;\n  text-transform: capitalize;\n}\n\n.bank-claim-summary > small {\n  grid-column: 1 / -1;\n  margin-top: 4px;\n}\n\n.bank-claim-summary.approved {\n  border-left: 4px solid #2d7a4b;\n}\n\n.bank-claim-summary.rejected {\n  border-left: 4px solid #a33c33;\n}\n\n.bank-review-card {\n  border: 1px solid #ded8ca;\n  margin-top: 16px;\n  padding: 18px;\n}\n\n.bank-review-card header {\n  align-items: center;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr auto auto;\n}\n\n.bank-review-card header h3 {\n  margin: 3px 0 0;\n}\n\n.evidence-list {\n  display: grid;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.evidence-item {\n  background: #f8f6f0;\n  display: grid;\n  gap: 5px;\n  padding: 12px;\n}\n\n.evidence-item small {\n  color: #805018;\n}\n\n.evidence-item .secondary-button {\n  justify-self: start;\n  margin-top: 5px;\n}\n\n.bank-review-fields {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.bank-sms-check {\n  align-items: end;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: 1fr auto;\n  margin-top: 12px;\n}\n\n.bank-sms-check label {\n  display: grid;\n  gap: 6px;\n}\n\n.bank-sms-check textarea {\n  min-height: 72px;\n}\n\n.danger-button {\n  background: #fff;\n  border: 1px solid #a33c33;\n  color: #8f2f28;\n}\n\n.unmatched-sms-list {\n  border-top: 1px solid #ded8ca;\n  margin-top: 22px;\n  padding-top: 16px;\n}\n\n.unmatched-sms-list article {\n  background: #fff5df;\n  display: grid;\n  gap: 6px;\n  grid-template-columns: auto auto 1fr;\n  margin-top: 10px;\n  padding: 12px;\n}\n\n.unmatched-sms-list article small {\n  text-align: right;\n}\n\n.unmatched-sms-list blockquote,\n.evidence-item blockquote {\n  background: #fff;\n  border-left: 3px solid #d7a93c;\n  grid-column: 1 / -1;\n  margin: 4px 0 0;\n  overflow-wrap: anywhere;\n  padding: 9px;\n}\n\n@media (max-width: 760px) {\n  .bank-claim-workflow,\n  .bank-review-fields,\n  .bank-sms-check,\n  .bank-start-form {\n    grid-template-columns: 1fr;\n  }\n\n  .bank-review-card header {\n    align-items: start;\n    grid-template-columns: 1fr auto;\n  }\n\n  .confidence-meter {\n    grid-column: 1 / -1;\n    justify-self: start;\n  }\n\n  .bank-claim-summary {\n    grid-template-columns: 1fr auto;\n  }\n\n  .bank-claim-summary em {\n    grid-column: 1 / -1;\n  }\n\n  .bank-payment-card dl div {\n    display: grid;\n  }\n\n  .unmatched-sms-list article {\n    grid-template-columns: 1fr;\n  }\n\n  .unmatched-sms-list article small {\n    text-align: left;\n  }\n\n  .bank-payment-card dd {\n    text-align: left;\n  }\n}\n.hosted-contribution-list {\n  display: grid;\n  gap: 10px;\n  margin-top: 18px;\n}\n\n.hosted-contribution-row {\n  align-items: end;\n  background: #faf8f2;\n  border: 1px solid #ded8ca;\n  border-radius: 8px;\n  display: grid;\n  gap: 14px;\n  grid-template-columns: minmax(220px, 1fr) auto minmax(220px, 1fr) auto;\n  padding: 14px;\n}\n\n.hosted-contribution-row > div {\n  display: grid;\n  gap: 3px;\n}\n\n.hosted-contribution-row label {\n  display: grid;\n  gap: 6px;\n}\n\n.hosted-contribution-row select {\n  min-height: 42px;\n}\n\n.hosted-contribution-status {\n  color: #8b651f;\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.hosted-contribution-amount {\n  font-size: 20px;\n  white-space: nowrap;\n}\n\n@media (max-width: 760px) {\n  .hosted-contribution-row {\n    align-items: stretch;\n    grid-template-columns: 1fr;\n  }\n\n  .hosted-contribution-row button {\n    width: 100%;\n  }\n}\n\n.wallet-spotlight {\n  align-items: center;\n  background: linear-gradient(135deg, #17211c, #2e3d33);\n  border: 1px solid rgba(215, 168, 79, 0.36);\n  border-radius: 8px;\n  color: #fff8e8;\n  display: grid;\n  gap: 18px;\n  grid-template-columns: minmax(0, 1.3fr) minmax(220px, 0.7fr);\n  margin-bottom: 18px;\n  padding: 22px;\n}\n\n.wallet-spotlight span {\n  color: #d7a84f;\n  display: block;\n  font-weight: 850;\n}\n\n.wallet-spotlight strong {\n  color: #ffffff;\n  display: block;\n  font-size: clamp(36px, 6vw, 58px);\n  line-height: 1;\n  margin: 10px 0;\n}\n\n.wallet-spotlight p {\n  color: #dce3d5;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.wallet-spotlight-metrics {\n  background: rgba(255, 255, 255, 0.08);\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  border-radius: 8px;\n  display: grid;\n  gap: 10px;\n  padding: 14px;\n}\n\n.wallet-spotlight-metrics span {\n  color: #ffffff;\n  font-size: 16px;\n}\n\n.content-band {\n  padding: 24px;\n}\n\n.content-band h2 {\n  font-size: 22px;\n  margin: 0 0 8px;\n}\n\n.content-band p {\n  color: #4e5b53;\n  margin: 0;\n}\n\n.vision-chart-band {\n  align-items: stretch;\n  background:\n    linear-gradient(135deg, rgba(23, 33, 28, 0.96), rgba(54, 71, 58, 0.94)),\n    #17211c;\n  color: #f8f4eb;\n  display: grid;\n  gap: 22px;\n  grid-template-columns: minmax(220px, 0.7fr) minmax(0, 1.3fr);\n  margin-bottom: 24px;\n  overflow: hidden;\n  position: relative;\n}\n\n.vision-chart-band::after {\n  border: 1px solid rgba(215, 168, 79, 0.28);\n  border-radius: 8px;\n  content: \"\";\n  inset: 12px;\n  pointer-events: none;\n  position: absolute;\n}\n\n.vision-chart-copy {\n  align-content: center;\n  display: grid;\n  gap: 10px;\n  position: relative;\n  z-index: 1;\n}\n\n.vision-chart-copy span {\n  color: #d7a84f;\n  font-size: 13px;\n  font-weight: 900;\n  text-transform: uppercase;\n}\n\n.vision-chart-copy h2 {\n  color: #ffffff;\n  font-size: 30px;\n  line-height: 1.12;\n  margin: 0;\n}\n\n.vision-chart-copy p {\n  color: #dce3d5;\n  line-height: 1.55;\n}\n\n.vision-cloud {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px 12px;\n  justify-content: center;\n  min-height: 210px;\n  position: relative;\n  z-index: 1;\n}\n\n.vision-chip {\n  background: rgba(248, 244, 235, 0.1);\n  border: 1px solid rgba(215, 168, 79, 0.28);\n  border-radius: 999px;\n  color: #fff8e8;\n  display: inline-flex;\n  font-weight: 850;\n  line-height: 1.2;\n  padding: 10px 14px;\n}\n\n.vision-chip-1 {\n  font-size: 22px;\n  transform: translateY(-8px);\n}\n\n.vision-chip-2 {\n  background: #d7a84f;\n  color: #17211c;\n  font-size: 16px;\n  transform: translateY(12px);\n}\n\n.vision-chip-3 {\n  font-size: 18px;\n  transform: translateY(4px);\n}\n\n.vision-chip-4 {\n  border-color: rgba(255, 255, 255, 0.38);\n  font-size: 14px;\n  transform: translateY(-14px);\n}\n\n.vision-chip-5 {\n  font-size: 20px;\n  transform: translateY(16px);\n}\n\n.project-summary {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.project-summary span {\n  background: #f0eadc;\n  border-radius: 999px;\n  color: #2f3e35;\n  font-size: 15px;\n  font-weight: 750;\n  line-height: 1.25;\n  padding: 9px 13px;\n}\n\n.mission-financials {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n  margin-top: 18px;\n}\n\n.mission-financials div {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.mission-financials span {\n  color: #68756e;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.mission-financials strong {\n  display: block;\n  font-size: 18px;\n}\n\n.kosh-filter-row {\n  align-items: end;\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;\n  margin-top: 18px;\n}\n\n.kosh-filter-row label {\n  display: grid;\n  gap: 8px;\n}\n\n.kosh-filter-row input,\n.kosh-filter-row select {\n  border: 1px solid #cfc8bc;\n  border-radius: 8px;\n  min-width: 0;\n  padding: 12px;\n}\n\n.kosh-filter-row button {\n  background: #17211c;\n  border: 0;\n  border-radius: 8px;\n  color: #ffffff;\n  cursor: pointer;\n  min-height: 45px;\n  padding: 12px 16px;\n}\n\n.kosh-analytics-grid {\n  margin-top: 14px;\n}\n\n.featured-sankalp-band {\n  margin-bottom: 18px;\n}\n\n.featured-sankalp-list {\n  display: grid;\n  gap: 12px;\n  margin-top: 16px;\n}\n\n.featured-sankalp-card {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: grid;\n  gap: 14px;\n  grid-template-columns: auto minmax(0, 1fr);\n  padding: 14px;\n}\n\n.sankalp-number {\n  align-items: center;\n  background: #d7a84f;\n  border-radius: 999px;\n  color: #17211c;\n  display: inline-flex;\n  font-weight: 900;\n  height: 34px;\n  justify-content: center;\n  width: 34px;\n}\n\n.compact-header {\n  align-items: center;\n  margin-bottom: 8px;\n}\n\n.compact-header h3 {\n  font-size: 18px;\n}\n\n.featured-sankalp-card p {\n  line-height: 1.5;\n}\n\n.featured-sankalp-card .project-summary {\n  margin-top: 12px;\n}\n\n.project-list {\n  display: grid;\n  gap: 16px;\n  margin-top: 18px;\n}\n\n.project-card {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  padding: 18px;\n}\n\n.lifecycle-strip {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin: 18px 0 12px;\n}\n\n.lifecycle-strip div {\n  align-items: center;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: flex;\n  gap: 10px;\n  min-height: 54px;\n  padding: 10px;\n}\n\n.lifecycle-strip strong {\n  align-items: center;\n  background: #dba945;\n  border-radius: 999px;\n  color: #17211c;\n  display: inline-flex;\n  flex: 0 0 auto;\n  height: 28px;\n  justify-content: center;\n  width: 28px;\n}\n\n.lifecycle-strip span,\n.sankalp-team-row span {\n  color: #4e5b53;\n}\n\n.section-heading-row {\n  align-items: flex-start;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n}\n\n.sadasya-sankalp-note {\n  align-items: flex-start;\n  display: grid;\n  gap: 14px;\n  margin-top: 16px;\n}\n\n.sankalp-board {\n  display: grid;\n  gap: 14px;\n}\n\n.sankalp-card {\n  display: grid;\n  gap: 14px;\n}\n\n.sankalp-card .project-card-header h3 {\n  font-size: clamp(21px, 2.2vw, 28px);\n  line-height: 1.2;\n}\n\n.sankalp-card .project-card-header p {\n  font-size: 17px;\n  line-height: 1.55;\n  max-width: 980px;\n}\n\n.sankalp-card .button-row button {\n  min-height: 44px;\n}\n\n.sankalp-team-row {\n  display: grid;\n  gap: 8px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.sankalp-workspace h3 {\n  margin: 24px 0 10px;\n}\n\n.sankalp-workspace {\n  scroll-margin-top: 18px;\n}\n\n.sankalp-workspace.workspace-opened {\n  animation: workspacePulse 1.8s ease;\n  border-color: #d7a84f;\n}\n\n@keyframes workspacePulse {\n  0% {\n    box-shadow: 0 0 0 0 rgba(215, 168, 79, 0.42);\n  }\n\n  45% {\n    box-shadow: 0 0 0 8px rgba(215, 168, 79, 0.16);\n  }\n\n  100% {\n    box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);\n  }\n}\n\n.sankalp-detail-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-top: 18px;\n}\n\n.compact-row {\n  align-items: center;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  padding: 12px;\n}\n\n.compact-row span {\n  color: #4e5b53;\n  text-align: right;\n}\n\n.management-row {\n  align-items: flex-start;\n}\n\n.management-row div {\n  display: grid;\n  gap: 4px;\n}\n\n.management-row small {\n  color: #637066;\n  line-height: 1.35;\n}\n\n.status-pill {\n  background: #17211c;\n  border-radius: 999px;\n  color: #fff;\n  flex: 0 0 auto;\n  padding: 8px 12px;\n}\n\n.draft-pill,\n.status-pill.draft-pill,\n.project-card-header > span.draft-pill {\n  background: #fff4d7;\n  border: 1px solid #d9a642;\n  color: #7a5410;\n}\n\n.next-step-card {\n  background: #fff8e8;\n  border: 1px solid #e3c986;\n  border-radius: 8px;\n  display: grid;\n  gap: 8px;\n  margin: 16px 0;\n  padding: 14px;\n}\n\n.next-step-card strong {\n  color: #17211c;\n  font-size: 1rem;\n}\n\n.next-step-card span {\n  color: #3f4d45;\n}\n\n.next-step-card ol {\n  color: #526158;\n  margin: 4px 0 0;\n  padding-left: 20px;\n}\n\n.next-step-card li {\n  margin: 4px 0;\n}\n\n.project-card-header {\n  align-items: flex-start;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n}\n\n.project-card-header h3 {\n  margin: 0 0 6px;\n}\n\n.project-card-header p {\n  color: #4e5b53;\n  margin: 0;\n}\n\n.project-card-header > span {\n  background: #17211c;\n  border-radius: 999px;\n  color: #fff;\n  flex: 0 0 auto;\n  padding: 7px 11px;\n  text-transform: capitalize;\n}\n\n.progress-track {\n  background: #e7e1d5;\n  border-radius: 999px;\n  height: 10px;\n  margin: 16px 0;\n  overflow: hidden;\n}\n\n.progress-track div {\n  background: #d7a84f;\n  height: 100%;\n}\n\n.feedback-overlay {\n  align-items: center;\n  background: rgba(23, 33, 28, 0.42);\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  padding: 18px;\n  position: fixed;\n  right: 0;\n  top: 0;\n  z-index: 80;\n  animation: feedbackBackdropIn 180ms ease-out both;\n}\n\n.feedback-dialog {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  box-shadow: 0 24px 72px rgba(23, 33, 28, 0.28);\n  display: grid;\n  gap: 12px;\n  max-width: 480px;\n  max-height: calc(100vh - 36px);\n  overflow-y: auto;\n  padding: 24px;\n  width: min(100%, 480px);\n  animation: feedbackDialogIn 420ms cubic-bezier(0.2, 0.85, 0.25, 1.15) both;\n}\n\n.feedback-eyebrow {\n  color: #805f1d;\n  display: block;\n  font-size: 13px;\n  font-weight: 900;\n  letter-spacing: 0;\n  text-transform: uppercase;\n}\n\n.feedback-dialog h2 {\n  color: #17211c;\n  font-size: 28px;\n  line-height: 1.18;\n  margin: 0;\n}\n\n.feedback-dialog p {\n  color: #4e5b53;\n  font-size: 17px;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.feedback-dialog button {\n  background: #17211c;\n  border: 0;\n  border-radius: 8px;\n  color: #ffffff;\n  cursor: pointer;\n  min-height: 46px;\n  padding: 12px 16px;\n}\n\n.feedback-actions {\n  display: flex;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.feedback-actions button {\n  flex: 1 1 0;\n}\n\n.feedback-dialog .feedback-secondary-action {\n  background: #f0ede5;\n  color: #243129;\n}\n\n.feedback-dialog.success {\n  border-top: 5px solid #2f7d46;\n}\n\n.feedback-dialog.warning {\n  border-top: 5px solid #d7a84f;\n}\n\n.feedback-dialog.error {\n  border-top: 5px solid #b42318;\n}\n\n.feedback-overlay.is-celebrating {\n  background: rgba(13, 27, 20, 0.72);\n}\n\n.feedback-dialog.celebration {\n  background: #fffdf7;\n  border: 1px solid #d8b45f;\n  border-top: 6px solid #d7a84f;\n  box-shadow: 0 28px 90px rgba(4, 23, 14, 0.42), 0 0 0 5px rgba(215, 168, 79, 0.12);\n  gap: 10px;\n  max-width: 540px;\n  padding: 24px 30px 28px;\n  text-align: center;\n}\n\n.feedback-celebration-stage {\n  height: 126px;\n  margin: -4px auto 2px;\n  position: relative;\n  width: 210px;\n}\n\n.celebration-halo {\n  border: 1px solid rgba(215, 168, 79, 0.42);\n  border-radius: 50%;\n  height: 112px;\n  left: 49px;\n  position: absolute;\n  top: 7px;\n  width: 112px;\n  animation: celebrationHalo 1.8s ease-out infinite;\n}\n\n.celebration-halo::after {\n  border: 1px solid rgba(47, 125, 70, 0.2);\n  border-radius: inherit;\n  content: \"\";\n  inset: 10px;\n  position: absolute;\n}\n\n.celebration-seal {\n  align-items: center;\n  background: #173c29;\n  border: 4px solid #e6c46f;\n  border-radius: 50%;\n  box-shadow: 0 10px 26px rgba(23, 60, 41, 0.28);\n  color: #f7d77e;\n  display: flex;\n  font-family: Georgia, \"Times New Roman\", serif;\n  font-size: 45px;\n  height: 84px;\n  justify-content: center;\n  left: 63px;\n  line-height: 1;\n  position: absolute;\n  top: 21px;\n  width: 84px;\n  z-index: 2;\n  animation: celebrationSealIn 650ms cubic-bezier(0.18, 0.9, 0.25, 1.25) both;\n}\n\n.celebration-petals {\n  inset: 0;\n  position: absolute;\n}\n\n.celebration-petals i {\n  background: #d7a84f;\n  border-radius: 80% 10% 80% 10%;\n  display: block;\n  height: 13px;\n  position: absolute;\n  width: 7px;\n  animation: celebrationPetalIn 700ms cubic-bezier(0.2, 0.8, 0.25, 1.2) both;\n}\n\n.celebration-petals i:nth-child(1) { left: 18px; top: 24px; transform: rotate(-52deg); }\n.celebration-petals i:nth-child(2) { left: 38px; top: 4px; transform: rotate(-30deg); animation-delay: 70ms; }\n.celebration-petals i:nth-child(3) { left: 75px; top: 0; transform: rotate(-12deg); animation-delay: 140ms; }\n.celebration-petals i:nth-child(4) { right: 75px; top: 0; transform: rotate(12deg); animation-delay: 210ms; }\n.celebration-petals i:nth-child(5) { right: 38px; top: 4px; transform: rotate(30deg); animation-delay: 280ms; }\n.celebration-petals i:nth-child(6) { right: 18px; top: 24px; transform: rotate(52deg); animation-delay: 350ms; }\n.celebration-petals i:nth-child(7) { left: 5px; top: 62px; transform: rotate(-78deg); animation-delay: 420ms; }\n.celebration-petals i:nth-child(8) { right: 5px; top: 62px; transform: rotate(78deg); animation-delay: 490ms; }\n.celebration-petals i:nth-child(9) { bottom: 13px; left: 28px; transform: rotate(-115deg); animation-delay: 560ms; }\n.celebration-petals i:nth-child(10) { bottom: 13px; right: 28px; transform: rotate(115deg); animation-delay: 630ms; }\n.celebration-petals i:nth-child(11) { bottom: 0; left: 65px; transform: rotate(-155deg); animation-delay: 700ms; }\n.celebration-petals i:nth-child(12) { bottom: 0; right: 65px; transform: rotate(155deg); animation-delay: 770ms; }\n\n.feedback-dialog.celebration h2 {\n  font-size: 30px;\n}\n\n.feedback-amount {\n  color: #173c29;\n  display: block;\n  font-size: 42px;\n  line-height: 1.08;\n  margin: 2px 0;\n  animation: celebrationAmountIn 520ms 260ms ease-out both;\n}\n\n.feedback-project {\n  background: #f4efe2;\n  border: 1px solid #e1d2ad;\n  border-radius: 8px;\n  display: grid;\n  gap: 3px;\n  padding: 11px 14px;\n  text-align: left;\n}\n\n.feedback-project span {\n  color: #7a6841;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.feedback-project strong {\n  color: #243129;\n  font-size: 17px;\n}\n\n.feedback-balance {\n  align-items: center;\n  background: #edf4ee;\n  border-radius: 8px;\n  display: flex;\n  justify-content: space-between;\n  padding: 10px 13px;\n  text-align: left;\n}\n\n.feedback-balance strong {\n  color: #1f6a39;\n  font-size: 18px;\n}\n\n@keyframes feedbackBackdropIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n@keyframes feedbackDialogIn {\n  from { opacity: 0; transform: translateY(24px) scale(0.96); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@keyframes celebrationSealIn {\n  0% { opacity: 0; transform: scale(0.35) rotate(-18deg); }\n  72% { opacity: 1; transform: scale(1.08) rotate(3deg); }\n  100% { opacity: 1; transform: scale(1) rotate(0); }\n}\n\n@keyframes celebrationHalo {\n  0% { opacity: 0.72; transform: scale(0.82); }\n  75%, 100% { opacity: 0; transform: scale(1.28); }\n}\n\n@keyframes celebrationPetalIn {\n  from { opacity: 0; margin-top: 12px; scale: 0.2; }\n  to { opacity: 1; margin-top: 0; scale: 1; }\n}\n\n@keyframes celebrationAmountIn {\n  from { opacity: 0; transform: translateY(10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .feedback-overlay,\n  .feedback-dialog,\n  .celebration-halo,\n  .celebration-seal,\n  .celebration-petals i,\n  .feedback-amount {\n    animation: none;\n  }\n}\n\n@media (max-width: 720px) {\n  .sankalp-carousel-heading {\n    align-items: center;\n  }\n\n  .sankalp-carousel-heading strong {\n    font-size: 16px;\n  }\n\n  .sankalp-carousel-track {\n    margin-inline: -4px;\n    padding: 3px 4px 12px;\n  }\n\n  .sankalp-slide {\n    flex-basis: calc(100% - 16px);\n    min-height: 230px;\n    padding: 16px;\n  }\n\n  .sankalp-slide h3 {\n    font-size: 20px;\n  }\n\n  .sankalp-slide-metrics {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 7px;\n  }\n\n  .allocation-wallet-pill {\n    align-self: flex-start;\n  }\n}\n\n.login-page {\n  align-items: center;\n  background: #17211c;\n  display: flex;\n  justify-content: center;\n  min-height: 100vh;\n  padding: 24px;\n}\n\n.login-panel {\n  max-width: 440px;\n  padding: 32px;\n  width: 100%;\n}\n\n.login-panel h1 {\n  margin: 18px 0 8px;\n}\n\n.login-panel p {\n  color: #4e5b53;\n  line-height: 1.5;\n}\n\n.password-input-wrap {\n  position: relative;\n  display: block;\n}\n\n.password-input-wrap input {\n  width: 100%;\n  padding-right: 52px;\n}\n\n.password-visibility-button {\n  position: absolute;\n  top: 50%;\n  right: 8px;\n  width: 40px;\n  height: 40px;\n  padding: 0;\n  display: grid;\n  place-items: center;\n  transform: translateY(-50%);\n  border: 0;\n  background: transparent;\n  color: #4e5b53;\n}\n\n.login-progress-note {\n  margin: 0;\n  padding: 10px 12px;\n  border-left: 3px solid #d6a63e;\n  background: #f7f4ed;\n  font-size: 0.9rem;\n}\n\n.form-stack {\n  display: grid;\n  gap: 14px;\n  margin-top: 24px;\n}\n\n.form-stack label {\n  display: grid;\n  gap: 8px;\n}\n\n.form-stack input {\n  border: 1px solid #cfc8bc;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.form-stack button {\n  background: #17211c;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  padding: 12px;\n}\n\n.form-grid {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-top: 18px;\n}\n\n.form-grid label {\n  display: grid;\n  gap: 8px;\n}\n\n.form-grid input,\n.form-grid select,\n.form-grid textarea {\n  border: 1px solid #cfc8bc;\n  border-radius: 8px;\n  min-width: 0;\n  padding: 12px;\n  width: 100%;\n}\n\n.form-grid textarea {\n  resize: vertical;\n}\n\n.wide-field {\n  grid-column: span 2;\n}\n\n.form-grid button,\n.secondary-button {\n  background: #17211c;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  padding: 12px;\n}\n\n.secondary-button {\n  background: #eef1ea;\n  color: #17211c;\n}\n\nbutton:disabled {\n  cursor: not-allowed;\n  opacity: 0.55;\n}\n\n.form-error {\n  color: #b42318;\n  margin: 0;\n}\n\n.form-message {\n  background: #eef5ed;\n  border: 1px solid #c7ddc0;\n  border-radius: 8px;\n  color: #34513f;\n  margin-top: 16px;\n  padding: 12px;\n}\n\n.section-note {\n  color: #4e5b53;\n  margin: 8px 0 0;\n}\n\n.contribute-hero-band {\n  display: grid;\n  gap: 22px;\n}\n\n.contribution-panel {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: grid;\n  gap: 14px;\n  padding: 16px;\n}\n\n.contribution-panel label {\n  display: grid;\n  gap: 8px;\n}\n\n.contribution-panel input {\n  border: 1px solid #cfc8bc;\n  border-radius: 8px;\n  font-size: 18px;\n  min-width: 0;\n  padding: 12px;\n  width: 100%;\n}\n\n.contribution-panel button[type=\"submit\"] {\n  background: #17211c;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  min-height: 48px;\n  padding: 12px;\n}\n\n.amount-preset-row {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(5, minmax(0, 1fr));\n}\n\n.amount-preset-row button {\n  background: #fff;\n  border: 1px solid #d8cdb8;\n  border-radius: 8px;\n  color: #17211c;\n  cursor: pointer;\n  min-height: 42px;\n  padding: 10px;\n}\n\n.amount-preset-row button.active {\n  background: #d7a84f;\n  border-color: #b98324;\n  font-weight: 800;\n}\n\n.contribute-project-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-top: 18px;\n}\n\n.contribute-project-card {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  color: #17211c;\n  cursor: pointer;\n  display: grid;\n  gap: 6px;\n  min-height: 116px;\n  padding: 14px;\n  text-align: left;\n}\n\n.contribute-project-card.active {\n  border-color: #d7a84f;\n  box-shadow: 0 0 0 2px rgba(215, 168, 79, 0.16);\n}\n\n.contribute-project-card span {\n  color: #4e5b53;\n}\n\n.contribute-project-card small {\n  color: #805f1d;\n  font-weight: 800;\n}\n\n.sankalp-carousel {\n  display: grid;\n  gap: 12px;\n  margin: 20px 0;\n  min-width: 0;\n}\n\n.sankalp-carousel-heading {\n  align-items: flex-end;\n  display: flex;\n  justify-content: space-between;\n}\n\n.sankalp-carousel-heading > div:first-child {\n  display: grid;\n  gap: 3px;\n}\n\n.recommendation-kicker {\n  color: #8a641b;\n  font-size: 12px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.sankalp-carousel-heading strong {\n  font-size: 18px;\n}\n\n.sankalp-carousel-controls {\n  display: flex;\n  gap: 8px;\n}\n\n.sankalp-carousel-controls button {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #d8cdb8;\n  border-radius: 50%;\n  color: #17211c;\n  cursor: pointer;\n  display: inline-flex;\n  height: 42px;\n  justify-content: center;\n  padding: 0;\n  width: 42px;\n}\n\n.sankalp-carousel-track {\n  display: flex;\n  gap: 12px;\n  min-width: 0;\n  overflow-x: auto;\n  overscroll-behavior-inline: contain;\n  padding: 3px;\n  scrollbar-width: none;\n  scroll-snap-type: x mandatory;\n}\n\n.sankalp-carousel-track::-webkit-scrollbar {\n  display: none;\n}\n\n.sankalp-slide {\n  background: #fbfaf6;\n  border: 1px solid #ddd6c8;\n  border-radius: 8px;\n  color: #17211c;\n  cursor: pointer;\n  display: grid;\n  flex: 0 0 min(520px, calc(100% - 24px));\n  gap: 12px;\n  min-height: 214px;\n  padding: 20px;\n  scroll-snap-align: center;\n  text-align: left;\n  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;\n}\n\n.sankalp-slide.active {\n  border-color: #d7a84f;\n  box-shadow: 0 12px 32px rgba(34, 55, 42, 0.12), 0 0 0 2px rgba(215, 168, 79, 0.16);\n  transform: translateY(-1px);\n}\n\n.sankalp-slide-topline,\n.sankalp-slide-metrics {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.sankalp-slide-topline span {\n  background: #efe4c9;\n  border-radius: 999px;\n  color: #755617;\n  font-size: 12px;\n  font-weight: 800;\n  padding: 5px 9px;\n}\n\n.sankalp-slide-topline strong {\n  color: #245f39;\n  font-size: 14px;\n}\n\n.sankalp-slide h3 {\n  font-size: 22px;\n  margin: 0;\n}\n\n.sankalp-progress {\n  background: #e8e2d6;\n  border-radius: 999px;\n  height: 9px;\n  overflow: hidden;\n}\n\n.sankalp-progress i {\n  background: #2f7d46;\n  border-radius: inherit;\n  display: block;\n  height: 100%;\n  min-width: 4px;\n  transition: width 480ms cubic-bezier(0.2, 0.75, 0.25, 1);\n}\n\n.sankalp-slide-metrics {\n  color: #536158;\n  gap: 14px;\n}\n\n.sankalp-slide-metrics span {\n  align-items: center;\n  display: inline-flex;\n  gap: 6px;\n}\n\n.sankalp-slide small {\n  color: #755617;\n  font-weight: 700;\n}\n\n.sankalp-carousel-dots {\n  display: flex;\n  gap: 7px;\n  justify-content: center;\n}\n\n.sankalp-carousel-dots button {\n  background: #cfc7b7;\n  border: 0;\n  border-radius: 999px;\n  cursor: pointer;\n  height: 7px;\n  padding: 0;\n  transition: background 180ms ease, width 180ms ease;\n  width: 7px;\n}\n\n.sankalp-carousel-dots button.active {\n  background: #2f7d46;\n  width: 24px;\n}\n\n.allocation-wallet-pill {\n  background: #edf4ee;\n  border: 1px solid #c9ddcd;\n  border-radius: 999px;\n  color: #245f39;\n  padding: 9px 13px;\n  white-space: nowrap;\n}\n\n.sankalp-allocation-form {\n  border-top: 1px solid #e2ded3;\n  padding-top: 18px;\n}\n\n.sabha-intro-band {\n  display: grid;\n  gap: 18px;\n}\n\n.sabha-rule-grid {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.sabha-rule-grid span {\n  background: #f0eadc;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  font-weight: 800;\n  padding: 12px;\n}\n\n.proposal-grid {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  margin-top: 18px;\n}\n\n.proposal-card {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: grid;\n  gap: 12px;\n  padding: 16px;\n}\n\n.proposal-card h3 {\n  margin: 0;\n}\n\n.proposal-card p,\n.proposal-card small {\n  color: #4e5b53;\n  line-height: 1.5;\n}\n\n.compact-proposal-card {\n  min-height: 160px;\n}\n\n.vote-meter {\n  background: #e7dfd0;\n  border-radius: 999px;\n  height: 10px;\n  overflow: hidden;\n}\n\n.vote-meter span {\n  background: #d7a84f;\n  display: block;\n  height: 100%;\n}\n\n.vote-actions {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n}\n\n.vote-actions button {\n  background: #17211c;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  min-height: 44px;\n  padding: 10px;\n}\n\n.button-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  margin-top: 14px;\n}\n\n.copy-box {\n  align-items: center;\n  background: #f4f1e9;\n  border: 1px solid #ded8ca;\n  border-radius: 8px;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  margin-top: 16px;\n  overflow-wrap: anywhere;\n  padding: 14px;\n}\n\n.copy-box span {\n  min-width: 0;\n}\n\n.copy-box button {\n  background: #17211c;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  flex: 0 0 auto;\n  padding: 10px 14px;\n}\n\n.list-stack {\n  display: grid;\n  gap: 10px;\n  margin-top: 18px;\n}\n\n.list-row {\n  align-items: center;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  color: #18201b;\n  display: flex;\n  justify-content: space-between;\n  padding: 12px 14px;\n  text-align: left;\n  width: 100%;\n}\n\n.invite-row {\n  align-items: center;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n  padding: 12px 14px;\n}\n\n.member-row {\n  align-items: center;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n  padding: 12px 14px;\n}\n\n.ledger-row {\n  align-items: center;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: flex;\n  gap: 16px;\n  justify-content: space-between;\n  padding: 12px 14px;\n}\n\n.ledger-row span,\n.ledger-row small,\n.ledger-member span {\n  color: #4e5b53;\n  display: block;\n  margin-top: 4px;\n  text-transform: capitalize;\n}\n\n.ledger-member {\n  text-align: right;\n}\n\n.document-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 10px;\n}\n\n.document-list button {\n  background: #eef1ea;\n  border: 0;\n  border-radius: 8px;\n  color: #17211c;\n  cursor: pointer;\n  padding: 8px 10px;\n}\n\n.member-row span {\n  color: #4e5b53;\n  display: block;\n  margin-top: 4px;\n  text-transform: capitalize;\n}\n\n.member-summary {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n}\n\n.member-avatar {\n  align-items: center;\n  background: #ebe5d9;\n  border-radius: 999px;\n  color: #17211c;\n  display: inline-flex;\n  flex: 0 0 auto;\n  height: 42px;\n  justify-content: center;\n  overflow: hidden;\n  width: 42px;\n}\n\n.member-avatar.deceased {\n  background: #ece7dc;\n  border: 2px solid #b8ad9b;\n  color: #615849;\n}\n\n.member-avatar.female {\n  background: #f2dfdd;\n  color: #6f2b38;\n}\n\n.member-avatar.male {\n  background: #dfe8ef;\n  color: #24435b;\n}\n\n.member-avatar.male.deceased,\n.member-avatar.female.deceased,\n.member-avatar.unknown.deceased {\n  background: #ece7dc;\n  color: #615849;\n}\n\n.member-avatar.has-photo {\n  background: #ffffff;\n}\n\n.member-avatar.has-photo.deceased {\n  background: #ece7dc;\n}\n\n.member-avatar img {\n  display: block;\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n.member-avatar.deceased img {\n  filter: grayscale(1) sepia(0.15);\n  opacity: 0.82;\n}\n\n.avatar-letter {\n  font-size: 14px;\n  font-weight: 800;\n  line-height: 1;\n}\n\n.invite-row span {\n  color: #4e5b53;\n  display: block;\n  margin-top: 4px;\n  text-transform: capitalize;\n}\n\n.row-actions {\n  display: flex;\n  flex: 0 0 auto;\n  gap: 8px;\n}\n\n.row-actions select {\n  border: 1px solid #cfc8bc;\n  border-radius: 8px;\n  padding: 10px 12px;\n}\n\n.reject-reason {\n  display: grid;\n  gap: 8px;\n  margin-top: 16px;\n}\n\n.reject-reason input {\n  border: 1px solid #cfc8bc;\n  border-radius: 8px;\n  padding: 12px;\n}\n\n.spaced-band {\n  margin-top: 20px;\n}\n\n.text-link {\n  color: #17211c;\n  display: inline-block;\n  margin-top: 18px;\n}\n\n.empty-state {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: grid;\n  gap: 10px;\n  margin: 16px 0;\n  padding: 18px;\n}\n\n.empty-state h3,\n.empty-state p {\n  margin: 0;\n}\n\n.empty-state p {\n  color: #4e5b53;\n  line-height: 1.5;\n}\n\n.empty-state .secondary-button {\n  display: inline-flex;\n  justify-self: start;\n  text-decoration: none;\n}\n\n.home-page {\n  background: #f7f4ee;\n  color: #18201b;\n  min-height: 100vh;\n}\n\n.launch-stage {\n  align-items: center;\n  background: #132019;\n  color: #f8f4eb;\n  display: flex;\n  inset: 0;\n  justify-content: center;\n  min-height: 100vh;\n  min-height: 100dvh;\n  overflow: hidden;\n  padding: 24px 24px 96px;\n  position: fixed;\n  z-index: 100;\n}\n\n.launch-stage::before,\n.launch-stage::after {\n  border: 1px solid rgba(215, 168, 79, 0.4);\n  content: \"\";\n  inset: 28px;\n  pointer-events: none;\n  position: absolute;\n}\n\n.launch-stage::after {\n  inset: 42px;\n  opacity: 0.35;\n}\n\n.launch-om-burst {\n  color: rgba(255, 214, 126, 0.34);\n  font-size: clamp(52px, 9vw, 142px);\n  font-weight: 900;\n  left: 50%;\n  letter-spacing: 0;\n  line-height: 1;\n  max-width: min(88vw, 980px);\n  opacity: 0;\n  pointer-events: none;\n  position: absolute;\n  text-align: center;\n  text-shadow: 0 0 30px rgba(255, 206, 93, 0.48);\n  top: 28%;\n  transform: translate(-50%, -50%) scale(0.18);\n  white-space: normal;\n  z-index: 2;\n}\n\n.launch-stage-active .launch-om-burst {\n  animation: launchOmBurst 3.4s ease-out forwards;\n}\n\n.launch-blessing-2 {\n  color: rgba(255, 244, 198, 0.36);\n  top: 53%;\n}\n\n.launch-blessing-3 {\n  color: rgba(215, 168, 79, 0.38);\n  top: 75%;\n}\n\n.launch-stage-inner {\n  align-items: center;\n  display: grid;\n  gap: 12px;\n  justify-items: center;\n  max-height: calc(100dvh - 122px);\n  max-width: 920px;\n  position: relative;\n  text-align: center;\n  z-index: 3;\n}\n\n.launch-logo-ring {\n  align-items: center;\n  animation: launchLogoFloat 3.6s ease-in-out infinite;\n  background: #f8f4eb;\n  border: 2px solid #d7a84f;\n  border-radius: 999px;\n  box-shadow: 0 0 0 12px rgba(215, 168, 79, 0.08);\n  display: inline-flex;\n  height: 108px;\n  justify-content: center;\n  overflow: hidden;\n  width: 108px;\n}\n\n.launch-logo-ring img {\n  height: 90px;\n  object-fit: cover;\n  width: 90px;\n}\n\n.launch-kicker {\n  color: #d7a84f;\n  font-weight: 800;\n  margin: 0;\n  text-transform: uppercase;\n}\n\n.launch-stage h1 {\n  color: #fff;\n  font-size: clamp(54px, 10vw, 124px);\n  line-height: 0.9;\n  margin: 0;\n}\n\n.launch-subtitle {\n  color: #e7dfd0;\n  font-size: clamp(18px, 2.4vw, 28px);\n  margin: 0;\n}\n\n.launch-bell-button {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 8px;\n  color: #f8f4eb;\n  cursor: pointer;\n  display: grid;\n  font-weight: 900;\n  gap: 8px;\n  justify-content: center;\n  justify-items: center;\n  min-height: 152px;\n  min-width: 170px;\n  padding: 0;\n  position: relative;\n}\n\n.launch-bell-button:hover,\n.launch-bell-button:focus-visible {\n  filter: drop-shadow(0 0 24px rgba(255, 190, 75, 0.38));\n}\n\n.launch-bell-button:disabled {\n  cursor: default;\n  opacity: 0.78;\n}\n\n.temple-bell-wrap {\n  align-items: center;\n  display: inline-flex;\n  height: 122px;\n  justify-content: center;\n  position: relative;\n  width: 130px;\n}\n\n.temple-bell-wrap::before {\n  background: radial-gradient(circle, rgba(255, 190, 75, 0.2), transparent 68%);\n  content: \"\";\n  inset: -32px;\n  opacity: 0.78;\n  position: absolute;\n}\n\n.temple-bell-rope {\n  background:\n    repeating-linear-gradient(90deg, #b72e22 0 4px, #f6c451 4px 8px),\n    #b72e22;\n  border-radius: 0 0 999px 999px;\n  box-shadow: 0 0 0 2px rgba(255, 214, 126, 0.22);\n  height: 44px;\n  left: 50%;\n  position: absolute;\n  top: -12px;\n  transform: translateX(-50%);\n  width: 9px;\n}\n\n.temple-bell-rope::after {\n  background: #b72e22;\n  border: 2px solid #f6c451;\n  border-radius: 999px;\n  content: \"\";\n  height: 18px;\n  left: 50%;\n  position: absolute;\n  top: 34px;\n  transform: translateX(-50%);\n  width: 18px;\n}\n\n.temple-bell {\n  bottom: 0;\n  height: 98px;\n  position: absolute;\n  transform-origin: 50% 0;\n  width: 112px;\n}\n\n.temple-bell-cap {\n  background:\n    radial-gradient(circle at 38% 28%, #fff4c4, transparent 26%),\n    linear-gradient(135deg, #ffe184, #c98219 50%, #6b3c08);\n  border: 2px solid rgba(255, 222, 135, 0.86);\n  border-radius: 999px 999px 14px 14px;\n  box-shadow: inset -10px -8px 16px rgba(74, 43, 9, 0.28);\n  height: 26px;\n  left: 50%;\n  position: absolute;\n  top: 2px;\n  transform: translateX(-50%);\n  width: 52px;\n}\n\n.temple-bell-body {\n  background:\n    radial-gradient(circle at 32% 22%, rgba(255, 246, 199, 0.96), transparent 16%),\n    radial-gradient(ellipse at 50% 100%, rgba(50, 27, 5, 0.72), transparent 31%),\n    linear-gradient(100deg, #6b3c08 0%, #c98219 14%, #ffd76f 34%, #bb7217 58%, #74430b 100%);\n  border: 2px solid rgba(255, 222, 135, 0.84);\n  border-radius: 60px 60px 18px 18px;\n  box-shadow:\n    inset 13px 0 20px rgba(255, 244, 196, 0.35),\n    inset -18px -10px 24px rgba(63, 36, 6, 0.48),\n    0 20px 40px rgba(0, 0, 0, 0.26);\n  clip-path: polygon(29% 0, 71% 0, 93% 83%, 100% 93%, 0 93%, 7% 83%);\n  height: 76px;\n  left: 50%;\n  position: absolute;\n  top: 24px;\n  transform: translateX(-50%);\n  width: 100px;\n}\n\n.temple-bell-body::before {\n  background:\n    linear-gradient(90deg, transparent, rgba(255, 241, 181, 0.7), transparent),\n    linear-gradient(90deg, #7a470b, #f0b743, #7a470b);\n  border-radius: 999px;\n  content: \"\";\n  height: 8px;\n  left: 50%;\n  position: absolute;\n  top: 54px;\n  transform: translateX(-50%);\n  width: 94px;\n}\n\n.temple-bell-lip {\n  background:\n    radial-gradient(ellipse at center, rgba(32, 18, 5, 0.92) 0 48%, transparent 52%),\n    linear-gradient(90deg, #5f3306, #f7c659 28%, #b66b13 55%, #4c2a06);\n  border: 2px solid rgba(255, 221, 132, 0.82);\n  border-radius: 999px;\n  bottom: 2px;\n  height: 20px;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n  width: 110px;\n}\n\n.temple-bell-clapper {\n  background: radial-gradient(circle at 35% 30%, #fff0ba, #c27a19 58%, #5f3306);\n  border: 1px solid rgba(255, 226, 150, 0.82);\n  border-radius: 999px;\n  bottom: -8px;\n  height: 24px;\n  left: 50%;\n  position: absolute;\n  transform: translateX(-50%);\n  width: 24px;\n}\n\n.launch-bell-ringing .temple-bell {\n  animation: launchBellRing 1.6s ease-in-out 2;\n}\n\n.launch-bell-ringing .temple-bell-clapper {\n  animation: launchClapperRing 1.6s ease-in-out 2;\n}\n\n.launch-bell-ringing .launch-bell-button {\n  filter: drop-shadow(0 0 42px rgba(255, 190, 75, 0.52));\n}\n\n.launch-sequence-line {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 10px;\n  justify-content: center;\n  margin-top: 10px;\n}\n\n.launch-sequence-line span {\n  background: rgba(248, 244, 235, 0.08);\n  border: 1px solid rgba(215, 168, 79, 0.36);\n  border-radius: 999px;\n  color: #f8f4eb;\n  opacity: 0.38;\n  padding: 10px 14px;\n}\n\n.launch-stage-active .launch-sequence-line span {\n  animation: launchStepReveal 0.75s ease forwards;\n}\n\n.launch-reveal-card {\n  background: #f8f4eb;\n  border: 1px solid #d7a84f;\n  border-radius: 8px;\n  color: #17211c;\n  display: grid;\n  gap: 6px;\n  margin-top: 10px;\n  max-width: 620px;\n  opacity: 0;\n  padding: 18px;\n  transform: translateY(14px);\n}\n\n.launch-stage-active .launch-reveal-card {\n  animation: launchCardReveal 0.9s ease 4.8s forwards;\n}\n\n.launch-reveal-card strong {\n  font-size: 24px;\n}\n\n.launch-reveal-card span {\n  color: #4e5b53;\n  line-height: 1.5;\n}\n\n.launch-controls {\n  bottom: 28px;\n  left: 50%;\n  min-height: 52px;\n  position: fixed;\n  transform: translateX(-50%);\n  z-index: 6;\n}\n\n.launch-controls button,\n.launch-skip-button {\n  align-items: center;\n  background: #d7a84f;\n  border: 0;\n  border-radius: 8px;\n  color: #17211c;\n  cursor: pointer;\n  display: inline-flex;\n  font-weight: 900;\n  gap: 8px;\n  justify-content: center;\n  min-height: 48px;\n  padding: 12px 18px;\n}\n\n.launch-skip-button {\n  background: rgba(248, 244, 235, 0.1);\n  color: #f8f4eb;\n  position: absolute;\n  right: 24px;\n  top: 24px;\n  z-index: 2;\n}\n\n@keyframes launchLogoFloat {\n  0%,\n  100% {\n    transform: translateY(0) scale(1);\n  }\n\n  50% {\n    transform: translateY(-8px) scale(1.02);\n  }\n}\n\n@keyframes launchOmBurst {\n  0% {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(0.12);\n  }\n\n  24% {\n    opacity: 1;\n    text-shadow: 0 0 28px rgba(255, 206, 93, 0.58);\n    transform: translate(-50%, -50%) scale(1);\n  }\n\n  56% {\n    opacity: 0.46;\n    transform: translate(-50%, -50%) scale(2.2);\n  }\n\n  100% {\n    opacity: 0;\n    transform: translate(-50%, -50%) scale(4.2);\n  }\n}\n\n@keyframes launchBellRing {\n  0%,\n  100% {\n    transform: rotate(0deg);\n  }\n\n  10% {\n    transform: rotate(18deg);\n  }\n\n  22% {\n    transform: rotate(-16deg);\n  }\n\n  35% {\n    transform: rotate(11deg);\n  }\n\n  48% {\n    transform: rotate(-9deg);\n  }\n\n  62% {\n    transform: rotate(5deg);\n  }\n\n  78% {\n    transform: rotate(-3deg);\n  }\n}\n\n@keyframes launchClapperRing {\n  0%,\n  100% {\n    transform: translateX(-50%);\n  }\n\n  10% {\n    transform: translateX(-112%);\n  }\n\n  22% {\n    transform: translateX(12%);\n  }\n\n  35% {\n    transform: translateX(-92%);\n  }\n\n  48% {\n    transform: translateX(-8%);\n  }\n\n  62% {\n    transform: translateX(-66%);\n  }\n\n  78% {\n    transform: translateX(-36%);\n  }\n}\n\n@keyframes launchStepReveal {\n  0% {\n    opacity: 0.38;\n    transform: translateY(8px);\n  }\n\n  100% {\n    background: #d7a84f;\n    color: #17211c;\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n@keyframes launchCardReveal {\n  100% {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.home-nav {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin: 0 auto;\n  max-width: 1180px;\n  padding: 24px;\n}\n\n.home-brand,\n.home-nav-actions,\n.home-actions,\n.home-kicker {\n  align-items: center;\n  display: flex;\n}\n\n.home-brand {\n  gap: 12px;\n}\n\n.home-brand-logo {\n  border-radius: 8px;\n  height: 44px;\n  object-fit: cover;\n  width: 44px;\n}\n\n.home-brand small {\n  color: #68756e;\n  display: block;\n}\n\n.home-nav-actions {\n  flex-wrap: wrap;\n  gap: 12px;\n  justify-content: flex-end;\n}\n\n.home-nav-actions a,\n.home-secondary {\n  color: #17211c;\n  text-decoration: none;\n}\n\n.home-primary-link,\n.home-cta {\n  background: #17211c;\n  border-radius: 8px;\n  color: #fff !important;\n  padding: 10px 14px;\n  text-decoration: none;\n}\n\n.home-hero {\n  align-items: center;\n  display: grid;\n  gap: 42px;\n  grid-template-columns: minmax(0, 0.9fr) minmax(420px, 1fr);\n  margin: 0 auto;\n  max-width: 1180px;\n  min-height: calc(100vh - 96px);\n  padding: 24px 24px 72px;\n}\n\n.home-hero-logo {\n  border-radius: 8px;\n  display: block;\n  height: 112px;\n  margin-bottom: 24px;\n  object-fit: cover;\n  width: 112px;\n}\n\n.home-hero-copy h1 {\n  font-size: 56px;\n  line-height: 1;\n  margin: 18px 0;\n  max-width: 820px;\n}\n\n.home-hero-copy p {\n  color: #4e5b53;\n  font-size: 20px;\n  line-height: 1.55;\n  max-width: 720px;\n}\n\n.home-hero-copy .home-blessing-line {\n  color: #34513f;\n  font-size: 18px;\n  margin-top: 14px;\n}\n\n.home-kicker {\n  color: #34513f;\n  gap: 8px;\n}\n\n.home-actions {\n  gap: 14px;\n  margin-top: 28px;\n}\n\n.village-pill-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-top: 18px;\n}\n\n.village-pill-row span {\n  background: #f0eadc;\n  border: 1px solid #e2ded3;\n  border-radius: 999px;\n  color: #34513f;\n  padding: 8px 12px;\n}\n\n.home-cta {\n  align-items: center;\n  display: inline-flex;\n  gap: 8px;\n  padding: 14px 18px;\n}\n\n.family-hero-card {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  box-shadow: 0 24px 60px rgba(35, 32, 26, 0.12);\n  overflow: hidden;\n}\n\n.family-hero-card > img {\n  aspect-ratio: 16 / 10;\n  display: block;\n  object-fit: cover;\n  width: 100%;\n}\n\n.family-hero-overlay {\n  align-items: center;\n  background: #ffffff;\n  border-bottom: 1px solid #e2ded3;\n  display: flex;\n  justify-content: space-between;\n  padding: 14px 18px;\n}\n\n.family-hero-overlay strong {\n  background: #d7a84f;\n  border-radius: 999px;\n  padding: 7px 10px;\n}\n\n.portal-preview {\n  padding: 18px;\n}\n\n.preview-header,\n.preview-row {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n}\n\n.preview-header strong {\n  background: #d7a84f;\n  border-radius: 999px;\n  padding: 7px 10px;\n}\n\n.preview-metrics {\n  display: grid;\n  gap: 10px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-top: 18px;\n}\n\n.preview-metrics div,\n.preview-mission,\n.walkthrough-card,\n.home-band div,\n.launch-grid article {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  padding: 16px;\n}\n\n.preview-metrics span,\n.preview-mission span {\n  color: #68756e;\n  display: block;\n  margin-bottom: 6px;\n}\n\n.preview-metrics strong {\n  font-size: 24px;\n}\n\n.preview-mission {\n  margin-top: 12px;\n}\n\n.preview-progress {\n  background: #e7e1d5;\n  border-radius: 999px;\n  height: 10px;\n  margin-top: 14px;\n  overflow: hidden;\n}\n\n.preview-progress span {\n  background: #d7a84f;\n  display: block;\n  height: 100%;\n}\n\n.preview-row {\n  color: #34513f;\n  gap: 10px;\n  justify-content: flex-start;\n  margin-top: 14px;\n}\n\n.home-section,\n.home-band {\n  margin: 0 auto;\n  max-width: 1180px;\n  padding: 56px 24px;\n}\n\n.home-section-heading {\n  max-width: 680px;\n}\n\n.home-section-heading span,\n.interactive-section > div > span {\n  color: #68756e;\n}\n\n.home-section h2 {\n  font-size: 36px;\n  line-height: 1.1;\n  margin: 8px 0 22px;\n}\n\n.today-start-section {\n  padding-top: 24px;\n}\n\n.today-start-section .home-section-heading p {\n  color: #4e5b53;\n  font-size: 18px;\n  line-height: 1.55;\n  margin: 0;\n}\n\n.today-step-grid {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin-top: 24px;\n}\n\n.today-step-grid article,\n.today-action-panel {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);\n}\n\n.today-step-grid article {\n  padding: 18px;\n}\n\n.today-step-grid svg {\n  color: #34513f;\n}\n\n.today-step-grid h3 {\n  margin: 12px 0 8px;\n}\n\n.today-step-grid p {\n  color: #4e5b53;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.today-action-panel {\n  align-items: center;\n  display: flex;\n  gap: 18px;\n  justify-content: space-between;\n  margin-top: 16px;\n  padding: 20px;\n}\n\n.today-action-panel strong,\n.today-action-panel span {\n  display: block;\n}\n\n.today-action-panel span {\n  color: #4e5b53;\n  line-height: 1.5;\n  margin-top: 6px;\n  max-width: 780px;\n}\n\n.launch-message-section {\n  align-items: stretch;\n  display: grid;\n  gap: 18px;\n  grid-template-columns: minmax(0, 1fr) minmax(320px, 0.65fr);\n  padding-top: 24px;\n}\n\n.launch-note-card,\n.launch-message-list {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);\n  padding: 24px;\n}\n\n.launch-note-card p {\n  color: #4e5b53;\n  font-size: 18px;\n  line-height: 1.65;\n  margin: 0;\n}\n\n.launch-note-card blockquote {\n  border-left: 4px solid #d7a84f;\n  color: #17211c;\n  font-size: 22px;\n  font-weight: 700;\n  line-height: 1.45;\n  margin: 24px 0 0;\n  padding-left: 18px;\n}\n\n.launch-message-list {\n  align-content: center;\n  display: grid;\n  gap: 12px;\n}\n\n.launch-message-list div {\n  align-items: flex-start;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  color: #34513f;\n  display: flex;\n  gap: 10px;\n  line-height: 1.5;\n  padding: 14px;\n}\n\n.launch-message-list svg {\n  flex: 0 0 auto;\n  margin-top: 2px;\n}\n\n.village-section {\n  align-items: center;\n  display: grid;\n  gap: 28px;\n  grid-template-columns: minmax(0, 0.9fr) minmax(320px, 0.7fr);\n}\n\n.village-story > span {\n  align-items: center;\n  color: #34513f;\n  display: inline-flex;\n  gap: 8px;\n}\n\n.village-story h2 {\n  max-width: 760px;\n}\n\n.village-story p {\n  color: #4e5b53;\n  font-size: 18px;\n  line-height: 1.55;\n  margin: 0;\n  max-width: 780px;\n}\n\n.village-focus-grid {\n  display: grid;\n  gap: 12px;\n}\n\n.village-focus-grid div {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);\n  padding: 16px;\n}\n\n.village-focus-grid strong,\n.village-focus-grid span {\n  display: block;\n}\n\n.village-focus-grid span {\n  color: #4e5b53;\n  line-height: 1.5;\n  margin-top: 6px;\n}\n\n.market-section {\n  padding-top: 24px;\n}\n\n.market-section .home-section-heading p {\n  color: #4e5b53;\n  font-size: 18px;\n  line-height: 1.55;\n  margin: 0;\n}\n\n.customer-segment-grid,\n.pricing-grid {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  margin-top: 24px;\n}\n\n.customer-segment-grid article,\n.pricing-grid article,\n.market-position-card,\n.pricing-note {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);\n}\n\n.customer-segment-grid article,\n.pricing-grid article {\n  padding: 18px;\n}\n\n.customer-segment-grid svg {\n  color: #34513f;\n}\n\n.customer-segment-grid h3,\n.pricing-grid p,\n.customer-segment-grid p {\n  margin: 10px 0 0;\n}\n\n.customer-segment-grid p,\n.pricing-grid p {\n  color: #4e5b53;\n  line-height: 1.5;\n}\n\n.market-position-card {\n  align-items: center;\n  display: flex;\n  gap: 18px;\n  justify-content: space-between;\n  margin-top: 16px;\n  padding: 22px;\n}\n\n.market-position-card span,\n.pricing-grid article > span {\n  color: #68756e;\n  display: block;\n}\n\n.market-position-card strong {\n  display: block;\n  font-size: 24px;\n  margin-top: 6px;\n}\n\n.market-position-card p {\n  color: #4e5b53;\n  line-height: 1.55;\n  margin: 8px 0 0;\n  max-width: 760px;\n}\n\n.pricing-section {\n  padding-top: 24px;\n}\n\n.pricing-grid {\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.pricing-grid article {\n  display: grid;\n  gap: 12px;\n}\n\n.pricing-grid strong {\n  color: #17211c;\n  font-size: 30px;\n}\n\n.pricing-grid ul {\n  display: grid;\n  gap: 10px;\n  list-style: none;\n  margin: 4px 0 0;\n  padding: 0;\n}\n\n.pricing-grid li {\n  align-items: center;\n  color: #34513f;\n  display: flex;\n  gap: 8px;\n}\n\n.pricing-note {\n  display: grid;\n  gap: 6px;\n  margin-top: 16px;\n  padding: 18px;\n}\n\n.pricing-note span {\n  color: #4e5b53;\n  line-height: 1.5;\n}\n\n.home-snapshot-section {\n  padding-top: 24px;\n}\n\n.home-snapshot-grid {\n  display: grid;\n  gap: 14px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n}\n\n.home-snapshot-grid div {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);\n  padding: 18px;\n}\n\n.home-snapshot-grid span {\n  color: #68756e;\n}\n\n.home-snapshot-grid strong {\n  color: #17211c;\n  display: block;\n  font-size: 30px;\n  margin-top: 8px;\n}\n\n.family-gallery-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: minmax(0, 1.2fr) minmax(0, 1fr);\n}\n\n.family-gallery-grid figure {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  box-shadow: 0 10px 30px rgba(35, 32, 26, 0.06);\n  margin: 0;\n  overflow: hidden;\n}\n\n.family-gallery-grid img {\n  aspect-ratio: 16 / 9;\n  display: block;\n  object-fit: cover;\n  width: 100%;\n}\n\n.family-gallery-grid figcaption {\n  display: grid;\n  gap: 4px;\n  padding: 16px;\n}\n\n.family-gallery-grid figcaption span {\n  color: #4e5b53;\n}\n\n.launch-grid,\n.home-band,\n.future-grid {\n  display: grid;\n  gap: 16px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n}\n\n.launch-grid article svg,\n.home-band svg,\n.future-grid svg {\n  color: #34513f;\n}\n\n.launch-grid h3,\n.home-band strong,\n.future-grid h3 {\n  display: block;\n  margin: 12px 0 8px;\n}\n\n.launch-grid p,\n.home-band p,\n.interactive-section p,\n.future-grid p {\n  color: #4e5b53;\n  line-height: 1.5;\n  margin: 0;\n}\n\n.future-grid article {\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  padding: 18px;\n}\n\n.future-grid article > span {\n  background: #f0eadc;\n  border-radius: 999px;\n  color: #34513f;\n  display: inline-flex;\n  font-size: 13px;\n  margin-top: 16px;\n  padding: 6px 10px;\n}\n\n.interactive-section {\n  align-items: center;\n  display: grid;\n  gap: 28px;\n  grid-template-columns: minmax(0, 0.8fr) minmax(320px, 0.6fr);\n}\n\n.segmented-control {\n  background: #ebe5d9;\n  border-radius: 8px;\n  display: inline-flex;\n  gap: 4px;\n  margin-top: 22px;\n  padding: 4px;\n}\n\n.segmented-control button {\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  cursor: pointer;\n  padding: 10px 12px;\n}\n\n.segmented-control button.active {\n  background: #ffffff;\n}\n\n.walkthrough-card ul {\n  display: grid;\n  gap: 12px;\n  list-style: none;\n  margin: 16px 0 0;\n  padding: 0;\n}\n\n.walkthrough-card li {\n  align-items: center;\n  display: flex;\n  gap: 10px;\n}\n\n.profile-form {\n  align-items: end;\n}\n\n.account-security-section {\n  background: #f4f8f4;\n  border: 1px solid #bfd2c4;\n  border-left: 4px solid #2f6947;\n  border-radius: 6px;\n  margin: 18px 0 24px;\n  padding: 18px;\n}\n\n.account-security-section h3 {\n  margin: 0 0 6px;\n}\n\n.security-form {\n  align-items: end;\n  margin-top: 14px;\n}\n\n.transaction-security-callout {\n  align-items: center;\n  background: #fff8e7;\n  border: 1px solid #dfbf72;\n  border-left: 5px solid #b98624;\n  display: flex;\n  gap: 18px;\n  justify-content: space-between;\n  margin-bottom: 18px;\n  padding: 16px 18px;\n}\n\n.transaction-security-callout div {\n  display: grid;\n  gap: 4px;\n}\n\n.transaction-security-callout span {\n  color: #4e5e55;\n}\n\n.transaction-security-callout .secondary-button {\n  background: #173c29;\n  border-color: #173c29;\n  color: #ffffff;\n  flex: 0 0 auto;\n  font-weight: 700;\n  text-decoration: none;\n}\n\n.home-app-note {\n  color: #68756e;\n  display: block;\n  line-height: 1.5;\n  margin-top: 10px;\n}\n\n.transaction-security-callout .secondary-button:hover,\n.transaction-security-callout .secondary-button:focus-visible {\n  background: #245c3f;\n  border-color: #245c3f;\n  color: #ffffff;\n}\n\n.payment-test-banner {\n  align-items: center;\n  background: #fff7dd;\n  border: 1px solid #d7a84f;\n  border-left: 4px solid #a26e11;\n  border-radius: 6px;\n  color: #57461f;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin: 14px 0;\n  padding: 11px 13px;\n}\n\n.payment-test-banner strong {\n  color: #17211c;\n}\n\n.home-legal-footer {\n  align-items: center;\n  background: #111d17;\n  color: #edf2ee;\n  display: grid;\n  gap: 24px;\n  grid-template-columns: minmax(220px, 0.7fr) minmax(280px, 1.4fr) auto;\n  margin-top: 34px;\n  padding: 34px max(5vw, 28px);\n}\n\n.home-legal-footer > div:first-child {\n  align-items: center;\n  display: flex;\n  gap: 12px;\n}\n\n.home-legal-footer img {\n  background: #fff;\n  border-radius: 6px;\n  height: 52px;\n  object-fit: contain;\n  width: 52px;\n}\n\n.home-legal-footer strong,\n.home-legal-footer span {\n  display: block;\n}\n\n.home-legal-footer p {\n  color: #c8d2cc;\n  line-height: 1.65;\n  margin: 0;\n}\n\n.home-legal-links {\n  display: grid;\n  gap: 9px;\n  justify-items: end;\n}\n\n.home-legal-links a {\n  color: #fff;\n}\n\n.legal-page {\n  background: #f7f4ee;\n  color: #17211c;\n  min-height: 100vh;\n}\n\n.legal-header,\n.legal-content,\n.legal-page-footer {\n  margin: 0 auto;\n  max-width: 1120px;\n  padding-left: 28px;\n  padding-right: 28px;\n}\n\n.legal-header {\n  padding-bottom: 48px;\n  padding-top: 30px;\n}\n\n.legal-header img {\n  display: block;\n  height: 74px;\n  margin: 54px 0 28px;\n  object-fit: contain;\n  width: 74px;\n}\n\n.legal-header > span,\n.legal-identity-band span,\n.legal-contact-band span {\n  color: #6c5b32;\n  display: block;\n  font-size: 13px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.legal-header h1 {\n  font-size: clamp(36px, 5vw, 64px);\n  line-height: 1.02;\n  margin: 10px 0 16px;\n}\n\n.legal-header p {\n  color: #526158;\n  font-size: 20px;\n  margin: 0;\n}\n\n.legal-back-link {\n  align-items: center;\n  color: #17211c;\n  display: inline-flex;\n  gap: 8px;\n}\n\n.legal-identity-band {\n  background: #17211c;\n  color: #fff;\n  display: grid;\n  gap: 1px;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  padding: 0 max(calc((100vw - 1120px) / 2 + 28px), 28px);\n}\n\n.legal-identity-band div {\n  border-left: 1px solid #38483f;\n  min-width: 0;\n  padding: 25px 20px;\n}\n\n.legal-identity-band div:last-child {\n  border-right: 1px solid #38483f;\n}\n\n.legal-identity-band span {\n  color: #d7b86e;\n  margin-bottom: 7px;\n}\n\n.legal-identity-band strong {\n  overflow-wrap: anywhere;\n}\n\n.legal-content {\n  display: grid;\n  gap: 0;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  padding-bottom: 58px;\n  padding-top: 58px;\n}\n\n.legal-content article {\n  border-bottom: 1px solid #dcd6ca;\n  padding: 30px 34px 30px 0;\n}\n\n.legal-content article:nth-child(even) {\n  border-left: 1px solid #dcd6ca;\n  padding-left: 34px;\n}\n\n.legal-content article svg {\n  color: #a26e11;\n}\n\n.legal-content h2 {\n  font-size: 24px;\n  margin: 14px 0 12px;\n}\n\n.legal-content p {\n  color: #4f5e55;\n  line-height: 1.68;\n}\n\n.legal-contact-band {\n  align-items: center;\n  background: #ead7a6;\n  display: grid;\n  gap: 26px;\n  grid-template-columns: 0.7fr 1.5fr auto;\n  padding: 30px max(calc((100vw - 1120px) / 2 + 28px), 28px);\n}\n\n.legal-contact-band p {\n  line-height: 1.55;\n  margin: 0;\n}\n\n.legal-contact-band a {\n  background: #17211c;\n  border-radius: 6px;\n  color: #fff;\n  padding: 12px 16px;\n  white-space: nowrap;\n}\n\n.legal-page-footer {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  padding-bottom: 32px;\n  padding-top: 32px;\n}\n\n.legal-page-footer a {\n  color: #17211c;\n}\n\n.legal-page-footer nav {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 18px;\n}\n\n.policy-page {\n  background: #f7f4ee;\n  color: #17211c;\n  min-height: 100vh;\n}\n\n.policy-page > header,\n.policy-body,\n.policy-page > footer {\n  margin: 0 auto;\n  max-width: 940px;\n  padding-left: 28px;\n  padding-right: 28px;\n}\n\n.policy-page > header {\n  padding-bottom: 42px;\n  padding-top: 30px;\n}\n\n.policy-page > header > a {\n  align-items: center;\n  color: #17211c;\n  display: inline-flex;\n  gap: 8px;\n}\n\n.policy-page > header img {\n  display: block;\n  height: 68px;\n  margin: 50px 0 24px;\n  object-fit: contain;\n  width: 68px;\n}\n\n.policy-page > header span {\n  color: #765a21;\n  display: block;\n  font-size: 13px;\n  font-weight: 800;\n  text-transform: uppercase;\n}\n\n.policy-page > header h1 {\n  font-size: clamp(36px, 5vw, 58px);\n  line-height: 1.05;\n  margin: 10px 0 14px;\n}\n\n.policy-page > header p {\n  color: #5b685f;\n  margin: 0;\n}\n\n.policy-body {\n  background: #fff;\n  border-bottom: 1px solid #ded8cc;\n  border-top: 1px solid #ded8cc;\n  padding-bottom: 42px;\n  padding-top: 42px;\n}\n\n.policy-body section + section {\n  border-top: 1px solid #e5e0d6;\n  margin-top: 28px;\n  padding-top: 28px;\n}\n\n.policy-body h2 {\n  font-size: 22px;\n  margin: 0 0 10px;\n}\n\n.policy-body p {\n  color: #4f5e55;\n  line-height: 1.72;\n  margin: 8px 0;\n}\n\n.policy-page > footer {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 20px;\n  padding-bottom: 34px;\n  padding-top: 34px;\n}\n\n.policy-page > footer a {\n  color: #17211c;\n}\n\n.account-deletion-form {\n  display: grid;\n  gap: 16px;\n  max-width: 680px;\n}\n\n.account-deletion-form label {\n  display: grid;\n  gap: 7px;\n  font-weight: 700;\n}\n\n.account-deletion-form textarea,\n.account-deletion-form input {\n  width: 100%;\n}\n\n.account-deletion-form button {\n  width: fit-content;\n}\n\n@media (max-width: 760px) {\n  .home-legal-footer,\n  .legal-contact-band {\n    grid-template-columns: 1fr;\n  }\n\n  .home-legal-links {\n    justify-items: start;\n  }\n\n  .legal-identity-band,\n  .legal-content {\n    grid-template-columns: 1fr;\n  }\n\n  .legal-identity-band div,\n  .legal-identity-band div:last-child {\n    border-bottom: 1px solid #38483f;\n    border-left: 0;\n    border-right: 0;\n  }\n\n  .legal-content article,\n  .legal-content article:nth-child(even) {\n    border-left: 0;\n    padding-left: 0;\n    padding-right: 0;\n  }\n\n  .legal-page-footer {\n    align-items: flex-start;\n    flex-direction: column;\n    gap: 10px;\n  }\n\n  .legal-page-footer nav {\n    display: grid;\n    gap: 10px;\n  }\n}\n\n.form-section-title {\n  border-top: 1px solid #e2ded3;\n  color: #17211c;\n  grid-column: 1 / -1;\n  margin: 18px 0 0;\n  padding-top: 18px;\n}\n\n.form-section-title:first-of-type {\n  border-top: 0;\n  margin-top: 0;\n  padding-top: 0;\n}\n\n.nested-fieldset {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: grid;\n  gap: 10px;\n  padding: 12px;\n}\n\n.nested-fieldset strong {\n  color: #17211c;\n}\n\n.nested-fieldset input {\n  min-width: 0;\n}\n\n.relative-card {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: grid;\n  gap: 14px;\n  grid-column: 1 / -1;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  padding: 14px;\n}\n\n.relative-search {\n  align-items: end;\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: grid;\n  gap: 10px;\n  grid-template-columns: minmax(0, 1fr) auto;\n  padding: 12px;\n}\n\n.relative-search-results {\n  display: grid;\n  gap: 8px;\n  grid-column: 1 / -1;\n}\n\n.relative-search-results button {\n  align-items: center;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  color: #17211c;\n  cursor: pointer;\n  display: flex;\n  justify-content: space-between;\n  padding: 10px;\n  text-align: left;\n}\n\n.relative-search-results span {\n  color: #4e5b53;\n}\n\n.relative-actions {\n  align-items: center;\n  background: #ffffff;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: flex;\n  gap: 12px;\n  justify-content: space-between;\n  padding: 10px;\n}\n\n.relative-actions span {\n  color: #4e5b53;\n  font-size: 13px;\n}\n\n.profile-help {\n  background: #f8f6f1;\n  border-left: 4px solid #d8a947;\n  border-radius: 8px;\n  margin: 0;\n  padding: 12px;\n}\n\n.app-error-page {\n  background: #f7f4ee;\n  min-height: 100vh;\n  padding: 40px;\n}\n\n.app-error-panel {\n  margin: 0 auto;\n  max-width: 760px;\n}\n\n.app-error-panel pre {\n  background: #17211c;\n  border-radius: 8px;\n  color: #fff;\n  overflow-x: auto;\n  padding: 14px;\n  white-space: pre-wrap;\n}\n\n.app-error-panel button {\n  background: #17211c;\n  border: 0;\n  border-radius: 8px;\n  color: #fff;\n  cursor: pointer;\n  padding: 12px 16px;\n}\n\n.tree-toolbar {\n  background: #ebe5d9;\n  border-radius: 8px;\n  display: inline-flex;\n  gap: 4px;\n  padding: 4px;\n}\n\n.family-tabs {\n  border-bottom: 1px solid #e2ded3;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  margin-bottom: 18px;\n  padding-bottom: 12px;\n}\n\n.family-tabs button {\n  background: transparent;\n  border: 1px solid transparent;\n  border-radius: 8px;\n  color: #4e5b53;\n  cursor: pointer;\n  font-weight: 800;\n  padding: 10px 14px;\n}\n\n.family-tabs button.active {\n  background: #17211c;\n  border-color: #17211c;\n  color: #ffffff;\n}\n\n.family-history-panel {\n  margin-top: 4px;\n}\n\n.tree-toolbar button {\n  align-items: center;\n  background: transparent;\n  border: 0;\n  border-radius: 6px;\n  color: #17211c;\n  cursor: pointer;\n  display: inline-flex;\n  gap: 8px;\n  padding: 10px 12px;\n}\n\n.tree-toolbar button.active {\n  background: #ffffff;\n}\n\n.family-tree-board {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: grid;\n  gap: 0;\n  margin-top: 18px;\n  overflow-x: auto;\n  padding: 18px;\n}\n\n.tree-level {\n  display: grid;\n  gap: 12px;\n  min-width: 640px;\n}\n\n.tree-level-label {\n  color: #4e5b53;\n  font-size: 13px;\n  font-weight: 700;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.tree-level-members {\n  display: flex;\n  gap: 14px;\n  justify-content: center;\n}\n\n.tree-connector {\n  background: #d8a947;\n  height: 28px;\n  justify-self: center;\n  margin: 8px 0;\n  width: 2px;\n}\n\n.tree-empty-node {\n  background: #ffffff;\n  border: 1px dashed #cfc8bc;\n  border-radius: 8px;\n  color: #4e5b53;\n  min-width: 220px;\n  padding: 18px;\n  text-align: center;\n}\n\n.tree-register-header {\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  margin-top: 24px;\n}\n\n.tree-register-header h2 {\n  margin: 0;\n}\n\n.tree-register-header p {\n  color: #4e5b53;\n  margin: 6px 0 0;\n}\n\n.tree-register-header span {\n  color: #4e5b53;\n}\n\n.whole-tree {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: flex;\n  gap: 18px;\n  margin-top: 14px;\n  overflow-x: auto;\n  padding: 18px;\n}\n\n.expanded-family-map {\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  margin-top: 14px;\n  max-height: 780px;\n  overflow: auto;\n  padding: 18px;\n}\n\n.relationship-graph {\n  min-height: 320px;\n  min-width: 860px;\n  position: relative;\n}\n\n.relationship-lines {\n  inset: 0;\n  pointer-events: none;\n  position: absolute;\n}\n\n.relationship-line {\n  stroke-linecap: round;\n  stroke-linejoin: round;\n  stroke-width: 2.5;\n}\n\n.parent-line {\n  stroke: #d8a947;\n}\n\n.spouse-line {\n  stroke: #805f1d;\n  stroke-dasharray: 7 7;\n}\n\n.relationship-node {\n  position: absolute;\n  z-index: 1;\n}\n\n.relationship-node .tree-member-card.compact {\n  height: 126px;\n  min-width: 238px;\n  width: 238px;\n}\n\n.generation-row {\n  display: grid;\n  gap: 14px;\n  min-width: 980px;\n}\n\n.generation-label {\n  align-items: baseline;\n  display: flex;\n  gap: 10px;\n}\n\n.generation-label strong {\n  color: #17211c;\n}\n\n.generation-label span {\n  color: #4e5b53;\n  font-size: 13px;\n}\n\n.generation-units {\n  align-items: flex-start;\n  display: flex;\n  gap: 18px;\n}\n\n.family-unit {\n  background: #ffffff;\n  border: 1px solid #ded8cc;\n  border-radius: 8px;\n  box-shadow: 0 10px 24px rgba(35, 32, 26, 0.06);\n  min-width: 560px;\n  padding: 14px;\n}\n\n.couple-row {\n  align-items: stretch;\n  display: flex;\n  gap: 16px;\n}\n\n.couple-partner {\n  align-items: center;\n  display: flex;\n  flex: 1;\n  gap: 12px;\n  min-width: 0;\n}\n\n.marriage-link {\n  background: #efe6d2;\n  border: 1px solid #d8a947;\n  border-radius: 999px;\n  color: #805f1d;\n  flex: 0 0 auto;\n  font-size: 12px;\n  font-weight: 800;\n  padding: 5px 8px;\n  text-transform: uppercase;\n}\n\n.sibling-strip {\n  border-top: 2px solid #d8a947;\n  margin-top: 16px;\n  padding-top: 14px;\n  position: relative;\n}\n\n.sibling-strip::before {\n  background: #d8a947;\n  content: \"\";\n  height: 14px;\n  left: 50%;\n  position: absolute;\n  top: 0;\n  transform: translate(-50%, -100%);\n  width: 2px;\n}\n\n.sibling-label,\n.unit-note {\n  color: #4e5b53;\n  display: block;\n  font-size: 12px;\n  font-weight: 800;\n  margin-bottom: 10px;\n  text-transform: uppercase;\n}\n\n.sibling-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 12px;\n}\n\n.child-bridge {\n  align-items: center;\n  background: #fbfaf7;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: flex;\n  gap: 10px;\n  padding: 10px;\n}\n\n.child-bridge .tree-member-card.compact {\n  min-width: 210px;\n  width: 230px;\n}\n\n.family-branch {\n  align-items: center;\n  display: inline-flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.family-branch-children {\n  border-top: 2px solid #d8a947;\n  display: flex;\n  gap: 14px;\n  padding-top: 18px;\n  position: relative;\n}\n\n.family-branch-children::before {\n  background: #d8a947;\n  content: \"\";\n  height: 18px;\n  left: 50%;\n  position: absolute;\n  top: 0;\n  transform: translate(-50%, -100%);\n  width: 2px;\n}\n\n.tree-grid {\n  display: grid;\n  gap: 12px;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  margin-top: 18px;\n}\n\n.tree-member-card {\n  align-items: flex-start;\n  background: #f8f6f1;\n  border: 1px solid #e2ded3;\n  border-radius: 8px;\n  display: flex;\n  gap: 12px;\n  padding: 14px;\n}\n\n.tree-member-card.self {\n  border-color: #d8a947;\n  box-shadow: 0 0 0 2px rgba(216, 169, 71, 0.18);\n}\n\n.tree-member-card.muted {\n  opacity: 0.72;\n}\n\n.tree-member-card.deceased {\n  background: #f3f0e8;\n  border-color: #c9bfae;\n}\n\n.tree-member-card.compact {\n  min-width: 220px;\n  width: 260px;\n}\n\n.tree-member-card h3,\n.tree-member-card p {\n  margin: 0;\n}\n\n.tree-member-card h3 {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n\n.memory-mark {\n  background: #e9e1d1;\n  border: 1px solid #c9bfae;\n  border-radius: 999px;\n  color: #615849;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0;\n  line-height: 1;\n  padding: 5px 7px;\n  text-transform: uppercase;\n}\n\n.tree-member-card p,\n.tree-member-card small {\n  color: #4e5b53;\n  display: block;\n  line-height: 1.4;\n  margin-top: 6px;\n}\n\n@media (max-width: 1120px) {\n  .app-shell {\n    grid-template-columns: 220px minmax(0, 1fr);\n  }\n\n  .main-panel {\n    padding: 28px;\n  }\n\n  .metric-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .wallet-spotlight {\n    grid-template-columns: 1fr;\n  }\n\n  .age-group-grid {\n    grid-template-columns: repeat(3, minmax(0, 1fr));\n  }\n\n  .form-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .mission-financials {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .lifecycle-strip,\n  .sankalp-detail-grid,\n  .kosh-filter-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .sankalp-team-row {\n    grid-template-columns: 1fr;\n  }\n\n  .tree-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .home-hero {\n    grid-template-columns: 1fr;\n  }\n\n  .customer-segment-grid,\n  .pricing-grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 820px) {\n  .app-shell {\n    grid-template-columns: 1fr;\n  }\n\n  .mobile-menu-button {\n    display: none;\n  }\n\n  .sidebar-backdrop {\n    background: rgba(23, 33, 28, 0.42);\n    border: 0;\n    bottom: 0;\n    display: block;\n    left: 0;\n    opacity: 0;\n    pointer-events: none;\n    position: fixed;\n    right: 0;\n    top: 0;\n    transition: opacity 0.18s ease;\n    z-index: 20;\n  }\n\n  .sidebar {\n    border-radius: 16px 16px 0 0;\n    bottom: calc(64px + env(safe-area-inset-bottom));\n    box-shadow: 0 -16px 40px rgba(23, 33, 28, 0.28);\n    left: 0;\n    max-height: min(76vh, 680px);\n    max-width: none;\n    overflow-y: auto;\n    padding: 22px 18px calc(18px + env(safe-area-inset-bottom));\n    position: fixed;\n    top: auto;\n    transform: translateY(110%);\n    transition: transform 0.22s ease;\n    width: 100%;\n    z-index: 30;\n  }\n\n  .sidebar-open .sidebar {\n    transform: translateY(0);\n  }\n\n  .sidebar-open .sidebar-backdrop {\n    opacity: 1;\n    pointer-events: auto;\n  }\n\n  .brand {\n    margin-bottom: 18px;\n  }\n\n  .nav-list {\n    gap: 12px;\n  }\n\n  .nav-section {\n    display: grid;\n  }\n\n  .nav-section-title {\n    display: block;\n    padding: 0 4px 8px;\n  }\n\n  .nav-section .nav-link {\n    display: flex;\n    margin: 0;\n    white-space: nowrap;\n  }\n\n  .nav-section .mobile-primary-duplicate {\n    display: none;\n  }\n\n  .session-panel,\n  .api-status {\n    margin-top: 14px;\n  }\n\n  .metric-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .main-panel {\n    min-height: 100dvh;\n    padding-bottom: calc(92px + env(safe-area-inset-bottom));\n  }\n\n  .mobile-bottom-nav {\n    align-items: stretch;\n    background: rgba(255, 255, 255, 0.98);\n    border-top: 1px solid #e2ddd2;\n    bottom: 0;\n    box-shadow: 0 -8px 24px rgba(23, 33, 28, 0.08);\n    display: grid;\n    grid-template-columns: repeat(5, minmax(0, 1fr));\n    left: 0;\n    padding: 6px max(4px, env(safe-area-inset-left)) calc(6px + env(safe-area-inset-bottom)) max(4px, env(safe-area-inset-right));\n    position: fixed;\n    right: 0;\n    z-index: 45;\n  }\n\n  .mobile-bottom-link {\n    align-items: center;\n    background: transparent;\n    border: 0;\n    border-radius: 6px;\n    color: #617067;\n    display: flex;\n    flex-direction: column;\n    font-family: inherit;\n    font-size: 11px;\n    font-weight: 700;\n    gap: 3px;\n    justify-content: center;\n    letter-spacing: 0;\n    min-height: 52px;\n    min-width: 0;\n    padding: 5px 2px;\n    text-decoration: none;\n  }\n\n  .mobile-bottom-link.active {\n    background: #f6efdf;\n    color: #17211c;\n  }\n\n  .mobile-bottom-link svg {\n    flex: 0 0 auto;\n  }\n\n  .mobile-more-button {\n    cursor: pointer;\n  }\n\n  .mobile-quick-start {\n    background: #17211c;\n    border: 1px solid rgba(218, 164, 66, 0.38);\n    border-radius: 8px;\n    color: #fff;\n    display: block;\n    margin-bottom: 18px;\n    padding: 18px;\n  }\n\n  .mobile-quick-start > div:first-child span {\n    color: #e7bd66;\n    display: block;\n    font-size: 13px;\n    font-weight: 800;\n    margin-bottom: 4px;\n  }\n\n  .mobile-quick-start h2 {\n    color: #fff;\n    font-size: 22px;\n    margin: 0 0 14px;\n  }\n\n  .mobile-quick-grid {\n    display: grid;\n    gap: 8px;\n  }\n\n  .mobile-quick-grid a {\n    align-items: center;\n    background: rgba(255, 255, 255, 0.09);\n    border: 1px solid rgba(255, 255, 255, 0.12);\n    border-radius: 6px;\n    color: #fff;\n    display: grid;\n    gap: 11px;\n    grid-template-columns: auto minmax(0, 1fr) auto;\n    min-height: 58px;\n    padding: 10px 12px;\n    text-decoration: none;\n  }\n\n  .mobile-quick-grid a > span {\n    min-width: 0;\n  }\n\n  .mobile-quick-grid strong,\n  .mobile-quick-grid small {\n    display: block;\n  }\n\n  .mobile-quick-grid strong {\n    font-size: 16px;\n  }\n\n  .mobile-quick-grid small {\n    color: #d5ddd8;\n    font-size: 12px;\n    margin-top: 2px;\n  }\n\n  .featured-sankalp-list .featured-sankalp-card:nth-child(n + 3) {\n    display: none;\n  }\n\n  .dashboard-grid,\n  .snapshot-grid,\n  .age-group-grid,\n  .vision-chart-band,\n  .history-event,\n  .home-snapshot-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .form-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .wide-field {\n    grid-column: span 1;\n  }\n\n  .mission-financials {\n    grid-template-columns: 1fr;\n  }\n\n  .lifecycle-strip,\n  .sankalp-detail-grid,\n  .kosh-filter-row {\n    grid-template-columns: 1fr;\n  }\n\n  .section-heading-row,\n  .compact-row {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .compact-row span {\n    text-align: left;\n  }\n\n  .member-row,\n  .invite-row,\n  .ledger-row {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .ledger-member {\n    text-align: left;\n  }\n\n  .row-actions {\n    flex-wrap: wrap;\n  }\n\n  .relative-card {\n    grid-template-columns: 1fr;\n  }\n\n  .relative-search {\n    align-items: stretch;\n    grid-template-columns: 1fr;\n  }\n\n  .relative-search-results button {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .tree-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .tree-toolbar {\n    display: flex;\n  }\n\n  .whole-tree {\n    align-items: flex-start;\n  }\n\n  .member-summary {\n    align-items: flex-start;\n  }\n\n  .project-card-header {\n    flex-direction: column;\n  }\n\n  .main-panel {\n    padding: 24px;\n  }\n\n  .home-nav,\n  .home-nav-actions,\n  .home-actions {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .home-hero,\n  .launch-message-section,\n  .today-step-grid,\n  .interactive-section,\n  .village-section,\n  .launch-grid,\n  .home-band,\n  .future-grid,\n  .family-gallery-grid,\n  .contribute-project-grid,\n  .customer-segment-grid,\n  .pricing-grid,\n  .proposal-grid,\n  .sabha-rule-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .market-position-card {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .amount-preset-row {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  .home-hero {\n    min-height: auto;\n  }\n\n  .launch-stage {\n    padding: 18px;\n  }\n\n  .launch-stage::before {\n    inset: 14px;\n  }\n\n  .launch-stage::after {\n    inset: 24px;\n  }\n\n  .launch-logo-ring {\n    height: 104px;\n    width: 104px;\n  }\n\n  .launch-logo-ring img {\n    height: 86px;\n    width: 86px;\n  }\n\n  .home-hero-copy h1 {\n    font-size: 42px;\n  }\n\n  .home-hero-logo {\n    height: 88px;\n    width: 88px;\n  }\n\n  .preview-metrics {\n    grid-template-columns: 1fr;\n  }\n\n  .today-action-panel {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .vision-chart-copy h2 {\n    font-size: 26px;\n  }\n\n  .vision-cloud {\n    justify-content: flex-start;\n    min-height: auto;\n  }\n\n  .vision-chip {\n    transform: none;\n  }\n}\n\n@media (max-width: 640px) {\n  :root {\n    font-size: 15px;\n  }\n\n  .sidebar {\n    border-bottom: 0;\n    max-height: calc(100dvh - 76px - env(safe-area-inset-bottom));\n    overflow-y: auto;\n  }\n\n  .brand-mark {\n    height: 36px;\n    width: 36px;\n  }\n\n  .main-panel {\n    padding: 18px 14px 82px;\n  }\n\n  .metric-grid {\n    display: flex;\n    gap: 10px;\n    margin-left: -14px;\n    margin-right: -14px;\n    overflow-x: auto;\n    padding: 0 14px 8px;\n    scroll-snap-type: x proximity;\n  }\n\n  .metric-grid .metric-card {\n    flex: 0 0 min(44vw, 180px);\n    scroll-snap-align: start;\n  }\n\n  .vision-chart-band,\n  .mobile-deferred-section {\n    display: none;\n  }\n\n  .page-header {\n    margin-bottom: 18px;\n  }\n\n  .page-header h1 {\n    font-size: 32px;\n  }\n\n  .page-header p {\n    font-size: 16px;\n  }\n\n  .content-band {\n    padding: 16px;\n  }\n\n  .transaction-security-callout {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .wallet-spotlight {\n    padding: 18px;\n  }\n\n  .wallet-spotlight strong {\n    font-size: 38px;\n  }\n\n  .feedback-dialog {\n    padding: 20px;\n  }\n\n  .feedback-dialog.celebration {\n    padding: 18px 16px 20px;\n  }\n\n  .feedback-dialog.celebration h2 {\n    font-size: 25px;\n  }\n\n  .feedback-celebration-stage {\n    margin-bottom: -5px;\n    margin-top: -12px;\n    transform: scale(0.88);\n  }\n\n  .feedback-amount {\n    font-size: 35px;\n  }\n\n  .feedback-actions {\n    flex-direction: column;\n  }\n\n  .vision-chart-band {\n    padding: 18px;\n  }\n\n  .vision-chart-band::after {\n    inset: 8px;\n  }\n\n  .vision-chart-copy h2 {\n    font-size: 24px;\n  }\n\n  .vision-chip {\n    font-size: 14px;\n    padding: 9px 11px;\n  }\n\n  .metric-card {\n    padding: 14px;\n  }\n\n  .metric-card strong {\n    font-size: 22px;\n  }\n\n  .age-group-card strong {\n    font-size: 24px;\n  }\n\n  .form-grid {\n    gap: 12px;\n  }\n\n  .form-grid button,\n  .secondary-button,\n  .button-row .secondary-button {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .button-row {\n    display: grid;\n  }\n\n  .copy-box,\n  .family-hero-overlay,\n  .preview-row,\n  .tree-register-header {\n    align-items: stretch;\n    flex-direction: column;\n  }\n\n  .copy-box button {\n    width: 100%;\n  }\n\n  .family-tabs,\n  .tree-toolbar {\n    display: flex;\n    gap: 8px;\n    margin-left: -16px;\n    margin-right: -16px;\n    overflow-x: auto;\n    padding: 0 16px 8px;\n  }\n\n  .family-tabs button,\n  .tree-toolbar button {\n    flex: 0 0 auto;\n  }\n\n  .expanded-family-map {\n    margin-left: -16px;\n    margin-right: -16px;\n    max-height: 68vh;\n    padding: 12px;\n  }\n\n  .relationship-graph {\n    transform-origin: top left;\n  }\n\n  .tree-member-card,\n  .member-row,\n  .ledger-row,\n  .featured-sankalp-card,\n  .project-card {\n    padding: 12px;\n  }\n\n  .featured-sankalp-card {\n    grid-template-columns: 1fr;\n  }\n\n  .tree-member-card.compact {\n    min-width: 210px;\n    width: 230px;\n  }\n\n  .project-summary {\n    display: grid;\n    grid-template-columns: 1fr;\n  }\n\n  .project-summary span {\n    border-radius: 8px;\n  }\n\n  .row-actions select,\n  .row-actions button,\n  .kosh-filter-row button {\n    width: 100%;\n  }\n\n  .home-nav {\n    padding: 16px 14px;\n  }\n\n  .home-nav-actions {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    width: 100%;\n  }\n\n  .home-nav-actions a {\n    align-items: center;\n    background: #f0eadc;\n    border-radius: 8px;\n    display: flex;\n    min-height: 40px;\n    padding: 8px 10px;\n  }\n\n  .home-primary-link {\n    justify-content: center;\n  }\n\n  .home-hero {\n    gap: 24px;\n    padding: 12px 14px 42px;\n  }\n\n  .home-hero-copy h1 {\n    font-size: 36px;\n    line-height: 1.05;\n  }\n\n  .home-hero-copy p {\n    font-size: 17px;\n  }\n\n  .home-actions {\n    align-items: stretch;\n    width: 100%;\n  }\n\n  .home-cta,\n  .home-secondary {\n    justify-content: center;\n    text-align: center;\n  }\n\n  .pricing-grid strong {\n    font-size: 26px;\n  }\n\n  .portal-preview,\n  .launch-message-copy,\n  .village-story {\n    padding: 14px;\n  }\n\n  .launch-sequence-line {\n    display: grid;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n    width: 100%;\n  }\n\n  .launch-sequence-line span {\n    padding: 9px;\n  }\n\n  .launch-reveal-card {\n    padding: 14px;\n  }\n}\n.trust-contribution-panel,\n.reconciliation-panel {\n  overflow: hidden;\n}\n\n.trust-badge {\n  padding: 8px 12px;\n  border: 1px solid #d9ae4c;\n  border-radius: 999px;\n  color: #6d5218;\n  background: #fff9e9;\n  font-weight: 700;\n  white-space: nowrap;\n}\n\n.direct-payment-layout {\n  display: grid;\n  grid-template-columns: minmax(300px, 0.85fr) minmax(360px, 1.15fr);\n  gap: 20px;\n  margin-top: 20px;\n}\n\n.bank-destination-card,\n.self-declaration-form {\n  border: 1px solid #ded8ca;\n  border-radius: 8px;\n  padding: 20px;\n  background: #faf8f3;\n}\n\n.bank-destination-card {\n  display: grid;\n  grid-template-columns: 240px 1fr;\n  gap: 24px;\n  align-items: start;\n}\n\n.bank-qr-image,\n.bank-qr-placeholder {\n  width: 240px;\n  aspect-ratio: 1;\n  border: 1px solid #d8d1c2;\n  border-radius: 6px;\n  background: #fff;\n  object-fit: contain;\n}\n\n.bank-qr-placeholder {\n  display: grid;\n  place-content: center;\n  gap: 4px;\n  text-align: center;\n  color: #6b706d;\n}\n\n.bank-qr-placeholder strong {\n  font-size: 32px;\n}\n\n.bank-destination-card h3,\n.self-declaration-form h3,\n.declaration-history h3,\n.reconciliation-declarations h3 {\n  margin: 4px 0 14px;\n  font-size: 20px;\n}\n\n.bank-destination-card dl {\n  display: grid;\n  gap: 8px;\n  margin: 0 0 16px;\n}\n\n.bank-destination-card dl div {\n  display: grid;\n  grid-template-columns: 72px 1fr;\n  gap: 8px;\n}\n\n.bank-destination-card dt {\n  color: #67706b;\n}\n\n.bank-destination-card dd {\n  margin: 0;\n  font-weight: 700;\n  overflow-wrap: anywhere;\n}\n\n.upi-amount-field {\n  display: grid;\n  gap: 7px;\n  margin: 14px 0;\n  font-weight: 700;\n}\n\n.upi-amount-suggestions {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 8px;\n}\n\n.upi-amount-suggestions button {\n  min-height: 42px;\n  padding: 8px;\n  border: 1px solid #d9cfc7;\n  background: #fffaf8;\n  color: #542f34;\n  font-weight: 700;\n}\n\n.upi-amount-suggestions button.selected {\n  border-color: #a84f61;\n  background: #f8e8ec;\n  color: #7f2e40;\n  box-shadow: 0 0 0 2px rgb(168 79 97 / 12%);\n}\n\n.upi-direct-note {\n  display: block;\n  margin-top: 10px;\n  color: #69716d;\n  line-height: 1.45;\n}\n\n.contribution-guidance-card ol {\n  display: grid;\n  gap: 10px;\n  margin: 14px 0;\n  padding-left: 22px;\n  color: #50484a;\n  line-height: 1.5;\n}\n\n.upi-amount-field small {\n  color: #69716d;\n  font-size: 13px;\n  font-weight: 400;\n}\n\n.transferred-amount-summary {\n  display: grid;\n  grid-column: 1 / -1;\n  gap: 5px;\n  padding: 13px 14px;\n  border: 1px solid #d8c48d;\n  border-radius: 6px;\n  background: #fffaf0;\n}\n\n.transferred-amount-summary span {\n  color: #69716d;\n  font-size: 13px;\n}\n\n.transferred-amount-summary strong {\n  font-size: 20px;\n}\n\n.primary-link-button {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 42px;\n  padding: 10px 16px;\n  border-radius: 6px;\n  background: #17251f;\n  color: #fff;\n  text-decoration: none;\n}\n\n.self-declaration-form,\n.reconciliation-form {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: 14px;\n}\n\n.self-declaration-form h3,\n.self-declaration-form .attestation-check,\n.self-declaration-form > button,\n.self-declaration-form > small {\n  grid-column: 1 / -1;\n}\n\n.self-declaration-form label,\n.reconciliation-form label {\n  display: grid;\n  gap: 7px;\n}\n\n.self-declaration-form label > span {\n  color: #69716d;\n  font-size: 13px;\n}\n\n.attestation-check {\n  grid-template-columns: 22px 1fr !important;\n  align-items: start;\n  padding: 12px;\n  border: 1px solid #d8c48d;\n  border-radius: 6px;\n  background: #fffaf0;\n}\n\n.attestation-check input {\n  width: 18px;\n  height: 18px;\n  margin-top: 2px;\n}\n\n.declaration-history,\n.reconciliation-declarations {\n  margin-top: 24px;\n}\n\n.declaration-history article,\n.reconciliation-declarations article {\n  display: grid;\n  grid-template-columns: minmax(180px, 1.4fr) minmax(160px, 1fr);\n  gap: 10px 18px;\n  padding: 13px 0;\n  border-top: 1px solid #e5dfd3;\n}\n\n.declaration-history article > div,\n.reconciliation-declarations article > div {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.declaration-history em,\n.reconciliation-declarations em {\n  justify-self: end;\n  padding: 4px 8px;\n  border-radius: 999px;\n  background: #eee9df;\n  color: #5d625f;\n  font-size: 12px;\n  font-style: normal;\n  text-transform: capitalize;\n}\n\n.declaration-history em.reconciled,\n.reconciliation-declarations em.reconciled {\n  color: #1f6b45;\n  background: #e4f4e9;\n}\n\n.declaration-history em.flagged,\n.reconciliation-declarations em.flagged {\n  color: #8b3f31;\n  background: #fae8e3;\n}\n\n.reconciliation-metrics {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px;\n  margin: 20px 0;\n}\n\n.reconciliation-metrics > div {\n  display: grid;\n  gap: 6px;\n  padding: 16px;\n  border: 1px solid #ded8ca;\n  border-radius: 7px;\n  background: #faf8f3;\n}\n\n.reconciliation-metrics strong {\n  font-size: 24px;\n}\n\n.reconciliation-metrics .matched {\n  border-color: #8dbb9c;\n  background: #edf8f0;\n}\n\n.reconciliation-metrics .mismatch {\n  border-color: #d7a48e;\n  background: #fff3ee;\n}\n\n.reconciliation-form {\n  grid-template-columns: repeat(3, minmax(0, 1fr)) auto;\n  align-items: end;\n  padding: 16px;\n  border: 1px solid #ded8ca;\n  border-radius: 7px;\n}\n\n.reconciliation-declarations article {\n  grid-template-columns: minmax(180px, 1.2fr) 120px minmax(130px, 1fr) 110px auto;\n  align-items: center;\n}\n\n.reconciliation-alert {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin: 0 0 18px;\n  padding: 14px 16px;\n  border: 1px solid #b7d5c0;\n  border-radius: 7px;\n  background: #edf8f0;\n  color: #1f5e3d;\n}\n\n.reconciliation-alert.warning { border-color: #ddb276; background: #fff6e5; color: #755017; }\n.reconciliation-alert.error { border-color: #ddb0a6; background: #fff0ed; color: #8b3429; }\n.reconciliation-alert button { flex: 0 0 auto; padding: 7px 11px; }\n.icon-text-button { display: inline-flex; align-items: center; gap: 7px; }\n.declaration-review-list { display: grid; gap: 14px; }\n\n.declaration-review-card {\n  padding: 18px;\n  border: 1px solid #ddd6c8;\n  border-radius: 7px;\n  background: #fcfbf8;\n}\n\n.declaration-review-summary {\n  display: grid;\n  grid-template-columns: repeat(5, minmax(120px, 1fr)) auto;\n  gap: 14px;\n  align-items: start;\n  padding-bottom: 16px;\n  border-bottom: 1px solid #e5dfd3;\n}\n\n.declaration-review-summary > div,\n.correction-preview { display: grid; gap: 5px; }\n.declaration-review-summary span,\n.correction-preview span { color: #66706b; font-size: 13px; }\n.declaration-review-summary strong { overflow-wrap: anywhere; font-size: 15px; }\n.declaration-review-summary em { padding: 5px 9px; border-radius: 999px; background: #eee9df; color: #5d625f; font-size: 12px; font-style: normal; text-transform: capitalize; }\n.declaration-review-summary em.reconciled { background: #e4f4e9; color: #1f6b45; }\n\n.declaration-review-fields {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(160px, 1fr)) minmax(140px, 0.7fr) auto;\n  gap: 12px;\n  align-items: end;\n  padding-top: 16px;\n}\n\n.declaration-review-fields label { display: grid; gap: 7px; }\n.correction-preview { min-height: 44px; padding: 10px 12px; border: 1px solid #b7d5c0; border-radius: 6px; background: #edf8f0; }\n.correction-preview.debit { border-color: #ddb0a6; background: #fff0ed; color: #8b3429; }\n.correction-preview.credit { color: #1f6b45; }\n\n.member-kosh-credit-panel { margin-top: 18px; }\n.member-kosh-credit-form {\n  display: grid;\n  grid-template-columns: minmax(220px, 1.35fr) minmax(180px, 0.75fr) minmax(210px, 1fr);\n  gap: 14px;\n  align-items: end;\n  margin-top: 18px;\n}\n.member-kosh-credit-form label,\n.member-credit-search { display: grid; gap: 7px; }\n.member-credit-search { position: relative; }\n.member-credit-search label { display: flex; align-items: center; gap: 7px; }\n.member-credit-results {\n  position: absolute;\n  z-index: 8;\n  top: calc(100% + 6px);\n  right: 0;\n  left: 0;\n  display: grid;\n  padding: 6px;\n  border: 1px solid var(--nyas-line, #ded8ca);\n  border-radius: 7px;\n  background: #fff;\n  box-shadow: 0 16px 36px rgba(52, 41, 45, 0.14);\n}\n.member-credit-results button {\n  display: grid;\n  gap: 2px;\n  padding: 11px 12px;\n  border: 0;\n  border-radius: 6px;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n}\n.member-credit-results button:hover,\n.member-credit-results button:focus-visible { background: var(--nyas-surface-soft, #faf8f3); }\n.member-credit-results span { color: var(--nyas-muted, #66706b); font-size: 13px; }\n.member-credit-note { grid-column: 1 / 3; }\n.member-kosh-credit-form > button { display: inline-flex; align-items: center; justify-content: center; gap: 7px; }\n.member-credit-dialog-backdrop {\n  position: fixed;\n  z-index: 120;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  padding: 20px;\n  background: rgba(39, 29, 33, 0.52);\n  backdrop-filter: blur(5px);\n}\n.member-credit-dialog {\n  width: min(100%, 520px);\n  padding: 28px;\n  border: 1px solid var(--nyas-line, #ded8ca);\n  border-radius: 8px;\n  background: #fff;\n  box-shadow: 0 30px 80px rgba(40, 28, 33, 0.25);\n  text-align: center;\n}\n.member-credit-dialog h2 { margin: 7px 0 14px; }\n.member-credit-review-amount { display: block; margin: 12px 0; color: var(--nyas-forest, #183b2d); font-size: clamp(36px, 8vw, 54px); line-height: 1.1; }\n.member-credit-dialog p { color: var(--nyas-muted, #66706b); }\n.member-credit-reference { display: grid; gap: 4px; margin: 18px 0; padding: 12px; border-radius: 7px; background: var(--nyas-surface-soft, #faf8f3); }\n.member-credit-reference span { color: var(--nyas-muted, #66706b); font-size: 13px; }\n.member-credit-dialog-actions { display: grid; grid-template-columns: 1fr 1.35fr; gap: 10px; margin-top: 22px; }\n\n@media (max-width: 760px) {\n  .direct-payment-layout,\n  .reconciliation-metrics,\n  .self-declaration-form,\n  .reconciliation-form {\n    grid-template-columns: 1fr;\n  }\n\n  .bank-destination-card {\n    grid-template-columns: 1fr;\n    padding: 14px;\n  }\n\n  .bank-qr-image,\n  .bank-qr-placeholder {\n    width: min(100%, 340px);\n    justify-self: center;\n  }\n\n  .bank-destination-card dl div {\n    grid-template-columns: 1fr;\n    gap: 2px;\n  }\n\n  .self-declaration-form h3,\n  .transferred-amount-summary,\n  .self-declaration-form .attestation-check,\n  .self-declaration-form > button,\n  .self-declaration-form > small {\n    grid-column: auto;\n  }\n\n  .reconciliation-declarations article,\n  .declaration-history article {\n    grid-template-columns: 1fr;\n  }\n\n  .declaration-review-summary,\n  .declaration-review-fields { grid-template-columns: 1fr; }\n  .member-kosh-credit-form,\n  .member-credit-dialog-actions { grid-template-columns: 1fr; }\n  .member-credit-note { grid-column: auto; }\n  .declaration-review-card { padding: 14px; }\n  .reconciliation-alert { align-items: flex-start; flex-direction: column; }\n\n  .declaration-history em,\n  .reconciliation-declarations em {\n    justify-self: start;\n  }\n\n  .trust-badge {\n    white-space: normal;\n  }\n}\n\n/* Premium family theme */\n:root {\n  --nyas-ink: #34292d;\n  --nyas-muted: #77676d;\n  --nyas-canvas: #fff9f7;\n  --nyas-surface: #ffffff;\n  --nyas-surface-soft: #fcf5f6;\n  --nyas-line: #eadde1;\n  --nyas-sage: #fbedef;\n  --nyas-sage-strong: #f4dce1;\n  --nyas-leaf: #c98591;\n  --nyas-forest: #8e4352;\n  --nyas-gold: #c99668;\n  --nyas-sun: #fff2ea;\n  --nyas-sky: #f5edf1;\n  --nyas-blush: #f9e5e8;\n  --nyas-petal: #f4e9ed;\n  --nyas-shadow: 0 12px 34px rgba(92, 54, 66, 0.075);\n  --nyas-shadow-raised: 0 18px 46px rgba(92, 54, 66, 0.13);\n  color: var(--nyas-ink);\n  background: var(--nyas-canvas);\n}\n\nhtml {\n  background: var(--nyas-canvas);\n  scroll-behavior: smooth;\n}\n\nbody {\n  background:\n    linear-gradient(180deg, rgba(251, 237, 239, 0.62) 0, rgba(255, 249, 247, 0) 260px),\n    var(--nyas-canvas);\n  color: var(--nyas-ink);\n}\n\nbutton,\na,\ninput,\nselect,\ntextarea {\n  -webkit-tap-highlight-color: transparent;\n}\n\nbutton,\na {\n  transition: background-color 180ms ease, border-color 180ms ease, color 180ms ease, box-shadow 180ms ease, transform 180ms ease;\n}\n\nbutton:focus-visible,\na:focus-visible,\ninput:focus-visible,\nselect:focus-visible,\ntextarea:focus-visible {\n  outline: 3px solid rgba(201, 133, 145, 0.28);\n  outline-offset: 2px;\n}\n\n.sidebar {\n  background: rgba(255, 255, 255, 0.96);\n  border-right: 1px solid var(--nyas-line);\n  box-shadow: 10px 0 34px rgba(92, 54, 66, 0.055);\n  color: var(--nyas-ink);\n}\n\n.brand {\n  border-bottom: 1px solid var(--nyas-line);\n  padding: 0 8px 22px;\n}\n\n.brand strong {\n  color: var(--nyas-forest);\n  font-size: 19px;\n}\n\n.sidebar .brand small {\n  color: var(--nyas-muted);\n}\n\n.brand-mark {\n  background: var(--nyas-sun);\n  border: 1px solid #ead5c5;\n  box-shadow: 0 8px 20px rgba(201, 150, 104, 0.16);\n  overflow: hidden;\n}\n\n.brand-mark img {\n  height: 100%;\n  object-fit: cover;\n  width: 100%;\n}\n\n.nav-list {\n  gap: 22px;\n}\n\n.nav-section-title {\n  color: #849089;\n}\n\n.nav-link {\n  color: #4f5d56;\n  min-height: 44px;\n}\n\n.nav-icon {\n  align-items: center;\n  background: var(--nyas-surface-soft);\n  border: 1px solid transparent;\n  border-radius: 8px;\n  display: inline-flex;\n  height: 30px;\n  justify-content: center;\n  width: 30px;\n}\n\n.nav-link:hover {\n  background: #fdf4f6;\n  color: var(--nyas-forest);\n  transform: translateX(2px);\n}\n\n.nav-link.active {\n  background: var(--nyas-sage);\n  color: var(--nyas-forest);\n  font-weight: 750;\n}\n\n.nav-link.active .nav-icon {\n  background: rgba(255, 255, 255, 0.82);\n  border-color: #edd8dd;\n  color: var(--nyas-leaf);\n  box-shadow: 0 5px 14px rgba(142, 67, 82, 0.1);\n}\n\n.nav-link-planned,\n.nav-link-planned:hover {\n  color: #87918b;\n}\n\n.nav-link small {\n  background: var(--nyas-sun);\n  color: #805d1c;\n}\n\n.session-panel,\n.api-status {\n  background: var(--nyas-surface-soft);\n  border-color: var(--nyas-line);\n  color: var(--nyas-ink);\n}\n\n.session-panel span,\n.session-panel a,\n.session-panel button {\n  color: var(--nyas-ink);\n}\n\n.session-panel strong {\n  color: var(--nyas-gold);\n}\n\n.session-panel small,\n.api-status small {\n  color: var(--nyas-muted);\n}\n\n.api-status.connected span {\n  color: #3d7b59;\n}\n\n.main-panel {\n  animation: nyasPageIn 420ms cubic-bezier(.2, .8, .2, 1) both;\n  background: transparent;\n}\n\n.page-header span {\n  color: var(--nyas-leaf);\n  font-weight: 750;\n}\n\n.page-header h1 {\n  color: var(--nyas-ink);\n}\n\n.page-header p,\n.content-band p,\n.project-card-header p,\n.metric-card span {\n  color: var(--nyas-muted);\n}\n\n.metric-card,\n.content-band,\n.login-panel,\n.project-card,\n.featured-sankalp-card,\n.age-group-card,\n.bank-destination-card,\n.self-declaration-form,\n.declaration-review-card {\n  background: rgba(255, 255, 255, 0.96);\n  border-color: var(--nyas-line);\n  box-shadow: var(--nyas-shadow);\n}\n\n.metric-card {\n  overflow: hidden;\n  position: relative;\n  transition: transform 200ms ease, box-shadow 200ms ease;\n}\n\n.metric-card::before {\n  background: var(--nyas-sage-strong);\n  content: \"\";\n  height: 4px;\n  inset: 0 0 auto;\n  position: absolute;\n}\n\n.metric-card:nth-child(2)::before { background: #f0dce2; }\n.metric-card:nth-child(3)::before { background: #ead0d7; }\n.metric-card:nth-child(4)::before { background: #eed9c8; }\n.metric-card:nth-child(5)::before { background: #e7d8df; }\n\n.metric-card:hover,\n.content-band:hover {\n  box-shadow: var(--nyas-shadow-raised);\n  transform: translateY(-2px);\n}\n\n.metric-card strong {\n  color: var(--nyas-forest);\n}\n\n.content-band {\n  transition: box-shadow 220ms ease, transform 220ms ease;\n}\n\n.mobile-quick-start,\n.vision-chart-band,\n.wallet-spotlight {\n  background: var(--nyas-sage);\n  border: 1px solid #edd8dd;\n  color: var(--nyas-ink);\n}\n\n.mobile-quick-start > div:first-child span,\n.vision-chart-copy span,\n.wallet-spotlight span {\n  color: var(--nyas-gold);\n}\n\n.mobile-quick-start h2,\n.vision-chart-copy h2,\n.wallet-spotlight strong,\n.wallet-spotlight-metrics span {\n  color: var(--nyas-forest);\n}\n\n.mobile-quick-grid a,\n.wallet-spotlight-metrics {\n  background: rgba(255, 255, 255, 0.78);\n  border-color: rgba(142, 67, 82, 0.14);\n  color: var(--nyas-ink);\n}\n\n.mobile-quick-grid small,\n.vision-chart-copy p,\n.wallet-spotlight p {\n  color: var(--nyas-muted);\n}\n\n.vision-chart-band::after {\n  border-color: rgba(142, 67, 82, 0.16);\n}\n\n.vision-chip {\n  background: rgba(255, 255, 255, 0.82);\n  border-color: rgba(142, 67, 82, 0.18);\n  color: var(--nyas-forest);\n  box-shadow: 0 6px 16px rgba(92, 54, 66, 0.07);\n  animation: nyasFloat 7s ease-in-out infinite;\n}\n\n.vision-chip:nth-child(3n + 2) {\n  animation-delay: -2.1s;\n  background: var(--nyas-sun);\n}\n\n.vision-chip:nth-child(3n) {\n  animation-delay: -4.2s;\n  background: var(--nyas-sky);\n}\n\n.featured-sankalp-card,\n.project-card {\n  transition: border-color 180ms ease, box-shadow 180ms ease, transform 180ms ease;\n}\n\n.featured-sankalp-card:hover,\n.project-card:hover {\n  border-color: #e1c5cc;\n  box-shadow: var(--nyas-shadow-raised);\n  transform: translateY(-2px);\n}\n\n.sankalp-number,\n.lifecycle-strip strong {\n  background: var(--nyas-sun);\n  color: #73531a;\n}\n\n.project-summary span,\n.compact-row,\n.lifecycle-strip div,\n.next-step-card {\n  background: var(--nyas-surface-soft);\n  border-color: var(--nyas-line);\n}\n\n.project-card-header > span,\n.status-pill {\n  background: var(--nyas-sage);\n  border: 1px solid #ead0d6;\n  color: var(--nyas-forest);\n}\n\n.progress-track {\n  background: #f3e9ec;\n}\n\n.progress-track div {\n  background: var(--nyas-leaf);\n  border-radius: inherit;\n  transition: width 700ms cubic-bezier(.2, .8, .2, 1);\n}\n\n.primary-link-button,\n.kosh-filter-row button,\nbutton[type=\"submit\"] {\n  background: var(--nyas-forest);\n  color: white;\n}\n\n.primary-link-button:hover,\n.kosh-filter-row button:hover,\nbutton[type=\"submit\"]:hover {\n  background: #7b3947;\n  box-shadow: 0 10px 24px rgba(142, 67, 82, 0.2);\n  transform: translateY(-1px);\n}\n\n.bank-qr-image {\n  border-color: #ead0d6;\n  box-shadow: 0 10px 24px rgba(92, 54, 66, 0.09);\n}\n\n.trust-badge,\n.attestation-check,\n.next-step-card {\n  background: var(--nyas-sun);\n  border-color: #ead2c2;\n  color: #76513d;\n}\n\n.feedback-overlay {\n  background: rgba(76, 48, 57, 0.22);\n  backdrop-filter: blur(8px);\n}\n\n.feedback-dialog {\n  border-color: var(--nyas-line);\n  box-shadow: 0 28px 80px rgba(92, 54, 66, 0.19);\n}\n\n.mobile-bottom-nav {\n  background: rgba(255, 255, 255, 0.94) !important;\n  border-color: var(--nyas-line) !important;\n  backdrop-filter: blur(18px);\n}\n\n.mobile-bottom-link.active {\n  background: var(--nyas-sage) !important;\n  color: var(--nyas-forest) !important;\n}\n\n/* The ceremonial welcome stays luminous so it belongs to the light family theme. */\n.launch-stage {\n  background:\n    radial-gradient(circle at 50% 38%, rgba(201, 150, 104, 0.24), transparent 25%),\n    linear-gradient(145deg, var(--nyas-canvas), var(--nyas-sun) 50%, var(--nyas-sage));\n  color: var(--nyas-ink);\n}\n\n.launch-stage::before,\n.launch-stage::after {\n  border-color: rgba(201, 150, 104, 0.36);\n}\n\n.launch-stage h1 {\n  color: var(--nyas-forest);\n  text-shadow: 0 8px 24px rgba(142, 67, 82, 0.1);\n}\n\n.launch-subtitle,\n.launch-bell-button,\n.launch-sequence-line span,\n.launch-skip-button {\n  color: var(--nyas-ink);\n}\n\n.launch-logo-ring {\n  background: white;\n  border-color: var(--nyas-gold);\n  box-shadow: 0 0 0 12px rgba(201, 150, 104, 0.14), var(--nyas-shadow-raised);\n}\n\n.launch-om-burst,\n.launch-blessing-2,\n.launch-blessing-3 {\n  color: rgba(142, 67, 82, 0.32);\n  text-shadow: 0 0 30px rgba(201, 150, 104, 0.38);\n}\n\n.launch-sequence-line span,\n.launch-skip-button {\n  background: rgba(255, 255, 255, 0.66);\n  border: 1px solid rgba(201, 150, 104, 0.28);\n  box-shadow: 0 6px 18px rgba(92, 54, 66, 0.07);\n}\n\n.launch-reveal-card {\n  background: rgba(255, 255, 255, 0.9);\n  border-color: rgba(201, 150, 104, 0.36);\n  box-shadow: var(--nyas-shadow-raised);\n}\n\n.launch-controls button {\n  background: var(--nyas-gold);\n  color: #432f35;\n  box-shadow: 0 12px 30px rgba(201, 150, 104, 0.24);\n}\n\n.login-page {\n  background:\n    radial-gradient(circle at 18% 18%, rgba(201, 150, 104, 0.2), transparent 30%),\n    radial-gradient(circle at 82% 78%, rgba(245, 237, 241, 0.82), transparent 34%),\n    linear-gradient(145deg, var(--nyas-canvas), var(--nyas-sage));\n}\n\n.login-panel {\n  background: rgba(255, 255, 255, 0.9);\n  border: 1px solid var(--nyas-line);\n  border-radius: 8px;\n  box-shadow: 0 28px 80px rgba(92, 54, 66, 0.16);\n  overflow: hidden;\n  position: relative;\n}\n\n.login-panel::before {\n  background: linear-gradient(90deg, var(--nyas-forest), var(--nyas-leaf), var(--nyas-gold));\n  content: \"\";\n  height: 4px;\n  inset: 0 0 auto;\n  position: absolute;\n}\n\n.login-panel .brand-mark {\n  background: var(--nyas-sun);\n  border: 1px solid #ecd9a7;\n  box-shadow: 0 8px 20px rgba(201, 150, 104, 0.14);\n  color: var(--nyas-forest);\n}\n\n@keyframes nyasPageIn {\n  from { opacity: 0; transform: translateY(8px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n@keyframes nyasFloat {\n  0%, 100% { transform: translateY(0); }\n  50% { transform: translateY(-4px); }\n}\n\n@media (max-width: 900px) {\n  .sidebar {\n    box-shadow: 16px 0 42px rgba(92, 54, 66, 0.13);\n  }\n\n  .mobile-menu-button {\n    background: rgba(255, 255, 255, 0.96);\n    border: 1px solid var(--nyas-line);\n    box-shadow: 0 8px 22px rgba(92, 54, 66, 0.11);\n    color: var(--nyas-forest);\n  }\n}\n\n@media (max-width: 640px) {\n  body {\n    background: var(--nyas-canvas);\n  }\n\n  .metric-card:hover,\n  .content-band:hover,\n  .featured-sankalp-card:hover,\n  .project-card:hover {\n    transform: none;\n  }\n\n  .mobile-quick-start {\n    box-shadow: var(--nyas-shadow);\n  }\n\n  .mobile-quick-grid a:active,\n  .mobile-bottom-link:active {\n    transform: scale(0.97);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  html { scroll-behavior: auto; }\n  *, *::before, *::after {\n    animation-duration: 0.01ms !important;\n    animation-iteration-count: 1 !important;\n    scroll-behavior: auto !important;\n    transition-duration: 0.01ms !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
